/* CycloOutlet — MASTER JS. Único script custom activo consolidado. */

/* ===== Logica base activa ===== */
(() => {
  const result = document.querySelector("[data-apex-result]");
  const filters = [...document.querySelectorAll("[data-apex-filter]")];
  const cards = [...document.querySelectorAll("[data-apex-product]")];

  function recommendationText(values) {
    if (values.series === "dura" || values.use === "premium") return "Recomendacion: Dura-Ace para maxima ligereza, precision y estatus profesional.";
    if (values.series === "ultegra" || values.use === "race") return "Recomendacion: Ultegra para rendimiento alto con compra mas racional que Dura-Ace.";
    if (values.series === "105" || values.use === "climb") return "Recomendacion: Shimano 105 para equilibrio precio/rendimiento y escalada comoda.";
    if (values.type === "di2") return "Recomendacion: prioriza Di2 si buscas precision, menor ajuste y experiencia premium.";
    return "Recomendacion: usa los filtros para ordenar opciones. CycloOutlet valida compatibilidad antes del despacho.";
  }

  function applyComparison() {
    if (!filters.length || !cards.length) return;
    const values = Object.fromEntries(filters.map(filter => [filter.dataset.apexFilter, filter.value]));
    cards.forEach(card => {
      const seriesOk = values.series === "all" || card.dataset.series === values.series;
      const typeOk = values.type === "all" || card.dataset.type === values.type;
      card.hidden = !(seriesOk && typeOk);
    });
    if (result) result.textContent = recommendationText(values);
  }

  filters.forEach(filter => filter.addEventListener("change", applyComparison));
  applyComparison();

  const escapeHtml = value => String(value ?? "").replace(/[&<>"']/g, char => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
  }[char]));

  const fixMojibake = (root = document.body) => {
    if (!root) return;
    const replacements = [
      [/\u00c3\u00a1/g, "\u00e1"], [/\u00c3\u00a9/g, "\u00e9"], [/\u00c3\u00ad/g, "\u00ed"], [/\u00c3\u00b3/g, "\u00f3"], [/\u00c3\u00ba/g, "\u00fa"],
      [/\u00c3\u0081/g, "\u00c1"], [/\u00c3\u0089/g, "\u00c9"], [/\u00c3\u008d/g, "\u00cd"], [/\u00c3\u0093/g, "\u00d3"], [/\u00c3\u009a/g, "\u00da"],
      [/\u00c3\u00b1/g, "\u00f1"], [/\u00c3\u0091/g, "\u00d1"], [/\u00c2\u00bf/g, "\u00bf"], [/\u00c2\u00a1/g, "\u00a1"], [/\u00c2\u00b7/g, "\u00b7"],
      [/\u00e2\u02dc\u2026/g, "\u2605"], [/\u00e2\u02c6\u2019/g, "-"], [/\u00e2\u20ac\u0153/g, "\u201c"], [/\u00e2\u20ac\u009d/g, "\u201d"]
    ];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|OPTION)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return /[\u00c2\u00c3\u00e2]/.test(node.nodeValue || "") ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      let next = node.nodeValue;
      replacements.forEach(([pattern, replacement]) => { next = next.replace(pattern, replacement); });
      node.nodeValue = next;
    });
  };

  const formatMoney = cents => new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0
  }).format((Number(cents || 0)) / 100);

  const requestJson = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: "same-origin",
      headers: { "Accept": "application/json", ...(options.headers || {}) },
      ...options
    });
    if (!response.ok) throw new Error(`Request failed: ${url}`);
    return response.json();
  };

  let drawerBuilt = false;
  let drawerState = null;

  const buildDrawer = () => {
    if (drawerBuilt) return;
    drawerBuilt = true;
    const overlay = document.createElement("div");
    overlay.className = "co-cart-drawer-overlay";
    overlay.setAttribute("data-cart-drawer-overlay", "");
    overlay.hidden = true;
    overlay.innerHTML = `
      <aside class="co-cart-drawer" role="dialog" aria-modal="true" aria-label="Carrito" tabindex="-1">
        <header>
          <div><small>CycloOutlet</small><strong>Tu carrito</strong></div>
          <button type="button" data-cart-drawer-close aria-label="Cerrar carrito">&times;</button>
        </header>
        <div class="co-cart-drawer-items" data-cart-drawer-items></div>
        <footer class="co-cart-drawer-footer" data-cart-drawer-footer></footer>
      </aside>
    `;
    document.body.appendChild(overlay);
  };

  const drawerOverlay = () => document.querySelector("[data-cart-drawer-overlay]");
  const drawerPanel = () => drawerOverlay()?.querySelector(".co-cart-drawer");

  const setDrawerOpen = open => {
    buildDrawer();
    const overlay = drawerOverlay();
    if (!overlay) return;
    overlay.hidden = false;
    document.documentElement.classList.toggle("co-cart-drawer-open", open);
    overlay.classList.toggle("is-open", open);
    overlay.setAttribute("aria-hidden", open ? "false" : "true");
    if (!open) {
      window.setTimeout(() => {
        if (!overlay.classList.contains("is-open")) overlay.hidden = true;
      }, 180);
    } else {
      drawerPanel()?.focus({ preventScroll: true });
    }
  };

  const updateHeaderCount = count => {
    document.querySelectorAll(".apex-cart-link").forEach(link => {
      let badge = link.querySelector("span");
      if (count > 0) {
        if (!badge) {
          badge = document.createElement("span");
          link.appendChild(badge);
        }
        badge.textContent = String(count);
      } else {
        badge?.remove();
      }
    });
  };

  const renderCart = cart => {
    buildDrawer();
    drawerState = cart;
    updateHeaderCount(cart.item_count || 0);
    const itemsMount = document.querySelector("[data-cart-drawer-items]");
    const footer = document.querySelector("[data-cart-drawer-footer]");
    if (!itemsMount || !footer) return;

    if (!cart.items?.length) {
      itemsMount.innerHTML = `
        <div class="co-cart-drawer-empty">
          <strong>Tu carrito esta vacio</strong>
          <span>Agrega productos para revisar tu compra aqui.</span>
          <a href="/collections/all">Ver productos</a>
        </div>
      `;
      footer.innerHTML = "";
      return;
    }

    itemsMount.innerHTML = cart.items.map(item => {
      const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : "";
      const variant = item.variant_title && item.variant_title !== "Default Title" ? `<small>${escapeHtml(item.variant_title)}</small>` : "";
      return `
        <article class="co-cart-drawer-line" data-cart-line-key="${escapeHtml(item.key)}">
          <a class="co-cart-drawer-line-media" href="${escapeHtml(item.url)}">${image}</a>
          <div class="co-cart-drawer-line-copy">
            <a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a>
            ${variant}
            <span>${formatMoney(item.final_price)} unidad</span>
            <div class="co-cart-drawer-qty" aria-label="Cantidad">
              <button type="button" data-cart-delta="-1" data-current-quantity="${item.quantity}" data-cart-line-key="${escapeHtml(item.key)}" aria-label="Disminuir cantidad">-</button>
              <b>${item.quantity}</b>
              <button type="button" data-cart-delta="1" data-current-quantity="${item.quantity}" data-cart-line-key="${escapeHtml(item.key)}" aria-label="Aumentar cantidad">+</button>
            </div>
          </div>
          <div class="co-cart-drawer-line-total">
            <strong>${formatMoney(item.final_line_price)}</strong>
            <button type="button" data-cart-remove data-cart-line-key="${escapeHtml(item.key)}">Quitar</button>
          </div>
        </article>
      `;
    }).join("");

    footer.innerHTML = `
      <div class="co-cart-drawer-total"><span>Total</span><strong>${formatMoney(cart.total_price)}</strong></div>
      <p>Validamos referencia y alistamiento antes del despacho.</p>
      <a class="apex-button primary" href="/checkout">Ir a pagar</a>
      <a class="apex-button secondary" href="/cart">Ver carrito completo</a>
    `;
  };

  const refreshCart = async ({ open = false } = {}) => {
    const cart = await requestJson("/cart.js");
    renderCart(cart);
    if (open) setDrawerOpen(true);
    return cart;
  };

  const setButtonLoading = (button, loading) => {
    if (!button) return;
    if (loading) {
      button.dataset.cartOriginalText = button.textContent.trim();
      button.disabled = true;
      button.classList.add("is-cart-loading");
      button.textContent = "Agregando";
    } else {
      button.disabled = false;
      button.classList.remove("is-cart-loading");
      button.textContent = button.dataset.cartOriginalText || button.textContent;
    }
  };

  const variantFromElement = element => {
    const explicit = element?.dataset?.variantId || element?.getAttribute?.("data-variant-id");
    if (explicit) return explicit;
    const form = element?.closest?.("form");
    if (form) {
      const data = new FormData(form);
      return data.get("id") || form.querySelector('[name="id"], [data-variant-select]')?.value || "";
    }
    const productRoot = element?.closest?.("[data-apex-product-detail], [data-quote-product], .apex-product-card");
    return productRoot?.dataset?.quoteVariantId || productRoot?.dataset?.variantId || "";
  };

  const quantityFromForm = form => {
    const quantity = form?.querySelector('[name="quantity"]')?.value;
    return Math.max(1, Number(quantity || 1));
  };

  const addItems = async (items, button = null) => {
    const valid = items
      .map(item => ({ id: Number(item.id), quantity: Math.max(1, Number(item.quantity || 1)) }))
      .filter(item => Number.isFinite(item.id) && item.id > 0);
    if (!valid.length) return null;
    setButtonLoading(button, true);
    try {
      await requestJson("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: valid })
      });
      return refreshCart({ open: true });
    } catch (error) {
      window.location.assign(`/cart/${valid.map(item => `${item.id}:${item.quantity}`).join(",")}`);
      return null;
    } finally {
      setButtonLoading(button, false);
    }
  };

  const changeLine = async (key, quantity) => {
    if (!key) return;
    const cart = await requestJson("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity || 0)) })
    });
    renderCart(cart);
  };

  document.addEventListener("click", event => {
    const addButton = event.target.closest("[data-cart-add]");
    if (addButton) {
      event.preventDefault();
      const variantId = variantFromElement(addButton);
      const form = addButton.closest('form[action*="/cart/add"], form.apex-product-form');
      const quantity = quantityFromForm(form);
      if (variantId) addItems([{ id: variantId, quantity }], addButton);
      return;
    }

    const cartLink = event.target.closest(".apex-cart-link");
    if (cartLink && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      refreshCart({ open: true });
      return;
    }

    const closeButton = event.target.closest("[data-cart-drawer-close]");
    if (closeButton || event.target.matches("[data-cart-drawer-overlay]")) {
      event.preventDefault();
      setDrawerOpen(false);
      return;
    }

    const deltaButton = event.target.closest("[data-cart-delta]");
    if (deltaButton) {
      event.preventDefault();
      const quantity = Number(deltaButton.dataset.currentQuantity || 0) + Number(deltaButton.dataset.cartDelta || 0);
      changeLine(deltaButton.dataset.cartLineKey, quantity);
      return;
    }

    const removeButton = event.target.closest("[data-cart-remove]");
    if (removeButton) {
      event.preventDefault();
      changeLine(removeButton.dataset.cartLineKey, 0);
    }
  });

  document.addEventListener("submit", event => {
    const form = event.target.closest('form[action*="/cart/add"], form.apex-product-form');
    if (!form || !form.classList.contains("apex-product-form")) return;
    event.preventDefault();
    const submitter = event.submitter || form.querySelector('[type="submit"]');
    const variantId = variantFromElement(form);
    if (variantId) addItems([{ id: variantId, quantity: quantityFromForm(form) }], submitter);
  }, true);

  document.addEventListener("keydown", event => {
    if (event.key === "Escape" && drawerOverlay()?.classList.contains("is-open")) setDrawerOpen(false);
  });

  const onReady = () => {
    fixMojibake();
    refreshCart().catch(() => {});
    window.setTimeout(fixMojibake, 300);
    window.setTimeout(fixMojibake, 1200);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", onReady, { once: true });
  else onReady();

  window.CycloOutletCartDrawer = {
    open: () => refreshCart({ open: true }),
    close: () => setDrawerOpen(false),
    addItems
  };
})();

(() => {
  const carousels = document.querySelectorAll("[data-co-offer-carousel]");
  if (!carousels.length) return;

  carousels.forEach(carousel => {
    const track = carousel.querySelector("[data-co-offer-track]");
    const slides = Array.from(carousel.querySelectorAll("[data-co-offer-slide]"));
    const prev = carousel.querySelector("[data-co-offer-prev]");
    const next = carousel.querySelector("[data-co-offer-next]");
    const dotsWrap = carousel.querySelector("[data-co-offer-dots]");
    if (!track || !slides.length) return;

    let index = 0;
    let timer = null;

    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      slides.forEach((_, i) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.setAttribute("aria-label", `Ir a oferta ${i + 1}`);
        dot.dataset.coOfferDot = String(i);
        dot.addEventListener("click", () => {
          goTo(i);
          restart();
        });
        dotsWrap.appendChild(dot);
      });
    }

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, i) => slide.setAttribute("aria-hidden", i === index ? "false" : "true"));
      dotsWrap?.querySelectorAll("[data-co-offer-dot]").forEach((dot, i) => dot.classList.toggle("is-active", i === index));
    }

    function start() {
      if (slides.length <= 1 || timer) return;
      timer = window.setInterval(() => goTo(index + 1), 5200);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function restart() {
      stop();
      start();
    }

    prev?.addEventListener("click", () => { goTo(index - 1); restart(); });
    next?.addEventListener("click", () => { goTo(index + 1); restart(); });
    carousel.addEventListener("mouseenter", stop);
    carousel.addEventListener("mouseleave", start);
    carousel.addEventListener("focusin", stop);
    carousel.addEventListener("focusout", start);

    goTo(0);
    start();
  });
})();
(() => {
  const menuButton = document.querySelector("[data-menu-toggle]");
  const navigation = document.querySelector(".apex-nav");
  const header = document.querySelector("[data-site-header]");
  const desktopQuery = window.matchMedia("(min-width: 750px)");

  const setMenuState = (open) => {
    document.body.classList.toggle("apex-menu-open", open);
    menuButton?.setAttribute("aria-expanded", String(open));
    navigation?.setAttribute("aria-hidden", String(!open && !desktopQuery.matches));
  };

  setMenuState(false);

  menuButton?.addEventListener("click", () => {
    setMenuState(!document.body.classList.contains("apex-menu-open"));
  });

  navigation?.addEventListener("click", (event) => {
    if (event.target.closest("a")) setMenuState(false);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") setMenuState(false);
  });

  document.addEventListener("click", (event) => {
    if (!document.body.classList.contains("apex-menu-open")) return;
    if (header?.contains(event.target)) return;
    setMenuState(false);
  });

  const closeMenuOnDesktop = () => setMenuState(false);
  if (desktopQuery.addEventListener) desktopQuery.addEventListener("change", closeMenuOnDesktop);
  else desktopQuery.addListener?.(closeMenuOnDesktop);

  const comparator = document.querySelector("[data-comparator-page]");
  if (comparator) {
    const fields = [...comparator.querySelectorAll("[data-compare-input]")];
    const technologies = [...comparator.querySelectorAll("[data-compare-technology]")];
    const cards = [...comparator.querySelectorAll("[data-compare-card]")];
    const result = comparator.querySelector("[data-comparator-result]");
    const summary = comparator.querySelector("[data-comparator-summary]");
    const whatsapp = comparator.querySelector("[data-comparator-whatsapp]");

    const radarScores = {
      "105": [82, 66, 72, 96, 96, 68],
      ultegra: [94, 86, 92, 88, 72, 88],
      dura: [100, 100, 100, 78, 45, 100]
    };

    const radarPoint = (score, index) => {
      const angle = (-90 + index * 60) * Math.PI / 180;
      const radius = 150 * score / 100;
      return `${210 + Math.cos(angle) * radius},${195 + Math.sin(angle) * radius}`;
    };

    Object.entries(radarScores).forEach(([family, scores]) => {
      const polygon = comparator.querySelector(`[data-radar-series="${family}"]`);
      if (polygon) polygon.setAttribute("points", scores.map(radarPoint).join(" "));
    });

    const recommend = () => {
      const values = Object.fromEntries(fields.map(field => [field.dataset.compareInput, field.value]));
      const selectedTechnologies = technologies.filter(field => field.checked).map(field => field.value);
      let family = "Ultegra";
      if (values.budget === "entry" || values.goal === "value") family = "105";
      if (values.budget === "premium" || values.goal === "weight" || values.goal === "precision") family = "Dura-Ace";
      if (values.use === "training" && values.budget !== "premium") family = values.goal === "value" ? "105" : "Ultegra";
      if (selectedTechnologies.includes("mechanical") && !selectedTechnologies.includes("di2") && family === "Dura-Ace") family = "Ultegra";

      cards.forEach(card => {
        const tech = String(card.dataset.tech || "").split(" ");
        const compatible = !selectedTechnologies.length || selectedTechnologies.every(item => tech.includes(item));
        card.classList.toggle("is-recommended", card.dataset.compareCard === family.toLowerCase().replace("-ace", ""));
        card.classList.toggle("is-filtered-out", !compatible);
      });
      const techLabel = selectedTechnologies.length ? selectedTechnologies.join(", ") : "sin restricción tecnológica";
      const message = `${family} es la recomendación inicial según tus prioridades y selección: ${techLabel}. Un técnico CycloOutlet debe validar compatibilidad, estándar y uso antes de la compra.`;
      if (result) result.textContent = message;
      if (summary) summary.value = `Comparador CycloOutlet: ${family}. ${JSON.stringify({ ...values, technologies: selectedTechnologies })}`;
      if (whatsapp) whatsapp.href = `https://wa.me/573142533532?text=${encodeURIComponent(`Hola, usé el comparador CycloOutlet y mi recomendación fue ${family}. Quiero validar compatibilidad con mi bicicleta.`)}`;
    };

    fields.forEach(field => field.addEventListener("change", recommend));
    technologies.forEach(field => field.addEventListener("change", recommend));
    recommend();
  }

  const sort = document.querySelector("[data-sort-products]");
  sort?.addEventListener("change", () => {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", sort.value);
    window.location.assign(url.toString());
  });

  const categoryNavigation = document.querySelector("[data-category-navigation]");
  categoryNavigation?.addEventListener("change", () => {
    if (categoryNavigation.value) window.location.assign(categoryNavigation.value);
  });

  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get("apex_offer") === "1") {
    const productCards = [...document.querySelectorAll("[data-apex-product]")];
    const saleCards = productCards.filter(card => card.dataset.onSale === "true");
    productCards.forEach(card => card.hidden = card.dataset.onSale !== "true");
    const title = document.querySelector("[data-collection-title]");
    const count = document.querySelector("[data-product-count]");
    if (title) title.textContent = "Ofertas";
    if (count) count.textContent = `${saleCards.length} productos con precio especial en esta página`;
    document.body.classList.add("apex-offers-view");
  }

  if (window.lucide) window.lucide.createIcons();
  else window.addEventListener("load", () => window.lucide?.createIcons());
})();

(() => {
  const initHomeHorizontalProducts = () => {
    document.querySelectorAll('[data-co-horizontal-products]').forEach((rail) => {
      const section = rail.closest('.co-home-best-sellers-card') || rail.parentElement;
      const previous = section?.querySelector('[data-co-scroll-prev]');
      const next = section?.querySelector('[data-co-scroll-next]');
      const getStep = () => Math.max(rail.clientWidth * 0.78, 320);
      previous?.addEventListener('click', () => rail.scrollBy({ left: -getStep(), behavior: 'smooth' }));
      next?.addEventListener('click', () => rail.scrollBy({ left: getStep(), behavior: 'smooth' }));
    });
  };

  const initCollectionQueryFilters = () => {
    return;
    const url = new URL(window.location.href);
    const normalize = (value) => String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

    const collectionCategoryMap = {
      'grupos-completos': 'grupos',
      'shimano-105': 'grupos',
      'shimano-ultegra': 'grupos',
      'shimano-dura-ace': 'grupos',
      'platos-bielas-y-coronillas': 'bielas',
      'potenciometros': 'potenciometros',
      'manetas-ergopowers': 'manetas',
      'pachas': 'cassettes',
      'cadenillas': 'cadenas',
      'pedales': 'pedales',
      'frenos': 'frenos'
    };

    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const collectionHandle = pathParts[0] === 'collections' ? pathParts[1] : '';
    const series = normalize(url.searchParams.get('series') || url.searchParams.get('co_series') || '');
    let category = normalize(url.searchParams.get('co_category') || '');
    if (!category && collectionHandle && collectionHandle !== 'all') {
      category = collectionCategoryMap[collectionHandle] || '';
    }
    if (category === 'all') category = '';
    if (!series && !category) return;

    const cards = [...document.querySelectorAll('[data-apex-product]')];
    if (!cards.length) return;

    const categoryTerms = {
      grupos: ['grupo', 'groupset', 'grupo completo', 'shimano 105', 'ultegra', 'dura-ace', 'campagnolo', 'r7000', 'r7100', 'r7120', 'r8000', 'r8100', 'r9200'],
      potenciometros: ['potenciometro', 'potenciómetro', 'power meter', 'powermeter', 'xcadey', 'sensor de potencia'],
      manetas: ['maneta', 'manetas', 'ergopower', 'ergopowers', 'sti', 'shifter', 'palanca', 'dual control'],
      frenos: ['freno', 'frenos', 'caliper', 'calipers', 'disco', 'rotor', 'herradura', 'brake'],
      pedales: ['pedal', 'pedales', 'pedals'],
      coronas: ['corona', 'coronas', 'coronilla', 'coronillas', 'plato', 'platos', 'chainring'],
      bielas: ['biela', 'bielas', 'crank', 'crankset', 'fc-', 'brazo'],
      cassettes: ['cassette', 'cassettes', 'pacha', 'pachas', 'casete', 'piñon', 'pinon', 'sprocket'],
      cadenas: ['cadena', 'cadenas', 'cadenilla', 'cadenillas', 'chain']
    };

    const labelMap = {
      grupos: 'Grupos completos',
      '105': 'Shimano 105',
      ultegra: 'Shimano Ultegra',
      dura: 'Shimano Dura-Ace',
      potenciometros: 'Potenciómetros',
      manetas: 'Manetas',
      frenos: 'Frenos',
      pedales: 'Pedales',
      coronas: 'Coronas',
      bielas: 'Bielas',
      cassettes: 'Cassettes',
      cadenas: 'Cadenas'
    };

    const terms = category ? (categoryTerms[category] || [category]) : [];
    let visibleCount = 0;

    cards.forEach((card) => {
      const cardSeries = normalize(card.dataset.series || '');
      const cardCategory = normalize(card.dataset.coCategory || '');
      const title = normalize(`${card.dataset.title || ''} ${card.dataset.cicloApexSku || ''} ${card.textContent || ''}`);
      const seriesOk = !series || cardSeries === series || title.includes(series);
      const categoryOk = !category || cardCategory === category || terms.some((term) => title.includes(normalize(term)));
      const visible = seriesOk && categoryOk;
      card.hidden = !visible;
      card.classList.toggle('co-filtered-out', !visible);
      if (visible) visibleCount += 1;
    });

    const title = document.querySelector('[data-collection-title]');
    const pageHeading = document.querySelector('#co-collection-page-title');
    const count = document.querySelector('[data-product-count]');
    const defaultHeading = 'Productos';
    const hasFilterLabel = Boolean(series || category);
    const label = labelMap[series] || labelMap[category] || defaultHeading;
    if (title) title.textContent = hasFilterLabel ? label : defaultHeading;
    if (pageHeading) pageHeading.textContent = hasFilterLabel ? label : defaultHeading;
    if (count) count.textContent = `${visibleCount} productos encontrados`;

    const empty = document.querySelector('[data-co-category-empty]');
    if (!visibleCount && !empty) {
      const grid = document.querySelector('.apex-product-grid');
      grid?.insertAdjacentHTML('beforeend', `<div class="co-category-empty" data-co-category-empty>No encontramos productos visibles en esta página para ${label}. Usa “Ver más categorías” o revisa la siguiente página del catálogo.</div>`);
    } else if (empty) {
      empty.hidden = visibleCount > 0;
      empty.textContent = `No encontramos productos visibles en esta página para ${label}. Usa “Ver más categorías” o revisa la siguiente página del catálogo.`;
    }

    const target = document.querySelector('#productos-filtrados') || document.querySelector('.apex-collection-layout');
    if (target && (series || category)) {
      setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initHomeHorizontalProducts();
      initCollectionQueryFilters();
      window.lucide?.createIcons?.();
    }, { once: true });
  } else {
    initHomeHorizontalProducts();
    initCollectionQueryFilters();
    window.lucide?.createIcons?.();
  }
})();
(() => {
  const initHomeShowcaseSlider = () => {
    document.querySelectorAll('[data-co-showcase-slider]').forEach((rail) => {
      if (rail.dataset.coShowcaseReady === 'true') return;
      rail.dataset.coShowcaseReady = 'true';

      const section = rail.closest('.co-home-best-sellers-card') || rail.parentElement;
      const previous = section?.querySelector('[data-co-slider-prev]');
      const next = section?.querySelector('[data-co-slider-next]');
      const cards = () => Array.from(rail.querySelectorAll('.apex-product-card'));
      const perView = () => (window.innerWidth <= 760 ? 1 : window.innerWidth <= 1180 ? 2 : window.innerWidth <= 1520 ? 2 : 3);
      const pageCount = () => Math.max(1, Math.ceil(cards().length / perView()));
      const gapValue = () => parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0) || 0;
      const pageWidth = () => rail.clientWidth + gapValue();
      const autoplayDelay = 5200;
      let page = 0;
      let autoplay = null;

      const syncButtons = () => {
        const single = pageCount() <= 1;
        previous?.classList.toggle('is-disabled', single);
        next?.classList.toggle('is-disabled', single);
        if (previous) previous.disabled = single;
        if (next) next.disabled = single;
      };

      const normalizePage = (value) => {
        const total = pageCount();
        if (total <= 1) return 0;
        if (value < 0) return total - 1;
        if (value >= total) return 0;
        return value;
      };

      const goToPage = (value, behavior = 'smooth') => {
        page = normalizePage(value);
        rail.scrollTo({ left: page * pageWidth(), behavior });
        syncButtons();
      };

      const stop = () => {
        if (autoplay) {
          clearInterval(autoplay);
          autoplay = null;
        }
      };

      const start = () => {
        stop();
        if (pageCount() <= 1) return;
        autoplay = setInterval(() => goToPage(page + 1), autoplayDelay);
      };

      previous?.addEventListener('click', () => {
        goToPage(page - 1);
        start();
      });

      next?.addEventListener('click', () => {
        goToPage(page + 1);
        start();
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          goToPage(page, 'auto');
          start();
        }, 120);
      });

      [section, rail].forEach((node) => {
        node?.addEventListener('mouseenter', stop);
        node?.addEventListener('mouseleave', start);
        node?.addEventListener('focusin', stop);
        node?.addEventListener('focusout', start);
      });

      rail.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          goToPage(page - 1);
          start();
        }
        if (event.key === 'ArrowRight') {
          goToPage(page + 1);
          start();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      syncButtons();
      goToPage(0, 'auto');
      start();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeShowcaseSlider);
  } else {
    initHomeShowcaseSlider();
  }
})();
(() => {
  const initFeaturedGroupsMobileCarousel = () => {
    document.querySelectorAll("[data-co-featured-groups-slider]").forEach((rail) => {
      if (rail.dataset.coFeaturedGroupsReady === "true") return;
      rail.dataset.coFeaturedGroupsReady = "true";

      const section = rail.closest(".co-featured-groups-block") || rail.parentElement;
      const previous = section?.querySelector("[data-co-featured-groups-prev]");
      const next = section?.querySelector("[data-co-featured-groups-next]");
      const cards = () => Array.from(rail.querySelectorAll(".co-fg-card"));
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      const autoplayDelay = 4600;
      let index = 0;
      let autoplay = null;

      const isMobile = () => window.innerWidth <= 740 && rail.scrollWidth > rail.clientWidth + 4;
      const gap = () => parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0) || 0;
      const step = () => {
        const first = cards()[0];
        return first ? first.getBoundingClientRect().width + gap() : rail.clientWidth;
      };
      const total = () => cards().length;
      const normalize = (value) => {
        const count = total();
        if (count <= 1) return 0;
        if (value < 0) return count - 1;
        if (value >= count) return 0;
        return value;
      };

      const goTo = (value, behavior = "smooth") => {
        index = normalize(value);
        rail.scrollTo({ left: index * step(), behavior });
      };

      const stop = () => {
        if (!autoplay) return;
        clearInterval(autoplay);
        autoplay = null;
      };

      const start = () => {
        stop();
        if (!isMobile() || reduceMotion.matches || total() <= 1) return;
        autoplay = setInterval(() => goTo(index + 1), autoplayDelay);
      };

      previous?.addEventListener("click", () => {
        goTo(index - 1);
        start();
      });
      next?.addEventListener("click", () => {
        goTo(index + 1);
        start();
      });

      rail.addEventListener("pointerdown", stop, { passive: true });
      rail.addEventListener("pointerup", start, { passive: true });
      rail.addEventListener("pointercancel", start, { passive: true });
      rail.addEventListener("focusin", stop);
      rail.addEventListener("focusout", start);

      let scrollTimer;
      rail.addEventListener("scroll", () => {
        if (!isMobile()) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          index = normalize(Math.round(rail.scrollLeft / step()));
        }, 100);
      }, { passive: true });

      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (!isMobile()) {
            stop();
            index = 0;
            rail.scrollTo({ left: 0, behavior: "auto" });
            return;
          }
          goTo(index, "auto");
          start();
        }, 120);
      });

      document.addEventListener("visibilitychange", () => {
        if (document.hidden) stop();
        else start();
      });

      goTo(0, "auto");
      start();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFeaturedGroupsMobileCarousel);
  } else {
    initFeaturedGroupsMobileCarousel();
  }

  document.addEventListener("shopify:section:load", initFeaturedGroupsMobileCarousel);
})();
(() => {
  const normalize = (value) => String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  const ensureFeaturedGroups = () => {
    document.querySelectorAll("[data-co-featured-groups-slider]").forEach((rail) => {
      rail.querySelectorAll(".co-fg-card").forEach((card) => {
        if (card.dataset.coSeriesCard) return;
        const text = normalize(card.textContent);
        if (text.includes("105")) card.dataset.coSeriesCard = "105";
        else if (text.includes("ultegra")) card.dataset.coSeriesCard = "ultegra";
        else if (text.includes("dura")) card.dataset.coSeriesCard = "dura";
      });

      const rank = { "105": 0, ultegra: 1, dura: 2, campagnolo: 3 };
      Array.from(rail.querySelectorAll(".co-fg-card"))
        .sort((a, b) => {
          const aRank = rank[a.dataset.coSeriesCard] ?? 9;
          const bRank = rank[b.dataset.coSeriesCard] ?? 9;
          return aRank - bRank;
        })
        .forEach((card) => rail.appendChild(card));

      rail.scrollTo({ left: 0, behavior: "auto" });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensureFeaturedGroups);
  } else {
    ensureFeaturedGroups();
  }

  window.addEventListener("load", ensureFeaturedGroups);
  document.addEventListener("shopify:section:load", ensureFeaturedGroups);
})();
;


(() => {
  const targets = '.apex-group-media, .apex-card-media, .co-offer-media, .apex-product-media';
  const clamp = (value) => Math.max(0, Math.min(255, Math.round(value)));

  const sampleImage = (img, host) => {
    const src = img.currentSrc || img.src;
    if (!src || host.dataset.coDominantReady === 'true') return;
    const probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        const size = 48;
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(probe, 0, 0, size, size);
        const data = ctx.getImageData(0, 0, size, size).data;
        let r = 0, g = 0, b = 0, weight = 0;
        for (let i = 0; i < data.length; i += 4) {
          const a = data[i + 3] / 255;
          const rr = data[i], gg = data[i + 1], bb = data[i + 2];
          const brightness = (rr + gg + bb) / 3;
          if (a < .45 || brightness < 18) continue;
          const w = a * (brightness > 238 ? .35 : 1);
          r += rr * w; g += gg * w; b += bb * w; weight += w;
        }
        if (!weight) throw new Error('No useful pixels');
        r /= weight; g /= weight; b /= weight;
        // suavizar para fondo premium: ni muy blanco ni muy saturado
        r = clamp(r * .86 + 22);
        g = clamp(g * .86 + 22);
        b = clamp(b * .86 + 22);
        host.style.setProperty('--co-dominant-bg', `rgb(${r}, ${g}, ${b})`);
        host.classList.add('co-dominant-bg-ready');
        host.dataset.coDominantReady = 'true';
      } catch (error) {
        const fallback = /black|carbon|negro/i.test(img.alt || '') ? '#11110f' : '#efe9dc';
        host.style.setProperty('--co-dominant-bg', fallback);
        host.classList.add('co-dominant-bg-ready');
        host.dataset.coDominantReady = 'true';
      }
    };
    probe.onerror = () => {
      host.style.setProperty('--co-dominant-bg', '#efe9dc');
      host.classList.add('co-dominant-bg-ready');
      host.dataset.coDominantReady = 'true';
    };
    probe.src = src;
  };

  const init = () => {
    document.querySelectorAll(targets).forEach((host) => {
      const img = host.querySelector('img');
      if (img) sampleImage(img, host);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('load', init, { once: true });
})();

(function(){
  const clampScore = value => Math.max(8, Math.min(99, Math.round(Number(value || 0))));
  const textOf = product => `${product?.title || ""} ${product?.baseTitle || ""} ${product?.variantTitle || ""} ${product?.option1 || ""} ${product?.option2 || ""} ${product?.option3 || ""} ${product?.subcategory || ""} ${(product?.specs || []).join(" ")} ${product?.family || ""} ${product?.categoryHint || ""} ${product?.vendor || ""}`.toLowerCase();
  const has = (txt, words) => words.some(word => txt.includes(word));
  const priceCents = product => Number(product?.priceCents || 0);
  const priceScore = (product, categoryName) => {
    const price = priceCents(product);
    if (!price) return 70;
    const brackets = {
      grupos: [320000000, 650000000, 1150000000],
      bielas: [60000000, 150000000, 260000000],
      potenciometros: [110000000, 180000000, 280000000],
      cassettes: [22000000, 48000000, 90000000],
      cadenas: [12000000, 22000000, 40000000],
      frenos: [45000000, 95000000, 170000000],
      pedales: [40000000, 95000000, 160000000],
      coronas: [15000000, 65000000, 125000000],
      manetas: [80000000, 160000000, 260000000],
      tensores: [35000000, 95000000, 170000000],
      corazas: [25000000, 42000000, 70000000],
      accesorios: [3000000, 15000000, 35000000]
    }[categoryName] || [50000000, 150000000, 260000000];
    if (price < brackets[0]) return 94;
    if (price < brackets[1]) return 82;
    if (price < brackets[2]) return 68;
    return 54;
  };
  const tier = txt => {
    if (has(txt,["dura ace", "dura-ace", "r9200", "r9100"])) return 96;
    if (has(txt,["super record"])) return 95;
    if (has(txt,["ultegra", "r8100", "r8000", "r8170", "r8070"])) return 88;
    if (has(txt,["record", "chorus"])) return 86;
    if (has(txt,["105", "r7100", "r7000", "r7120", "r7170"])) return 78;
    if (has(txt,["tiagra"])) return 68;
    return 62;
  };
  const speeds = txt => {
    if (/(^|\D)13\s*(v|vel|speed|x)/.test(txt) || txt.includes("13v")) return 13;
    if (/(^|\D)12\s*(v|vel|speed|x)/.test(txt) || txt.includes("12v") || txt.includes("12 velocidades")) return 12;
    if (/(^|\D)11\s*(v|vel|speed|x)/.test(txt) || txt.includes("11v") || txt.includes("11 velocidades")) return 11;
    if (/(^|\D)10\s*(v|vel|speed|x)/.test(txt) || txt.includes("10v")) return 10;
    return 0;
  };
  const crankRelation = txt => {
    const m = txt.match(/\b(46|48|50|52|53|54)\s*[\/x-]\s*(30|32|34|36|39|40)\b/);
    return m ? `${m[1]}/${m[2]}` : "";
  };
  const crankLength = txt => {
    const m = txt.match(/\b(160|165|167\.5|170|172\.5|175)\s*mm?\b|\b(160|165|167\.5|170|172\.5|175)\b/);
    return m ? Number(m[1] || m[2]) : 0;
  };
  const cassetteRange = txt => {
    const m = txt.match(/\b(10|11|12)\s*[\/-]\s*(25|28|30|32|34|36|40|42|46|50|51|52)\b/);
    if (!m) return { low: 0, high: 0, range: 0 };
    const low = Number(m[1]), high = Number(m[2]);
    return { low, high, range: high - low };
  };
  const tireWidth = txt => {
    const m = txt.match(/\b700\s*[x×-]\s*(23|24|25|26|28|30|32|35|38|40)\b|\b(23|24|25|26|28|30|32|35|38|40)c\b/);
    return m ? Number(m[1] || m[2]) : 0;
  };
  const isElectronic = txt => has(txt, ["di2", "eps", "etap", "axs", "wireless", "electronico", "electrónico", "electronic"]);
  const isDisc = txt => has(txt, ["disco", "disc", "rotor", "hidraul", "hydraulic", "160mm", "140mm"]);
  const isRim = txt => has(txt, ["herradura", "rim", "rin", "caliper"]);
  const isShimano = txt => has(txt, ["shimano", "105", "ultegra", "dura"]);
  const isCampy = txt => has(txt, ["campagnolo", "super record", "record", "chorus", "eps"]);
  const metricConfig = categoryName => ({
    grupos: {
      labels: ["Cambio", "Peso", "Frenado", "Valor", "Electrónica", "Compatibilidad"],
      copy: "Grupos: la variante elegida pesa en la lectura. Disco y electrónica suben frenado/electrónica, pero penalizan peso; herradura y mecánico puntúan distinto."
    },
    bielas: { labels: ["Rigidez", "Peso", "Compatibilidad", "Relación", "Medición", "Valor"], copy: "Bielas: relación, largo, serie y potenciómetro modifican la lectura." },
    potenciometros: { labels: ["Precisión", "Simetría", "Compatibilidad", "Batería", "Conectividad", "Valor"], copy: "Potenciómetros: variante exacta, compatibilidad y tipo de medición." },
    cassettes: { labels: ["Rango", "Saltos", "Peso", "Durabilidad", "Compatibilidad", "Valor"], copy: "Cassettes: cada rango 11-28, 11-30, 11-34 cambia rango, saltos y peso estimado." },
    cadenas: { labels: ["Fricción", "Durabilidad", "Cambio", "Compatibilidad", "Peso", "Valor"], copy: "Cadenas: velocidad, tratamiento y gama." },
    frenos: { labels: ["Potencia", "Modulación", "Peso", "Disipación", "Compatibilidad", "Valor"], copy: "Frenos: disco/rin, rotor y tecnología." },
    pedales: { labels: ["Plataforma", "Peso", "Rodamiento", "Calas", "Durabilidad", "Valor"], copy: "Pedales: plataforma, material, rodamiento y sistema de cala." },
    coronas: { labels: ["Cambio", "Rigidez", "Peso", "Compatibilidad", "Relación", "Valor"], copy: "Coronas/platos: relación exacta, serie y compatibilidad." },
    manetas: { labels: ["Ergonomía", "Control", "Peso", "Integración", "Compatibilidad", "Valor"], copy: "Manetas: disco/rin, electrónica/mecánica y generación." },
    tensores: { labels: ["Cambio", "Capacidad", "Peso", "Compatibilidad", "Durabilidad", "Valor"], copy: "Tensores: capacidad de cassette y tipo electrónico/mecánico." },
    corazas: { labels: ["Rodadura", "Agarre mojado", "Pinchazos", "Peso", "Ancho/volumen", "Valor"], copy: "Llantas: ancho exacto 700x23/25/28, tubeless y modelo cambian el resultado." },
    accesorios: { labels: ["Función", "Compatibilidad", "Uso", "Durabilidad", "Originalidad", "Valor"], copy: "Accesorios: función real, compatibilidad, uso, durabilidad y valor." }
  }[categoryName] || { labels: ["Función", "Compatibilidad", "Uso", "Durabilidad", "Originalidad", "Valor"], copy: "Criterios generales." });

  const score = (product, categoryName) => {
    const txt = textOf(product);
    const value = priceScore(product, categoryName);
    const t = tier(txt);
    const spd = speeds(txt);
    const electronic = isElectronic(txt);
    const disc = isDisc(txt);
    const rim = isRim(txt);
    const shimano = isShimano(txt);
    const campy = isCampy(txt);
    const carbon = has(txt, ["carbon", "carbono"]);
    const ceramic = has(txt, ["ceramic", "ceramica", "cerámica"]);
    const tubeless = has(txt, ["tubeless", "tlr", "str", "s tr", "tr "]);

    if (categoryName === "grupos") {
      const relation = crankRelation(txt);
      const casset = cassetteRange(txt);
      const cambio = clampScore(t + (electronic ? 4 : 0) + (spd >= 12 ? 2 : 0) + (campy && spd >= 12 ? 1 : 0));
      const peso = clampScore((t >= 95 ? 91 : t >= 88 ? 84 : t >= 78 ? 76 : 68) + (rim ? 6 : 0) - (disc ? 8 : 0) - (electronic ? 5 : 0) - (casset.high >= 34 ? 2 : 0));
      const frenado = clampScore(disc ? 94 : rim ? 76 : 80);
      const electronica = clampScore(electronic ? (t >= 95 ? 98 : t >= 88 ? 94 : t >= 78 ? 88 : 84) : 10);
      const compat = clampScore((shimano ? 91 : campy ? 80 : 74) + (spd === 11 ? 2 : 0) + (relation === "50/34" ? 2 : 0) - (electronic ? 2 : 0));
      return [cambio, peso, frenado, value, electronica, compat];
    }
    if (categoryName === "bielas") {
      const relation = crankRelation(txt);
      const length = crankLength(txt);
      const relationScore = relation === "50/34" ? 94 : relation === "52/36" ? 90 : relation === "53/39" ? 84 : relation ? 86 : 76;
      const fit = length >= 160 && length <= 172.5 ? 90 : length === 175 ? 84 : 80;
      return [clampScore(t + (carbon ? 4 : 0)), clampScore(t - (has(txt,["potencio", "power", "dual"]) ? 8 : 0) + (carbon ? 4 : 0)), clampScore((shimano ? 91 : campy ? 82 : 75) + (fit - 86) / 2), relationScore, clampScore(has(txt,["potencio", "power", "dual", "xcadey", "4iiii", "stages"]) ? 94 : 28), value];
    }
    if (categoryName === "cassettes") {
      const r = cassetteRange(txt);
      const rangeScore = r.high >= 34 ? 94 : r.high >= 32 ? 88 : r.high >= 30 ? 82 : r.high >= 28 ? 76 : 70;
      const jumpScore = r.high && r.high <= 28 ? 92 : r.high <= 30 ? 88 : r.high <= 32 ? 82 : 76;
      return [rangeScore, jumpScore, clampScore(t - (r.high >= 34 ? 6 : r.high >= 32 ? 3 : 0)), clampScore(t >= 88 ? 86 : t >= 78 ? 82 : 74), clampScore((shimano ? 90 : campy ? 82 : 74) + (spd >= 12 ? 2 : 0)), value];
    }
    if (categoryName === "corazas") {
      const width = tireWidth(txt);
      const gp5000 = has(txt,["5000", "gp5000"]);
      const grandPrix = has(txt,["grand prix"]);
      const fourSeason = has(txt,["4 estaciones", "four season"]);
      const ultra = has(txt,["ultra sport"]);
      const widthScore = width >= 28 && width <= 30 ? 94 : width === 32 ? 88 : width === 25 || width === 26 ? 82 : width === 23 ? 66 : 78;
      return [gp5000 ? 96 : grandPrix ? 84 : ultra ? 72 : 78, fourSeason ? 92 : gp5000 ? 88 : grandPrix ? 80 : ultra ? 68 : 76, fourSeason ? 96 : tubeless ? 86 : gp5000 ? 78 : grandPrix ? 76 : 66, gp5000 ? 90 : ultra ? 82 : tubeless ? 76 : fourSeason ? 70 : 74, widthScore, value];
    }
    if (categoryName === "potenciometros") return [clampScore(has(txt,["dual", "bilateral", "dura", "ultegra"]) ? 94 : has(txt,["xcadey", "4iiii", "stages"]) ? 88 : 80), clampScore(has(txt,["dual", "bilateral"]) ? 96 : 70), clampScore(shimano || has(txt,["r7000", "r8000", "r8100", "r7100"]) ? 91 : 76), clampScore(has(txt,["recarg", "usb", "recharge"]) ? 88 : 78), clampScore(has(txt,["ant", "bluetooth", "ble", "di2"]) ? 94 : 82), value];
    if (categoryName === "cadenas") return [clampScore(t >= 88 ? 90 : t >= 78 ? 82 : 74), clampScore(has(txt,["sil", "sil-tec", "quick", "ultegra", "dura"]) ? 90 : 80), clampScore(spd >= 12 ? 90 : 82), clampScore(spd >= 12 ? 88 : spd === 11 ? 84 : 76), clampScore(t >= 88 ? 88 : 80), value];
    if (categoryName === "frenos") return [clampScore(disc ? 94 : 78), clampScore(disc ? 92 : 76), clampScore(t + (rim ? 5 : 0) - (disc ? 6 : 0)), clampScore(has(txt,["ice", "freeza", "160", "rotor"]) ? 92 : disc ? 86 : 68), clampScore(shimano ? 90 : 78), value];
    if (categoryName === "pedales") return [clampScore(has(txt,["blade", "dura", "ultegra"]) ? 92 : 82), clampScore(carbon ? 92 : has(txt,["dura"]) ? 90 : has(txt,["ultegra"]) ? 86 : 78), clampScore(ceramic ? 96 : has(txt,["ultegra", "dura", "look"]) ? 88 : 76), clampScore(has(txt,["look", "keo", "spd-sl", "spd sl"]) ? 90 : 74), clampScore(ceramic || has(txt,["shimano", "look"]) ? 88 : 78), value];
    if (categoryName === "coronas") { const relation = crankRelation(txt); return [clampScore(t + (spd >= 12 ? 2 : 0)), clampScore(t + (carbon ? 2 : 0)), clampScore(t - (has(txt,["grande", "52", "53", "54"]) ? 3 : 0)), clampScore(shimano ? 90 : campy ? 82 : 74), clampScore(relation === "50/34" ? 92 : relation === "52/36" ? 88 : relation === "53/39" ? 84 : relation ? 86 : 76), value]; }
    if (categoryName === "manetas") return [clampScore(t + (electronic ? 4 : 0)), clampScore(disc ? 92 : 78), clampScore(t - (disc ? 5 : 0) - (electronic ? 2 : 0)), clampScore(electronic ? 94 : disc ? 86 : 72), clampScore(shimano ? 90 : campy ? 82 : 74), value];
    if (categoryName === "tensores") { const r = cassetteRange(txt); return [clampScore(t + (electronic ? 6 : 0)), clampScore(has(txt,["gs", "largo"]) || r.high >= 34 ? 92 : 78), clampScore(t - (electronic ? 6 : 0)), clampScore(shimano ? 90 : campy ? 82 : 74), clampScore(t >= 88 ? 88 : 80), value]; }
    return [clampScore(has(txt,["original", "shimano", "look", "garmin", "wahoo", "continental"]) ? 88 : 74), clampScore(shimano || has(txt,["compatible", "adaptador", "sl7", "sl8"]) ? 90 : 76), clampScore(has(txt,["adaptador", "cable", "sensor"]) ? 86 : 78), clampScore(has(txt,["original", "carbon", "aluminio", "shimano"]) ? 88 : 74), clampScore(has(txt,["original", "shimano", "look", "campagnolo"]) ? 92 : 72), value];
  };
  window.CycloOutletComparatorMatrix = { metricConfig, score, priceScore, clampScore };
})();
(() => {
  const normalize = value => String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

  const textForOption = option => String(option?.textContent || "").replace(/\s+/g, " ").trim();

  const enhanceSelect = select => {
    if (!select || select.dataset.coSearchReady === "true") return;
    select.dataset.coSearchReady = "true";

    const label = select.closest("label");
    const wrapper = document.createElement("div");
    wrapper.className = "co-searchable-select";

    const input = document.createElement("input");
    input.type = "search";
    input.className = "co-searchable-select__field";
    input.autocomplete = "off";
    input.spellcheck = false;
    input.placeholder = "Escribe para buscar referencia o variante";

    const list = document.createElement("div");
    list.className = "co-searchable-select__list";
    list.hidden = true;

    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(input);
    wrapper.appendChild(select);
    wrapper.appendChild(list);

    const optionData = () => [...select.options]
      .filter(option => option.value)
      .map(option => ({
        value: option.value,
        label: textForOption(option),
        tokens: normalize(`${option.value} ${textForOption(option)}`)
      }));

    const selectedLabel = () => textForOption(select.selectedOptions?.[0]) || "";

    const syncInput = () => {
      const value = selectedLabel();
      if (document.activeElement !== input || !input.value) input.value = value;
    };

    const close = () => { list.hidden = true; };
    const open = () => { list.hidden = false; };

    const selectValue = value => {
      if (![...select.options].some(option => option.value === value)) return;
      select.value = value;
      input.value = selectedLabel();
      select.dispatchEvent(new Event("change", { bubbles: true }));
      close();
    };

    const render = () => {
      const query = normalize(input.value);
      const all = optionData();
      const matches = query
        ? all.filter(item => item.tokens.includes(query)).slice(0, 36)
        : all.slice(0, 24);

      if (!matches.length) {
        list.innerHTML = `<div class="co-searchable-select__empty">Sin coincidencias. Prueba con serie, medida o precio.</div>`;
        open();
        return;
      }

      list.innerHTML = matches.map(item => {
        const [main, ...rest] = item.label.split(" — ");
        return `<button class="co-searchable-select__option${item.value === select.value ? " is-active" : ""}" type="button" data-value="${item.value.replace(/"/g, "&quot;")}"><strong>${main}</strong>${rest.length ? `<small>${rest.join(" — ")}</small>` : ""}</button>`;
      }).join("");
      open();
    };

    input.addEventListener("focus", render);
    input.addEventListener("input", render);
    input.addEventListener("keydown", event => {
      const buttons = [...list.querySelectorAll("button[data-value]")];
      const activeIndex = buttons.findIndex(button => button.classList.contains("is-key-active"));
      if (event.key === "Escape") close();
      if (event.key === "Enter") {
        event.preventDefault();
        const target = buttons[Math.max(activeIndex, 0)];
        if (target) selectValue(target.dataset.value);
      }
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        event.preventDefault();
        if (!buttons.length) return;
        const next = event.key === "ArrowDown"
          ? (activeIndex + 1) % buttons.length
          : (activeIndex <= 0 ? buttons.length - 1 : activeIndex - 1);
        buttons.forEach(button => button.classList.remove("is-key-active"));
        buttons[next].classList.add("is-key-active");
        buttons[next].scrollIntoView({ block: "nearest" });
      }
    });

    list.addEventListener("click", event => {
      const button = event.target.closest("button[data-value]");
      if (button) selectValue(button.dataset.value);
    });

    select.addEventListener("change", () => {
      syncInput();
      // Garantiza que el comparador se repinte aunque el cambio venga de código externo.
      window.dispatchEvent(new CustomEvent("cyclooutlet:comparator-reference-changed", { detail: { value: select.value } }));
    });

    document.addEventListener("click", event => {
      if (!wrapper.contains(event.target)) close();
    });

    new MutationObserver(() => {
      syncInput();
      if (!list.hidden) render();
    }).observe(select, { childList: true, subtree: true, attributes: true });

    syncInput();
  };

  const enhanceComparator = () => {
    document.querySelectorAll("[data-co-slot-select]").forEach(enhanceSelect);

    // Refuerzo para el bug reportado: si cualquier selector cambia, forzamos un segundo change microtask
    // para que la lógica anterior alcance a usar las opciones ya hidratadas / variantes exactas.
    document.querySelectorAll("[data-co-slot-select]").forEach(select => {
      if (select.dataset.coRepaintGuard === "true") return;
      select.dataset.coRepaintGuard = "true";
      select.addEventListener("change", () => {
        clearTimeout(select._coRepaintTimer);
        select._coRepaintTimer = setTimeout(() => {
          select.dispatchEvent(new Event("co:slot-sync", { bubbles: true }));
        }, 0);
      });
    });
  };

  const boot = () => {
    enhanceComparator();
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", boot);
})();
(() => {
  const SEARCH_PARAM = "co_search";
  const PRODUCT_PATH = "/collections/all";
  const MIN_QUERY = 2;
  const DEBOUNCE_MS = 130;
  const PREDICTIVE_LIMIT = 10;
  const MAX_RESULTS = 10;
  const CATALOG_PAGE_SIZE = 250;
  const CATALOG_MAX_PAGES = 12;

  const predictiveCache = new Map();
  let predictiveController = null;
  let catalogPromise = null;
  let catalogItems = [];

  const normalize = (value) => String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

  const tokensFor = (value) => normalize(value).split(/\s+/).filter(Boolean);

  const productHandleFromUrl = (value) => {
    try {
      const url = new URL(String(value || ""), window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : "";
    } catch (_) {
      const match = String(value || "").match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : "";
    }
  };

  const canonicalProductKey = (item) => {
    const handle = item?.handle || productHandleFromUrl(item?.url);
    if (handle) return `handle:${normalize(handle)}`;
    const title = normalize(item?.title);
    const vendor = normalize(item?.vendor);
    return title ? `title:${title}|${vendor}` : "";
  };

  const mergeProductData = (primary, secondary) => ({
    ...secondary,
    ...primary,
    handle: primary?.handle || secondary?.handle || productHandleFromUrl(primary?.url || secondary?.url),
    url: primary?.url || secondary?.url || "",
    image: primary?.image || secondary?.image || "",
    imageAlt: primary?.imageAlt || secondary?.imageAlt || primary?.title || secondary?.title || "",
    price: primary?.price || secondary?.price || "",
    sku: primary?.sku || secondary?.sku || "",
    tokens: primary?.tokens || secondary?.tokens || "",
    score: Math.max(Number(primary?.score ?? -1), Number(secondary?.score ?? -1)),
    available: primary?.available !== undefined ? primary.available : (secondary?.available !== undefined ? secondary.available : true)
  });

  const uniqueProducts = (items) => {
    const unique = new Map();
    (items || []).forEach((item) => {
      const key = canonicalProductKey(item);
      if (!key) return;
      unique.set(key, unique.has(key) ? mergeProductData(unique.get(key), item) : item);
    });
    return [...unique.values()];
  };

  const semanticAliases = (value) => {
    const text = normalize(value);
    const aliases = [];
    if (text.includes("tensor") || text.includes("cambio trasero") || text.includes("derailleur")) aliases.push("tensor desviador trasero derailleur cambio trasero rd");
    if (text.includes("descarrilador") || text.includes("desviador delantero")) aliases.push("descarrilador desviador delantero front derailleur fd");
    if (text.includes("cadenilla") || text.includes("cadena") || text.includes("chain")) aliases.push("cadenilla cadena chain cn");
    if (text.includes("pacha") || text.includes("cassette") || text.includes("casete")) aliases.push("pacha cassette casete pinones piñones cs");
    if (text.includes("coronilla") || text.includes("corona") || text.includes("plato") || text.includes("chainring")) aliases.push("coronilla corona plato chainring");
    if (text.includes("ergopower") || text.includes("maneta") || text.includes("sti") || text.includes("shifter")) aliases.push("ergopower maneta sti dual control shifter palanca");
    if (text.includes("herradura") || text.includes("rim brake") || text.includes("caliper")) aliases.push("herradura freno rim brake caliper");
    if (text.includes("di2") || text.includes("electronico") || text.includes("electrónico") || text.includes("electronic")) aliases.push("di2 electronic electronico electrónico cambio electrico eléctrico");
    return aliases.join(" ");
  };

  const stripHtml = (value) => String(value || "").replace(/<[^>]*>/g, " ");

  const queryFromUrl = () => new URL(window.location.href).searchParams.get(SEARCH_PARAM) || "";

  const collectionUrl = (query) => {
    const url = new URL(PRODUCT_PATH, window.location.origin);
    const clean = String(query || "").trim();
    if (clean) url.searchParams.set(SEARCH_PARAM, clean);
    url.hash = "productos-filtrados";
    return url.pathname + url.search + url.hash;
  };

  const formatPrice = (value) => {
    if (value === null || value === undefined || value === "") return "";
    let number = Number(value);
    if (!Number.isFinite(number)) return "";
    // /products.json entrega COP como unidades monetarias (ej. 399900.00),
    // mientras algunos objetos predictivos pueden llegar en centavos.
    if (number > 0 && number < 10000 && String(value).indexOf(".") === -1) number = number / 100;
    try {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        maximumFractionDigits: 0
      }).format(number);
    } catch (_) {
      return `$${Math.round(number).toLocaleString("es-CO")}`;
    }
  };

  const imageFromCard = (card) => card?.querySelector("img")?.currentSrc || card?.querySelector("img")?.src || "";
  const titleFromCard = (card) => card?.dataset?.title || card?.querySelector("h3")?.textContent || card?.textContent || "";
  const urlFromCard = (card) => card?.querySelector("a[href*='/products/']")?.getAttribute("href") || card?.dataset?.quoteUrl || "";

  const scoreMatch = (item, query) => {
    const clean = normalize(query);
    const tokens = tokensFor(query);
    const title = normalize(item.title);
    const haystack = item.tokens || normalize([item.title, item.vendor, item.type, item.handle, item.sku].join(" "));
    if (!tokens.length || !tokens.every((token) => haystack.includes(token))) return -1;
    let score = 0;
    if (title === clean) score += 1000;
    if (title.startsWith(clean)) score += 500;
    if (title.includes(clean)) score += 260;
    tokens.forEach((token) => {
      if (title.startsWith(token)) score += 90;
      else if (title.includes(token)) score += 50;
      if (normalize(item.sku).includes(token)) score += 80;
      if (normalize(item.handle).includes(token)) score += 35;
    });
    return score;
  };

  const localSuggestions = (query) => {
    const tokens = tokensFor(query);
    if (!tokens.length) return [];

    const matches = [...document.querySelectorAll("[data-apex-product], [data-co-clean-card], .co-catalog-card")]
      .map((card) => {
        const title = titleFromCard(card).replace(/\s+/g, " ").trim();
        const imageAlt = card.querySelector("img")?.getAttribute("alt") || "";
        const sku = card.dataset.cicloApexSku || card.dataset.sku || "";
        const url = urlFromCard(card);
        const item = {
          title,
          url,
          image: imageFromCard(card),
          imageAlt,
          price: card.querySelector(".apex-price, .co-catalog-card__price strong, [data-product-price]")?.textContent?.trim() || "",
          vendor: card.dataset.vendor || "",
          type: card.dataset.coCategory || "",
          handle: card.dataset.handle || productHandleFromUrl(url),
          sku,
          available: !(card.classList.contains("co-catalog-card--sold-out") || card.querySelector(".co-catalog-card__sold-out")),
          source: "local"
        };
        item.tokens = normalize([
          title,
          item.vendor,
          card.dataset.series,
          item.type,
          sku,
          imageAlt,
          card.textContent,
          semanticAliases(title)
        ].join(" "));
        item.score = scoreMatch(item, query);
        return item;
      })
      .filter((item) => item.title && item.url && item.score >= 0);

    return uniqueProducts(matches)
      .sort((a, b) => Number(b.available !== false) - Number(a.available !== false) || b.score - a.score || a.title.localeCompare(b.title, "es"));
  };

  const imageFromPredictive = (product) => {
    const image = product?.image || product?.featured_image;
    if (!image) return "";
    if (typeof image === "string") return image;
    return image.url || image.src || "";
  };

  const imageAltFromPredictive = (product) => {
    const image = product?.image || product?.featured_image;
    if (!image || typeof image === "string") return product?.title || "";
    return image.alt || product?.title || "";
  };

  const predictiveSuggestions = async (query) => {
    const clean = String(query || "").trim();
    const key = normalize(clean);
    if (key.length < MIN_QUERY) return [];
    if (predictiveCache.has(key)) return predictiveCache.get(key);

    if (predictiveController) predictiveController.abort();
    predictiveController = new AbortController();

    const params = new URLSearchParams();
    params.set("q", clean);
    params.set("resources[type]", "product");
    params.set("resources[limit]", String(PREDICTIVE_LIMIT));
    params.set("resources[options][unavailable_products]", "last");

    const response = await fetch(`/search/suggest.json?${params.toString()}`, {
      signal: predictiveController.signal,
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    });
    if (!response.ok) throw new Error("predictive search failed");

    const data = await response.json();
    const products = data?.resources?.results?.products || [];
    const results = products.map((product) => {
      const item = {
        title: product.title || product.text || "",
        url: product.url || (product.handle ? `/products/${product.handle}` : collectionUrl(clean)),
        image: imageFromPredictive(product),
        imageAlt: imageAltFromPredictive(product),
        price: formatPrice(product.price),
        vendor: product.vendor || "",
        type: product.type || product.product_type || "",
        handle: product.handle || "",
        sku: product.sku || "",
        available: product.available !== false,
        source: "predictive"
      };
      item.tokens = normalize([item.title, item.vendor, item.type, item.handle, item.sku, semanticAliases(item.title)].join(" "));
      item.score = scoreMatch(item, clean);
      return item;
    }).filter((item) => item.title && item.url);

    const uniqueResults = uniqueProducts(results);
    predictiveCache.set(key, uniqueResults);
    return uniqueResults;
  };

  const normalizeCatalogProduct = (product) => {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const images = Array.isArray(product?.images) ? product.images : [];
    const firstImage = images[0]?.src || product?.image?.src || product?.featured_image?.src || "";
    const imageAlts = images.map((image) => image?.alt || "").filter(Boolean);
    const descriptionText = stripHtml(product?.body_html || product?.description || "");
    const skus = variants.map((variant) => variant?.sku || "").filter(Boolean);
    const variantTitles = variants.map((variant) => variant?.title || "").filter(Boolean);
    const optionValues = Array.isArray(product?.options)
      ? product.options.flatMap((option) => Array.isArray(option?.values) ? option.values : [])
      : [];
    const prices = variants
      .map((variant) => Number(variant?.price))
      .filter((value) => Number.isFinite(value) && value >= 0);
    const minPrice = prices.length ? Math.min(...prices) : Number(product?.price || 0);
    const hasAvailability = variants.some((variant) => typeof variant?.available === "boolean");
    const isAvailable = hasAvailability ? variants.some((variant) => variant?.available === true) : true;
    const item = {
      title: product?.title || "",
      url: product?.handle ? `/products/${product.handle}` : "",
      image: firstImage,
      imageAlt: imageAlts[0] || product?.title || "",
      price: formatPrice(minPrice),
      vendor: product?.vendor || "",
      type: product?.product_type || product?.type || "",
      handle: product?.handle || "",
      sku: skus.join(" "),
      available: isAvailable,
      source: "catalog"
    };
    item.tokens = normalize([
      item.title,
      item.vendor,
      item.type,
      item.handle,
      Array.isArray(product?.tags) ? product.tags.join(" ") : product?.tags,
      skus.join(" "),
      variantTitles.join(" "),
      optionValues.join(" "),
      imageAlts.join(" "),
      descriptionText,
      semanticAliases(item.title)
    ].join(" "));
    return item;
  };

  const loadCatalog = async () => {
    if (catalogPromise) return catalogPromise;
    catalogPromise = (async () => {
      const loaded = [];
      for (let page = 1; page <= CATALOG_MAX_PAGES; page += 1) {
        const requestOptions = {
          headers: { Accept: "application/json" },
          credentials: "same-origin"
        };
        let response = await fetch(`/products.json?limit=${CATALOG_PAGE_SIZE}&page=${page}`, requestOptions);
        if (!response.ok) {
          response = await fetch(`/collections/all/products.json?limit=${CATALOG_PAGE_SIZE}&page=${page}`, requestOptions);
        }
        if (!response.ok) throw new Error("catalog search failed");
        const data = await response.json();
        const products = Array.isArray(data?.products) ? data.products : [];
        loaded.push(...products.map(normalizeCatalogProduct).filter((item) => item.title && item.url));
        if (products.length < CATALOG_PAGE_SIZE) break;
      }
      const unique = new Map();
      loaded.forEach((item) => {
        const key = canonicalProductKey(item);
        if (!key) return;
        unique.set(key, unique.has(key) ? mergeProductData(unique.get(key), item) : item);
      });
      catalogItems = [...unique.values()];
      return catalogItems;
    })().catch((error) => {
      catalogPromise = null;
      throw error;
    });
    return catalogPromise;
  };

  const catalogSuggestions = async (query) => {
    const tokens = tokensFor(query);
    if (!tokens.length) return [];
    const catalog = await loadCatalog();
    return catalog
      .map((item) => ({ ...item, score: scoreMatch(item, query) }))
      .filter((item) => item.score >= 0)
      .sort((a, b) => Number(b.available !== false) - Number(a.available !== false) || b.score - a.score || a.title.localeCompare(b.title, "es"));
  };

  const mergeUnique = (...groups) => uniqueProducts(groups.flat());

  const renderResults = (box, input, results, query, status = "", loading = false) => {
    box.innerHTML = "";
    const clean = String(query || "").trim();
    const uniqueResults = uniqueProducts(results).slice(0, MAX_RESULTS);

    if (!clean || clean.length < MIN_QUERY) {
      box.hidden = true;
      input.setAttribute("aria-expanded", "false");
      return;
    }

    const summary = document.createElement("div");
    summary.className = "co-header-product-summary";
    if (loading) summary.textContent = uniqueResults.length ? `${uniqueResults.length} coincidencias únicas · buscando más...` : "Buscando coincidencias...";
    else if (uniqueResults.length) summary.textContent = `${uniqueResults.length} ${uniqueResults.length === 1 ? "coincidencia" : "coincidencias"}`;
    else summary.textContent = status || "Sin coincidencias";
    box.appendChild(summary);

    if (uniqueResults.length) {
      uniqueResults.forEach((item, index) => {
        const link = document.createElement("a");
        link.className = "co-header-product-result";
        link.href = item.url || collectionUrl(clean);
        link.setAttribute("role", "option");
        link.setAttribute("aria-selected", "false");
        link.dataset.coSearchResultIndex = String(index);

        const media = document.createElement("span");
        media.className = "co-header-product-result__media";
        if (item.image) {
          const img = document.createElement("img");
          img.src = item.image;
          img.alt = item.imageAlt || item.title || "";
          img.loading = index < 5 ? "eager" : "lazy";
          img.decoding = "async";
          media.appendChild(img);
        } else {
          media.hidden = true;
          link.classList.add("co-header-product-result--text-only");
        }

        const copy = document.createElement("span");
        copy.className = "co-header-product-result__copy";
        const title = document.createElement("strong");
        title.textContent = item.title;
        copy.appendChild(title);

        link.appendChild(media);
        link.appendChild(copy);
        box.appendChild(link);
      });
    } else if (!loading) {
      const empty = document.createElement("div");
      empty.className = "co-header-product-empty";
      empty.textContent = status || "No encontramos productos con ese texto.";
      box.appendChild(empty);
    }

    const all = document.createElement("a");
    all.className = "co-header-product-all";
    all.href = collectionUrl(clean);
    all.textContent = `Ver todos los resultados para “${clean}”`;
    box.appendChild(all);
    box.hidden = false;
    input.setAttribute("aria-expanded", "true");
  };

  const broadcastQuery = (query) => {
    window.dispatchEvent(new CustomEvent("cyclooutlet:product-search-query", {
      detail: { query: String(query || "") }
    }));
  };

  const initHeaderSearch = () => {
    const initialQuery = queryFromUrl();

    document.querySelectorAll("[data-co-header-product-search]").forEach((form) => {
      if (form.dataset.coHeaderSearchReady === "true") return;
      form.dataset.coHeaderSearchReady = "true";

      const input = form.querySelector("[data-co-header-product-search-input]");
      const box = form.querySelector("[data-co-header-product-results]");
      const clearButton = form.querySelector("[data-co-header-product-clear]");
      if (!input || !box) return;

      input.setAttribute("aria-autocomplete", "list");
      input.setAttribute("aria-expanded", "false");
      if (!input.value && initialQuery) input.value = initialQuery;
      if (clearButton) clearButton.hidden = !input.value.trim();

      let timer = 0;
      let lastQuery = "";
      let activeIndex = -1;
      const trackedNoResults = new Set();

      const resultLinks = () => [...box.querySelectorAll("a.co-header-product-result")];

      const setActive = (index) => {
        const links = resultLinks();
        if (!links.length) {
          activeIndex = -1;
          return;
        }
        activeIndex = Math.max(0, Math.min(index, links.length - 1));
        links.forEach((link, i) => {
          const active = i === activeIndex;
          link.classList.toggle("is-active", active);
          link.setAttribute("aria-selected", active ? "true" : "false");
        });
        links[activeIndex]?.scrollIntoView({ block: "nearest" });
      };

      const close = () => {
        box.hidden = true;
        input.setAttribute("aria-expanded", "false");
        activeIndex = -1;
      };

      const update = async () => {
        const query = input.value.trim();
        lastQuery = query;
        activeIndex = -1;
        if (clearButton) clearButton.hidden = !query;
        broadcastQuery(query);

        if (query.length < MIN_QUERY) {
          close();
          return;
        }

        const local = localSuggestions(query);
        if (local.length) renderResults(box, input, local, query, "", true);
        else renderResults(box, input, [], query, "", true);

        const predictive = await predictiveSuggestions(query).catch((error) => {
          if (error?.name === "AbortError") return [];
          return [];
        });
        if (lastQuery !== query) return;

        const fastMerged = mergeUnique(predictive, local)
          .map((item) => ({ ...item, score: Number.isFinite(item.score) ? item.score : scoreMatch(item, query) }))
          .filter((item) => item.score >= 0)
          .sort((a, b) => Number(b.available !== false) - Number(a.available !== false) || (b.score || 0) - (a.score || 0) || a.title.localeCompare(b.title, "es"));

        if (fastMerged.length >= MAX_RESULTS) {
          renderResults(box, input, fastMerged, query, "");
          return;
        }

        renderResults(box, input, fastMerged, query, "", true);
        const catalog = await catalogSuggestions(query).catch(() => []);
        if (lastQuery !== query) return;

        const merged = mergeUnique(predictive, local, catalog)
          .map((item) => ({ ...item, score: Number.isFinite(item.score) ? item.score : scoreMatch(item, query) }))
          .filter((item) => item.score >= 0)
          .sort((a, b) => Number(b.available !== false) - Number(a.available !== false) || (b.score || 0) - (a.score || 0) || a.title.localeCompare(b.title, "es"));
        renderResults(box, input, merged, query, merged.length ? "" : "No encontramos productos con ese texto.");
        if (!merged.length) {
          const normalizedQuery = normalize(query);
          if (normalizedQuery && !trackedNoResults.has(normalizedQuery)) {
            trackedNoResults.add(normalizedQuery);
            try {
              window.CycloOutletMetrics?.track?.('co_search_no_results', { query: String(query || '').trim().slice(0, 80), placement: 'header_search' });
              window.Shopify?.analytics?.publish?.('co_search_no_results', { query: String(query || '').trim().slice(0, 80), placement: 'header_search' });
            } catch (_) {}
          }
        }
      };

      const schedule = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(update, DEBOUNCE_MS);
      };

      input.addEventListener("input", schedule);
      input.addEventListener("search", schedule);
      input.addEventListener("focus", () => {
        if (input.value.trim().length >= MIN_QUERY) schedule();
      });

      clearButton?.addEventListener("click", (event) => {
        event.preventDefault();
        window.clearTimeout(timer);
        input.value = "";
        clearButton.hidden = true;
        broadcastQuery("");
        close();
        input.focus();
      });

      form.addEventListener("submit", (event) => {
        event.preventDefault();
        const query = input.value.trim();
        if (query) window.location.href = collectionUrl(query);
      });

      document.addEventListener("click", (event) => {
        if (!form.contains(event.target)) close();
      });

      input.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          event.preventDefault();
          close();
          return;
        }
        if (box.hidden) return;
        const links = resultLinks();
        if (!links.length) return;
        if (event.key === "ArrowDown") {
          event.preventDefault();
          setActive(activeIndex + 1);
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          setActive(activeIndex <= 0 ? links.length - 1 : activeIndex - 1);
        } else if (event.key === "Enter" && activeIndex >= 0) {
          event.preventDefault();
          links[activeIndex]?.click();
        }
      });

    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeaderSearch);
  } else {
    initHeaderSearch();
  }

  document.addEventListener("shopify:section:load", initHeaderSearch);
})();
(() => {
  const STORAGE_KEY = "cyclooutlet_quotes_v1";
  const COMPARE_PRESET_KEY = "cyclooutlet_compare_preset_v1";
  const money = value => new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0
  }).format((Number(value || 0)) / 100);

  const readQuotes = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
      return { A: Array.isArray(parsed.A) ? parsed.A : [], B: Array.isArray(parsed.B) ? parsed.B : [] };
    } catch {
      return { A: [], B: [] };
    }
  };

  const writeQuotes = quotes => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(quotes));
    window.dispatchEvent(new CustomEvent("cyclooutlet:quotes-updated"));
  };

  const toast = message => {
    document.querySelector(".co-quote-toast")?.remove();
    const node = document.createElement("div");
    node.className = "co-quote-toast";
    node.textContent = message;
    document.body.appendChild(node);
    window.setTimeout(() => node.remove(), 2400);
  };

  const getProductData = button => {
    const root = button.closest("[data-quote-product]");
    if (!root) return null;
    const select = root.querySelector("[data-variant-select]");
    const variantId = select?.value || root.dataset.quoteVariantId;
    const priceText = root.querySelector("[data-product-price]")?.textContent?.trim();
    const priceCents = Number(root.dataset.quotePriceCents || 0);
    return {
      key: String(variantId || root.dataset.quoteUrl || root.dataset.quoteTitle),
      variantId: variantId ? Number(variantId) : null,
      title: root.dataset.quoteTitle || root.querySelector("h1,h3")?.textContent?.trim() || "Producto CycloOutlet",
      url: root.dataset.quoteUrl || "#",
      image: root.dataset.quoteImage || "",
      family: root.dataset.quoteFamily || "CycloOutlet",
      priceCents: Number.isFinite(priceCents) && priceCents > 0 ? priceCents : parsePrice(priceText || root.dataset.quotePrice || "0"),
      price: priceText || root.dataset.quotePrice || "",
      quantity: 1
    };
  };

  const parsePrice = value => {
    const digits = String(value || "").replace(/[^\d]/g, "");
    return digits ? Number(digits) * 100 : 0;
  };

  const addToQuote = (quoteId, item) => {
    const quotes = readQuotes();
    const target = quotes[quoteId] || [];
    const existing = target.find(line => line.key === item.key);
    if (existing) existing.quantity += 1;
    else target.push(item);
    quotes[quoteId] = target;
    writeQuotes(quotes);
    toast(`Producto agregado a Cotización ${quoteId}`);
  };

  const renderQuotePage = () => {
    const app = document.querySelector("[data-co-quote-app]");
    if (!app) return;
    const quotes = readQuotes();
    ["A", "B"].forEach(id => {
      const box = app.querySelector(`[data-co-quote-items="${id}"]`);
      const totalNode = app.querySelector(`[data-co-quote-total="${id}"]`);
      const lines = quotes[id] || [];
      if (!box) return;
      if (!lines.length) {
        box.innerHTML = `<div class="co-compare-empty">Cotización ${id} sin productos.</div>`;
      } else {
        box.innerHTML = lines.map(line => {
          const safeKey = escapeHtml(line.key);
          return `
          <article class="co-quote-line" data-line-key="${safeKey}">
            <a class="co-line-media" href="${escapeHtml(line.url || '#')}">${line.image ? `<img src="${escapeHtml(line.image)}" alt="">` : `<span></span>`}</a>
            <div class="co-line-copy">
              <a href="${escapeHtml(line.url || '#')}"><strong>${escapeHtml(line.title)}</strong></a>
              <span>${escapeHtml(line.family || "CycloOutlet")} · ${money(line.priceCents)} por unidad</span>
              <div class="co-line-controls" aria-label="Cambiar cantidad">
                <button type="button" data-co-quote-delta="-1" data-co-quote-id="${id}" data-line-key="${safeKey}" aria-label="Disminuir cantidad">−</button>
                <span>${Number(line.quantity || 1)}</span>
                <button type="button" data-co-quote-delta="1" data-co-quote-id="${id}" data-line-key="${safeKey}" aria-label="Aumentar cantidad">+</button>
              </div>
            </div>
            <b>${money(line.priceCents * line.quantity)}</b>
            <button class="co-line-remove" type="button" data-co-remove-line="${id}" data-line-key="${safeKey}" aria-label="Quitar ${escapeHtml(line.title)}">Quitar</button>
          </article>
        `;
        }).join("");
      }
      const total = lines.reduce((sum, line) => sum + Number(line.priceCents || 0) * Number(line.quantity || 1), 0);
      if (totalNode) totalNode.textContent = money(total);
    });
    const totalA = (quotes.A || []).reduce((sum, line) => sum + Number(line.priceCents || 0) * Number(line.quantity || 1), 0);
    const totalB = (quotes.B || []).reduce((sum, line) => sum + Number(line.priceCents || 0) * Number(line.quantity || 1), 0);
    const diff = Math.abs(totalA - totalB);
    app.querySelector("[data-co-summary-a]")?.replaceChildren(document.createTextNode(money(totalA)));
    app.querySelector("[data-co-summary-b]")?.replaceChildren(document.createTextNode(money(totalB)));
    app.querySelector("[data-co-summary-diff]")?.replaceChildren(document.createTextNode(money(diff)));
    const winner = !totalA && !totalB ? "-" : totalA === totalB ? "Empate" : totalA < totalB ? "Cotización A" : "Cotización B";
    app.querySelector("[data-co-summary-winner]")?.replaceChildren(document.createTextNode(winner));
  };

  const escapeHtml = value => String(value || "").replace(/[&<>"']/g, char => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#039;"
  }[char]));


  const updateQuoteLineQuantity = (quoteId, key, delta) => {
    const quotes = readQuotes();
    const id = quoteId === "B" ? "B" : "A";
    const target = quotes[id] || [];
    quotes[id] = target.map(line => {
      if (String(line.key) !== String(key)) return line;
      const nextQuantity = Math.max(0, Number(line.quantity || 1) + Number(delta || 0));
      return { ...line, quantity: nextQuantity };
    }).filter(line => Number(line.quantity || 0) > 0);
    writeQuotes(quotes);
    renderQuotePage();
  };

  const removeQuoteLine = (quoteId, key) => {
    const quotes = readQuotes();
    const id = quoteId === "B" ? "B" : "A";
    quotes[id] = (quotes[id] || []).filter(line => String(line.key) !== String(key));
    writeQuotes(quotes);
    renderQuotePage();
    toast(`Producto quitado de Cotización ${id}`);
  };

  const chooseQuote = async quoteId => {
    const quote = readQuotes()[quoteId] || [];
    const valid = quote.filter(line => line.variantId && line.quantity > 0);
    if (!valid.length) {
      toast(`Cotización ${quoteId} no tiene productos con variante válida`);
      return;
    }
    try {
      await fetch("/cart/clear.js", { method: "POST" });
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: valid.map(line => ({ id: Number(line.variantId), quantity: Number(line.quantity || 1) })) })
      });
      window.location.href = "/checkout";
    } catch {
      window.location.href = `/cart/${valid.map(line => `${line.variantId}:${line.quantity || 1}`).join(",")}`;
    }
  };

  const categoryOf = product => {
    const title = `${product.title || ""} ${product.baseTitle || ""} ${product.categoryHint || ""} ${product.variantTitle || ""} ${product.option1 || ""} ${product.option2 || ""} ${product.option3 || ""} ${product.subcategory || ""} ${(product.specs || []).join(" ")}`.toLowerCase();
    if (product.category && product.category !== "all") return product.category;
    if (title.includes("grupo") || title.includes("groupset")) return "grupos";
    if (title.includes("potencio") || title.includes("potenció") || title.includes("power meter") || title.includes("powermeter") || title.includes("xcadey")) return "potenciometros";
    if (title.includes("maneta") || title.includes("ergopower") || title.includes("sti") || title.includes("shifter") || title.includes("dual control")) return "manetas";
    if (title.includes("pacha") || title.includes("cassette") || title.includes("casete") || title.includes("piñon") || title.includes("pinon") || title.includes("sprocket")) return "cassettes";
    if (title.includes("cadena") || title.includes("cadenilla") || title.includes("chain")) return "cadenas";
    if (title.includes("pedal")) return "pedales";
    if (title.includes("freno") || title.includes("herradura") || title.includes("rotor") || title.includes("disco") || title.includes("zapata") || title.includes("pastilla") || title.includes("caliper") || title.includes("br-")) return "frenos";
    if (title.includes("corona") || title.includes("coronilla") || title.includes("plato") || title.includes("chainring")) return "coronas";
    if (title.includes("biela") || title.includes("crank") || title.includes("crankset") || title.includes("fc-")) return "bielas";
    if (title.includes("coraza") || title.includes("llanta") || title.includes("cubierta") || title.includes("neumatico") || title.includes("tire") || title.includes("continental") || title.includes("grand prix") || title.includes("ultra sport")) return "corazas";
    if (title.includes("tensor") || title.includes("descarrilador") || title.includes("derailleur") || title.includes("rd-") || title.includes("fd-")) return "tensores";
    return "accesorios";
  };

  const initComparator = () => {
    const page = document.querySelector("[data-co-compare-page]");
    if (!page) return;
    const raw = page.querySelector("[data-co-compare-products]")?.textContent || "[]";
    let products = [];
    try { products = JSON.parse(raw).filter(product => product.available !== false); } catch { products = []; }

    const collectionHandlesByCategory = {
      grupos: ["grupos-completos"],
      bielas: ["platos-bielas-y-coronillas"],
      potenciometros: ["potenciometros"],
      manetas: ["manetas-ergopowers"],
      cassettes: ["pachas"],
      cadenas: ["cadenillas"],
      frenos: ["all"],
      pedales: ["pedales"],
      coronas: ["platos-bielas-y-coronillas"],
      tensores: ["tensores", "descarriladores"],
      corazas: ["corazas-y-llantas", "corazas"],
      accesorios: ["accesorios"]
    };
    const hydratedCategories = new Set();
    const formatMoneyCOP = cents => new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(Number(cents || 0) / 100);
    const parseShopifyVariantCents = value => {
      const raw = String(value ?? "0").trim();
      const numeric = Number(raw.replace(/[^0-9.]/g, ""));
      if (!numeric) return 0;
      // Liquid entrega precios en centavos; /products.json entrega precios decimales.
      if (typeof value === "number" || (/^\d+$/.test(raw) && numeric > 1000000)) return Math.round(numeric);
      return Math.round(numeric * 100);
    };
    const normalizeVariantTitle = value => String(value || "").trim();
    const isDefaultVariantTitle = value => !normalizeVariantTitle(value) || /^default title$/i.test(normalizeVariantTitle(value));
    const compactVariantTitle = variant => {
      const title = normalizeVariantTitle(variant.title);
      if (!isDefaultVariantTitle(title)) return title;
      return [variant.option1, variant.option2, variant.option3].filter(Boolean).join(" / ") || "";
    };
    const buildVariantSpecs = (item, variant) => {
      const specs = [];
      const optionLabel = compactVariantTitle(variant);
      if (optionLabel) specs.push(`Variante: ${optionLabel}`);
      [variant.option1, variant.option2, variant.option3].filter(Boolean).forEach((option, index) => specs.push(`Opción ${index + 1}: ${option}`));
      if (variant.sku) specs.push(`SKU: ${variant.sku}`);
      const tags = Array.isArray(item.tags) ? item.tags : [];
      tags.slice(0, 3).forEach(tag => specs.push(tag));
      specs.push("Validación CycloOutlet");
      return [...new Set(specs.filter(Boolean))];
    };
    const variantSubcategoryLabel = product => {
      const raw = `${product?.variantTitle || ""} ${product?.option1 || ""} ${product?.option2 || ""} ${product?.option3 || ""} ${product?.title || ""} ${(product?.specs || []).join(" ")}`.toLowerCase();
      const parts = [];
      const pushUnique = value => {
        const clean = String(value || "").trim();
        if (clean && !parts.includes(clean)) parts.push(clean);
      };
      const tire = raw.match(/\b700\s*[x×\-\/]\s*(23|24|25|26|28|30|32|35|38|40)\b|\b(23|24|25|26|28|30|32|35|38|40)c\b/);
      if (tire) pushUnique(`700x${tire[1] || tire[2]}`);
      const length = raw.match(/\b(160|165|167\.5|170|172\.5|175)\s*(mm)?\b/);
      if (length) pushUnique(`${length[1]}mm`);
      const crank = raw.match(/\b(46|48|50|52|53|54)\s*[\/x\-]\s*(30|32|34|36|39|40)\b/);
      if (crank) pushUnique(`${crank[1]}/${crank[2]}`);
      const cassette = raw.match(/\b(10|11|12|13)\s*[\-\/]\s*(25|28|30|32|34|36|40|42|46|50|51|52)\b/);
      if (cassette) pushUnique(`${cassette[1]}-${cassette[2]}`);
      const rotor = raw.match(/\b(140|160|180|203)\s*mm\b/);
      if (rotor && !parts.includes(`${rotor[1]}mm`)) pushUnique(`${rotor[1]}mm`);
      if (/\b(disco|disc|hidraul|hydraulic|rotor)\b/.test(raw)) pushUnique("Disco");
      if (/\b(herradura|rim|rin|caliper)\b/.test(raw)) pushUnique("Herradura");
      const speed = raw.match(/\b(10|11|12|13)\s*(v|vel|velocidades|speed|x)\b/);
      if (speed) pushUnique(`${speed[1]}v`);
      if (/\b(di2|eps|axs|etap|wireless|electr[oó]nico|electronic)\b/.test(raw)) pushUnique("Electrónico");
      if (parts.length) return parts.slice(0, 4).join(" · ");
      return product?.variantTitle && !isDefaultVariantTitle(product.variantTitle) ? product.variantTitle : "Referencia principal";
    };
    const productEntriesFromShopifyJson = (item, forcedCategory = "") => {
      const variants = Array.isArray(item.variants) ? item.variants : [];
      const availableVariants = variants.filter(variant => variant.available !== false);
      const variantsToUse = availableVariants.length ? availableVariants : variants;
      const image = typeof item.image === "string" ? item.image : (item.image?.src || item.images?.[0]?.src || null);
      const baseTitle = item.title || "Producto CycloOutlet";
      const family = /dura[ -]?ace/i.test(baseTitle) ? "Dura-Ace" : /ultegra/i.test(baseTitle) ? "Ultegra" : /105/i.test(baseTitle) ? "105" : /campagnolo/i.test(baseTitle) ? "Campagnolo" : "CycloOutlet";
      const categoryHint = `${item.product_type || ""} ${item.vendor || ""} ${(item.tags || []).join(" ")}`;
      const makeEntry = variant => {
        const variantTitle = compactVariantTitle(variant);
        const priceCents = Number(variant.priceCents || variant.price_cents || 0) || parseShopifyVariantCents(variant.price);
        const hasNamedVariant = variantTitle && !isDefaultVariantTitle(variantTitle);
        const entryTitle = hasNamedVariant ? `${baseTitle} · ${variantTitle}` : baseTitle;
        const entry = {
          title: entryTitle,
          baseTitle,
          url: `/products/${item.handle}${variant.id ? `?variant=${variant.id}` : ""}`,
          productHandle: item.handle,
          handle: variant.id ? `${item.handle}::${variant.id}` : item.handle,
          priceCents,
          price: priceCents ? formatMoneyCOP(priceCents) : "Consultar",
          image: variant.image?.src || variant.image || image,
          family,
          categoryHint,
          category: forcedCategory,
          available: variant.available !== false,
          variantId: variant.id || null,
          sku: variant.sku || item.handle,
          variantTitle,
          option1: variant.option1 || "",
          option2: variant.option2 || "",
          option3: variant.option3 || "",
          vendor: item.vendor || "CycloOutlet",
          specs: buildVariantSpecs(item, variant)
        };
        entry.subcategory = variantSubcategoryLabel(entry);
        return entry;
      };
      if (!variantsToUse.length) {
        const fallback = makeEntry({ id: null, title: "", price: item.price || 0, available: true, sku: item.handle });
        fallback.handle = item.handle;
        return [fallback];
      }
      return variantsToUse.map(makeEntry);
    };
    const mergeProducts = incoming => {
      incoming.forEach(product => {
        if (!product?.handle) return;
        if (product.productHandle && String(product.handle).includes("::")) {
          products = products.filter(item => !(item.handle === product.productHandle || (item.productHandle === product.productHandle && !String(item.handle || "").includes("::"))));
        }
        const existingIndex = products.findIndex(item => item.handle === product.handle);
        if (existingIndex >= 0) {
          products[existingIndex] = { ...products[existingIndex], ...product, category: product.category || products[existingIndex].category };
        } else {
          products.push(product);
        }
      });
    };
    const hydrateCategory = async categoryName => {
      if (!categoryName || hydratedCategories.has(categoryName)) return;
      hydratedCategories.add(categoryName);
      const handles = collectionHandlesByCategory[categoryName] || [];
      for (const handle of handles) {
        try {
          const response = await fetch(`/collections/${handle}/products.json?limit=250`, { credentials: "same-origin" });
          if (!response.ok) continue;
          const payload = await response.json();
          mergeProducts((payload.products || []).flatMap(product => productEntriesFromShopifyJson(product, categoryName)));
        } catch (error) {}
      }
    };

    const category = page.querySelector("[data-co-compare-category]");
    const subcategory = page.querySelector("[data-co-compare-subcategory]");
    const subcategoryWrap = page.querySelector("[data-co-subcategory-wrap]");
    const empty = page.querySelector("[data-co-compare-empty]");
    const count = page.querySelector("[data-co-compare-count]");
    const selectedTotal = page.querySelector("[data-co-selected-total]");
    const slotSelects = [...page.querySelectorAll("[data-co-slot-select]")];
    const slotSelectWrappers = slotSelects.map(select => select.closest(".co-luxury-chip__search") || select.parentElement);
    const inventory = page.querySelector("[data-co-luxury-inventory]");
    const cards = page.querySelector("[data-co-luxury-cards]");
    const legend = page.querySelector("[data-co-radar-legend]");
    const winner = page.querySelector("[data-co-luxury-winner]");
    const winnerCopy = page.querySelector("[data-co-luxury-copy]");
    const whatsapp = page.querySelector("[data-co-luxury-whatsapp]");
    const table = page.querySelector("[data-co-compare-table]");
    const colors = ["#ff2d2d", "#22c55e", "#2563eb"];
    const categoryNames = {
      grupos: "Grupos completos",
      bielas: "Bielas",
      potenciometros: "Potenciómetros",
      manetas: "Manetas",
      cassettes: "Cassettes / pachas",
      cadenas: "Cadenas",
      frenos: "Frenos",
      pedales: "Pedales",
      coronas: "Coronas / platos",
      tensores: "Tensores y descarriladores",
      corazas: "Corazas / llantas",
      accesorios: "Accesorios"
    };
    const params = new URLSearchParams(window.location.search);
    const cleanComparableLabel = value => String(value || "")
      .replace(/\s+/g, " ")
      .trim();
    const compactBaseTitle = product => cleanComparableLabel(product?.baseTitle || product?.title || "Producto CycloOutlet").split(" · ")[0];
    const cleanSegment = value => cleanComparableLabel(value).replace(/^Variante:\s*/i, "").trim();
    const compactVariantSegments = product => {
      const sub = cleanSegment(product?.subcategory || variantSubcategoryLabel(product || {}));
      if (!sub || sub === "Referencia principal") return [];
      const baseNorm = compactBaseTitle(product).toLowerCase().replace(/\//g, "-");
      return sub.split(" · ").map(cleanSegment).filter(Boolean).filter((part, index, arr) => {
        const norm = part.toLowerCase().replace(/\//g, "-");
        return arr.findIndex(other => other.toLowerCase().replace(/\//g, "-") === norm) === index && !baseNorm.includes(norm);
      }).slice(0, 4);
    };
    const itemLabel = product => {
      const base = compactBaseTitle(product);
      const details = compactVariantSegments(product).join(" · ");
      return details ? `${base} · ${details}` : base;
    };
    const itemOptionLabel = product => `${itemLabel(product)}${product?.price ? ` — ${product.price}` : ""}`;
    const technicalLine = product => {
      const parts = [...compactVariantSegments(product), product?.family].filter(Boolean);
      return [...new Set(parts)].join(" · ") || "Validación CycloOutlet";
    };
    const itemMatchesValue = (product, value) => product && value && (product.handle === value || product.productHandle === value || String(product.variantId || "") === String(value));
    const findProductByValue = (list, value) => list.find(product => itemMatchesValue(product, value)) || products.find(product => itemMatchesValue(product, value));
    const subcategoryOf = product => product?.subcategory || variantSubcategoryLabel(product || {});
    const updateSubcategoryOptions = categoryProducts => {
      if (!subcategory || !subcategoryWrap) return "";
      const values = [...new Set(categoryProducts.map(subcategoryOf).filter(Boolean))].filter(value => value !== "Referencia principal");
      subcategoryWrap.hidden = values.length <= 1;
      const previous = subcategory.value;
      subcategory.innerHTML = `<option value="">Todas las variantes</option>` + values.map(value => `<option value="${escapeHtml(value)}">${escapeHtml(value)}</option>`).join("");
      if (values.includes(previous)) subcategory.value = previous;
      return subcategory.value || "";
    };
    const filterBySubcategory = categoryProducts => {
      const value = subcategory?.value || "";
      return value ? categoryProducts.filter(product => subcategoryOf(product) === value) : categoryProducts;
    };

    const metricConfig = categoryName => window.CycloOutletComparatorMatrix?.metricConfig?.(categoryName) || ({
      grupos: {
        labels: ["Cambio", "Peso", "Frenado", "Valor", "Electrónica", "Compatibilidad"],
        copy: "Evalúa el grupo completo con criterios técnicos: precisión de cambio, peso estimado, tipo de freno, valor, presencia real de electrónica y compatibilidad."
      },
      bielas: {
        labels: ["Rigidez", "Peso", "Compatibilidad", "Relacion", "Potencia", "Valor"],
        copy: "Prioriza rigidez, largo/relacion, compatibilidad de eje y si integra medición de potencia."
      },
      potenciometros: {
        labels: ["Precisión", "Peso", "Compatibilidad", "Batería", "Conectividad", "Valor"],
        copy: "Compara precisión, compatibilidad de biela/eje, autonomía, conectividad y valor real."
      },
      cassettes: {
        labels: ["Rango", "Saltos", "Peso", "Durabilidad", "Compatibilidad", "Valor"],
        copy: "Compara rango util, progresion entre coronas, peso, desgaste y compatibilidad 11v/12v."
      },
      cadenas: {
        labels: ["Friccion", "Durabilidad", "Cambio", "Compatibilidad", "Peso", "Valor"],
        copy: "Compara friccion, vida util, suavidad de cambio, compatibilidad y costo de reposicion."
      },
      frenos: {
        labels: ["Potencia", "Modulacion", "Peso", "Disipacion", "Compatibilidad", "Valor"],
        copy: "Compara potencia, control, disipacion termica, peso y compatibilidad disco/rin."
      },
      pedales: {
        labels: ["Plataforma", "Peso", "Rodamiento", "Compatibilidad", "Durabilidad", "Valor"],
        copy: "Compara plataforma, peso, rodamiento, compatibilidad de calas y valor."
      },
      coronas: {
        labels: ["Cambio", "Peso", "Compatibilidad", "Relacion", "Durabilidad", "Valor"],
        copy: "Compara relación, compatibilidad BCD/serie, peso, cambio y durabilidad."
      },
      manetas: {
        labels: ["Ergonomia", "Precision", "Peso", "Integracion", "Compatibilidad", "Valor"],
        copy: "Compara tacto, ergonomia, precision de cambio/freno e integracion mecanica o Di2."
      },
      tensores: {
        labels: ["Precision", "Capacidad", "Peso", "Compatibilidad", "Durabilidad", "Valor"],
        copy: "Compara precision de cambio, capacidad de pacha, compatibilidad, peso y robustez."
      },
      corazas: {
        labels: ["Rodadura", "Agarre mojado", "Pinchazos", "Peso", "Ancho/volumen", "Valor"],
        copy: "Compara como una prueba técnica de llantas: rodadura, agarre, proteccion, peso, volumen real y precio."
      },
      accesorios: {
        labels: ["Función", "Compatibilidad", "Uso", "Durabilidad", "Originalidad", "Valor"],
        copy: "Compara función real, compatibilidad, facilidad de uso, durabilidad, origen/marca y valor."
      }
    }[categoryName] || {
      labels: ["Función", "Compatibilidad", "Uso", "Durabilidad", "Originalidad", "Valor"],
      copy: "Compara criterios generales de compra y compatibilidad."
    });

    const getCategory = () => category?.value || "grupos";

    const priceScore = (product, categoryName) => {
      const price = Number(product.priceCents || 0);
      if (!price) return 70;
      if (categoryName === "grupos") return price < 350000000 ? 94 : price < 700000000 ? 78 : 58;
      if (categoryName === "corazas") return price < 25000000 ? 92 : price < 42000000 ? 80 : 66;
      if (categoryName === "bielas") return price < 60000000 ? 92 : price < 150000000 ? 80 : 64;
      if (categoryName === "potenciometros") return price < 120000000 ? 90 : price < 180000000 ? 78 : 64;
      if (categoryName === "pedales") return price < 40000000 ? 90 : price < 90000000 ? 78 : 64;
      if (categoryName === "coronas") return price < 15000000 ? 92 : price < 60000000 ? 80 : 64;
      return price < 50000000 ? 92 : price < 150000000 ? 78 : 62;
    };

    const clampScore = value => Math.max(8, Math.min(99, Math.round(Number(value || 0))));

    const productScore = (product, categoryName = getCategory()) => {
      const matrixScore = window.CycloOutletComparatorMatrix?.score?.(product, categoryName);
      if (Array.isArray(matrixScore) && matrixScore.length === 6) return matrixScore;
      const title = `${product.title || ""} ${product.baseTitle || ""} ${product.variantTitle || ""} ${product.option1 || ""} ${product.option2 || ""} ${product.option3 || ""} ${product.subcategory || ""} ${(product.specs || []).join(" ")}`.toLowerCase();
      const family = String(product.family || "").toLowerCase();
      const value = priceScore(product, categoryName);
      const isDura = family.includes("dura") || title.includes("dura");
      const isUltegra = family.includes("ultegra") || title.includes("ultegra");
      const is105 = family.includes("105") || title.includes("105");
      const isDi2 = title.includes("di2") || title.includes("electron");
      const isCarbon = title.includes("carbono") || title.includes("carbon");
      const isDisc = title.includes("disco") || title.includes("rotor") || title.includes("hidraul") || title.includes("hydraulic");
      const isTubeless = title.includes("tubeless") || title.includes(" tr") || title.includes("str");

      if (categoryName === "grupos") {
        const isElectronic = isDi2 || title.includes("eps") || title.includes("etap") || title.includes("axs") || title.includes("wireless") || title.includes("electronico") || title.includes("electrónico");
        const isRim = title.includes("herradura") || title.includes("rin") || title.includes("rim") || title.includes("caliper");
        const is12 = /(^|\D)12\s*(v|vel|speed|x)/.test(title) || title.includes("12v") || title.includes("12 velocidades");
        const is11 = /(^|\D)11\s*(v|vel|speed|x)/.test(title) || title.includes("11v") || title.includes("11 velocidades");
        const isCampy = family.includes("campagnolo") || title.includes("campagnolo");
        const cambioBase = isDura ? 94 : isUltegra ? 88 : is105 ? 79 : isCampy ? 90 : 74;
        const pesoBase = isDura ? 96 : isUltegra ? 88 : is105 ? 78 : isCampy ? 86 : 72;
        const compatBase = is105 || isUltegra || isDura ? 90 : isCampy ? 82 : 76;
        return [
          clampScore(cambioBase + (isElectronic ? 5 : 0) + (is12 ? 2 : 0) - (is11 ? 1 : 0)),
          clampScore(pesoBase + (isRim ? 4 : 0) - (isDisc ? 7 : 0) - (isElectronic ? 5 : 0) - (is12 ? 1 : 0)),
          clampScore(isDisc ? 94 : isRim ? 78 : 82),
          value,
          clampScore(isElectronic ? (isDura ? 98 : isUltegra ? 94 : is105 ? 88 : 86) : 18),
          clampScore(compatBase + (is12 ? 3 : 0) - (isElectronic ? 3 : 0))
        ];
      }

      if (categoryName === "corazas") {
        const isGp5000 = title.includes("5000") || title.includes("gp5000");
        const isGrandPrix = title.includes("grand prix");
        const isFourSeason = title.includes("4 estaciones") || title.includes("four season");
        const isUltra = title.includes("ultra sport");
        const widthMatch = title.match(/\b(23|25|26|28|30|32)\b|(\d{2})c/);
        const width = widthMatch ? Number(widthMatch[1] || widthMatch[2]) : 0;
        const widthScore = width >= 28 && width <= 30 ? 94 : width === 32 ? 88 : width === 25 || width === 26 ? 82 : width === 23 ? 66 : 78;
        return [
          isGp5000 ? 96 : isGrandPrix ? 84 : isUltra ? 72 : 78,
          isFourSeason ? 92 : isGp5000 ? 88 : isGrandPrix ? 80 : isUltra ? 68 : 76,
          isFourSeason ? 96 : isTubeless ? 86 : isGp5000 ? 78 : isGrandPrix ? 76 : 66,
          isGp5000 ? 90 : isUltra ? 82 : isTubeless ? 76 : isFourSeason ? 70 : 74,
          widthScore,
          value
        ];
      }

      if (categoryName === "bielas") return [
        isDura ? 98 : isUltegra ? 92 : is105 ? 82 : 76,
        isCarbon ? 96 : isDura ? 92 : isUltegra ? 86 : 74,
        is105 || isUltegra || isDura ? 92 : 76,
        title.includes("50/34") || title.includes("52/36") || title.includes("53/39") ? 94 : 78,
        title.includes("potencio") || title.includes("power") ? 98 : 66,
        value
      ];

      if (categoryName === "potenciometros") return [
        title.includes("dual") ? 96 : title.includes("xcadey") || title.includes("stages") || title.includes("4iiii") ? 88 : 80,
        isDura ? 92 : isUltegra ? 86 : is105 ? 80 : 76,
        is105 || isUltegra || isDura || title.includes("shimano") ? 92 : 78,
        title.includes("recarg") || title.includes("usb") ? 88 : 78,
        title.includes("bluetooth") || title.includes("ant") || title.includes("di2") ? 92 : 82,
        value
      ];

      if (categoryName === "cassettes") return [
        title.includes("34") || title.includes("36") ? 94 : title.includes("30") || title.includes("32") ? 84 : 72,
        isDura ? 94 : isUltegra ? 88 : is105 ? 80 : 74,
        isDura ? 94 : isUltegra ? 86 : 78,
        is105 ? 92 : isUltegra ? 88 : isDura ? 82 : 78,
        title.includes("12") ? 92 : title.includes("11") ? 84 : 74,
        value
      ];

      if (categoryName === "cadenas") return [
        isDura ? 92 : isUltegra ? 88 : is105 ? 82 : 76,
        is105 ? 92 : isUltegra ? 88 : isDura ? 82 : 76,
        isDura || isUltegra ? 92 : 82,
        title.includes("12") ? 92 : title.includes("11") ? 84 : 76,
        isDura ? 92 : isUltegra ? 86 : 78,
        value
      ];

      if (categoryName === "frenos") return [
        isDisc ? 94 : 78,
        isDura ? 96 : isUltegra ? 90 : is105 ? 82 : 76,
        isDura ? 94 : isUltegra ? 86 : 78,
        isDisc ? 92 : 72,
        isDisc || title.includes("herradura") ? 90 : 74,
        value
      ];

      if (categoryName === "pedales") return [
        title.includes("carbon") || isDura ? 94 : isUltegra ? 88 : is105 ? 82 : 76,
        isDura ? 94 : isUltegra ? 86 : 78,
        title.includes("dura") || title.includes("ultegra") ? 92 : 80,
        title.includes("spd") || title.includes("look") || title.includes("shimano") ? 90 : 76,
        is105 ? 88 : isUltegra ? 90 : isDura ? 86 : 78,
        value
      ];

      if (categoryName === "coronas") return [
        isDura ? 96 : isUltegra ? 90 : is105 ? 84 : 76,
        isDura ? 92 : isUltegra ? 84 : 76,
        is105 || isUltegra || isDura ? 94 : 76,
        title.includes("50") || title.includes("52") || title.includes("53") || title.includes("34") || title.includes("36") || title.includes("39") ? 92 : 78,
        is105 ? 92 : isUltegra ? 88 : isDura ? 84 : 78,
        value
      ];

      if (categoryName === "manetas") return [
        isDura ? 96 : isUltegra ? 92 : is105 ? 84 : 76,
        isDi2 ? 96 : 82,
        isDura ? 94 : isUltegra ? 86 : 78,
        isDi2 ? 96 : 74,
        is105 || isUltegra || isDura ? 92 : 76,
        value
      ];

      if (categoryName === "tensores") return [
        isDi2 ? 96 : isDura ? 94 : isUltegra ? 90 : 82,
        title.includes("gs") || title.includes("largo") ? 92 : 78,
        isDura ? 94 : isUltegra ? 86 : 78,
        is105 || isUltegra || isDura ? 92 : 76,
        is105 ? 92 : isUltegra ? 88 : isDura ? 82 : 78,
        value
      ];

      if (categoryName === "accesorios") return [
        title.includes("bateria") || title.includes("cargador") || title.includes("adaptador") || title.includes("cable") || title.includes("soporte") ? 88 : 76,
        is105 || isUltegra || isDura || title.includes("shimano") || title.includes("specialized") || title.includes("garmin") ? 90 : 74,
        title.includes("adaptador") || title.includes("cable") || title.includes("soporte") ? 90 : 78,
        title.includes("original") || title.includes("shimano") || title.includes("specialized") ? 88 : 76,
        title.includes("original") || title.includes("oem") || title.includes("shimano") || title.includes("specialized") || title.includes("garmin") ? 92 : 72,
        value
      ];

      let score = [76, 76, 78, 78, 74, value];
      if (is105) score = [82, 88, 84, 82, 88, value];
      if (isUltegra) score = [90, 90, 86, 86, 90, value];
      if (isDura) score = [94, 92, 88, 84, 92, value];
      if (family.includes("campagnolo")) score = [90, 80, 78, 86, 82, value];
      return score;
    };

    const averageScore = (product, categoryName = getCategory()) => {
      const scores = productScore(product, categoryName);
      return Math.round(scores.reduce((sum, value) => sum + value, 0) / scores.length);
    };

    const radarPoint = (score, index) => {
      const angle = (-90 + index * 60) * Math.PI / 180;
      const radius = 224 * Number(score || 0) / 100;
      return `${(310 + Math.cos(angle) * radius).toFixed(1)},${(286 + Math.sin(angle) * radius).toFixed(1)}`;
    };

    const paint = async () => {
      await hydrateCategory(category.value);
      const categoryProducts = products.filter(product => categoryOf(product) === category.value);
      updateSubcategoryOptions(categoryProducts);
      const filtered = filterBySubcategory(categoryProducts);
      if (count) count.textContent = `${filtered.length} referencias disponibles${categoryProducts.length !== filtered.length ? ` de ${categoryProducts.length}` : ""}`;
      if (empty) empty.hidden = filtered.length > 0;
      const config = metricConfig(getCategory());
      page.querySelectorAll("[data-co-radar-label]").forEach((label, index) => {
        label.textContent = (config.labels[index] || "").toUpperCase();
      });
      slotSelects.forEach((select, index) => {
        const previous = select.value;
        const placeholder = `<option value="">Seleccionar referencia / variante...</option>`;
        select.innerHTML = filtered.length
          ? placeholder + filtered.map(product => `<option value="${escapeHtml(product.handle)}">${escapeHtml(itemOptionLabel(product))}</option>`).join("")
          : `<option value="">Sin referencias disponibles</option>`;
        const previousMatch = filtered.find(product => itemMatchesValue(product, previous));
        if (previousMatch) {
          select.value = previousMatch.handle;
        } else if (select.dataset.keepEmpty === "true") {
          select.value = "";
        } else {
          select.value = filtered[index]?.handle || filtered[0]?.handle || "";
        }
      });
      renderInventory(filtered);
      renderSlots(filtered);
    };

    const renderInventory = filtered => {
      if (!inventory) return;
      inventory.innerHTML = filtered.slice(0, 18).map((product, index) => `
        <button type="button" data-co-inventory-handle="${escapeHtml(product.handle)}">
          <span style="--dot:${colors[index % colors.length]}"></span>
          ${product.image ? `<img src="${product.image}" alt="">` : ""}
          <b>${escapeHtml(itemLabel(product))}</b>
          <small>${escapeHtml([product.subcategory || variantSubcategoryLabel(product), product.family || "CycloOutlet"].filter(Boolean).join(" · "))}</small>
        </button>
      `).join("") || `<p>No hay inventario disponible para esta categoría.</p>`;
    };

    const setProductInSlot = (handle, preferredSlot = 0) => {
      const select = slotSelects[preferredSlot] || slotSelects[0];
      if (!select || ![...select.options].some(option => option.value === handle)) return;
      select.value = handle;
      renderSlots(filterBySubcategory(products.filter(product => categoryOf(product) === category.value)));
    };

    const readPreset = () => {
      const urlHandles = [params.get("a"), params.get("b"), params.get("c")].filter(Boolean);
      const urlCategory = params.get("category") || "";
      if (urlHandles.length) return { category: urlCategory, handles: urlHandles, source: "url" };
      try {
        const stored = JSON.parse(sessionStorage.getItem(COMPARE_PRESET_KEY) || "null");
        const handles = [stored?.a, stored?.b, stored?.c].filter(Boolean);
        if (handles.length) return { category: stored?.category || "", handles, source: "session" };
      } catch (error) {}
      return { category: urlCategory, handles: [], source: "none" };
    };

    const inferPresetCategory = (presetCategory, handles) => {
      const allowed = [...category.options].map(option => option.value);
      const foundProducts = handles.map(handle => findProductByValue(products, handle)).filter(Boolean);
      const inferred = foundProducts[0] ? categoryOf(foundProducts[0]) : "";
      const validPreset = allowed.includes(presetCategory) ? presetCategory : "";
      if (validPreset && handles.some(handle => products.some(product => itemMatchesValue(product, handle) && categoryOf(product) === validPreset))) {
        return validPreset;
      }
      if (inferred && allowed.includes(inferred)) return inferred;
      return validPreset || category.value || "grupos";
    };

    const populateCategory = async categoryName => {
      if (categoryName && [...category.options].some(option => option.value === categoryName)) {
        category.value = categoryName;
      }
      await hydrateCategory(category.value);
      await paint();
      return products.filter(product => categoryOf(product) === category.value);
    };

    const applyPresetFromQuery = async () => {
      const preset = readPreset();
      if (!preset.handles.length) {
        const categoryParam = params.get("category");
        if (categoryParam && [...category.options].some(option => option.value === categoryParam)) {
          category.value = categoryParam;
        }
        return false;
      }
      const desiredCategory = inferPresetCategory(preset.category, preset.handles);
      const filtered = await populateCategory(desiredCategory);
      slotSelects.forEach(select => {
        select.dataset.keepEmpty = "true";
        select.value = "";
      });
      preset.handles.forEach((handle, index) => {
        const select = slotSelects[index];
        const product = findProductByValue(filtered, handle) || findProductByValue(products, handle);
        if (select && product) {
          if (![...select.options].some(option => option.value === product.handle)) {
            select.add(new Option(itemOptionLabel(product), product.handle));
          }
          select.value = product.handle;
          delete select.dataset.keepEmpty;
        }
      });
      renderSlots(filtered);
      return true;
    };

    const selectedProductsBySlot = filtered => slotSelects.map(select => {
      const value = select?.value || "";
      return findProductByValue(filtered, value) || findProductByValue(products, value) || null;
    });

    const renderSlots = filtered => {
      const categoryName = getCategory();
      const config = metricConfig(categoryName);
      const slotProducts = selectedProductsBySlot(filtered);
      const selected = slotProducts.filter(Boolean);
      if (selectedTotal) selectedTotal.textContent = String(selected.length);
      slotSelects.forEach((select, index) => {
        const product = slotProducts[index];
        const chip = page.querySelector(`[data-co-slot="${index}"]`);
        const image = page.querySelector(`[data-co-chip-image="${index}"]`);
        if (chip) {
          chip.style.setProperty("--slot-color", colors[index]);
          chip.classList.toggle("is-filled", Boolean(product));
          const titleNode = chip.querySelector(`[data-co-chip-title="${index}"]`);
          const familyNode = chip.querySelector(`[data-co-chip-family="${index}"]`);
          const priceNode = chip.querySelector(`[data-co-chip-price="${index}"]`);
          if (titleNode) titleNode.textContent = product ? itemLabel(product) : "Producto por seleccionar";
          if (familyNode) familyNode.textContent = product ? (product.family || categoryNames[categoryName] || "CycloOutlet") : "Color comparativo";
          if (priceNode) priceNode.textContent = product?.price || "";
        }
        if (image && product?.image) {
          image.src = product.image;
          image.alt = product.title || "";
          image.hidden = false;
          image.removeAttribute("aria-hidden");
        } else if (image) {
          image.hidden = true;
          image.setAttribute("aria-hidden", "true");
          image.removeAttribute("src");
          image.removeAttribute("srcset");
          image.alt = "";
        }
      });
      renderRadar(slotProducts, categoryName, config);
      renderCards(slotProducts, categoryName, config);
      renderWinner(selected, categoryName, config);
      if (!table) return;
      if (!selected.length) {
        table.innerHTML = "";
        return;
      }
      const selectedScores = selected.map(product => productScore(product, categoryName));
      table.innerHTML = `
        <table class="co-compare-table">
          <thead><tr><th>Dato</th>${selected.map(product => `<th>${escapeHtml(itemLabel(product))}</th>`).join("")}</tr></thead>
          <tbody>
            <tr><th>Categoria</th>${selected.map(() => `<td>${escapeHtml(categoryNames[categoryName] || "Comparacion")}</td>`).join("")}</tr>
            <tr><th>Precio</th>${selected.map(product => `<td>${escapeHtml(product.price)}</td>`).join("")}</tr>
            <tr><th>Variante / subcategoría</th>${selected.map(product => `<td>${escapeHtml(product.subcategory || product.variantTitle || "Referencia principal")}</td>`).join("")}</tr>
            <tr><th>Familia</th>${selected.map(product => `<td>${escapeHtml(product.family)}</td>`).join("")}</tr>
            <tr><th>Score radar</th>${selected.map(product => `<td>${averageScore(product, categoryName)}/100</td>`).join("")}</tr>
            ${config.labels.map((label, metricIndex) => `<tr><th>${escapeHtml(label)}</th>${selected.map((product, productIndex) => `<td>${selectedScores[productIndex][metricIndex]}/100</td>`).join("")}</tr>`).join("")}
            <tr><th>SKU / referencia</th>${selected.map(product => `<td>${escapeHtml(product.sku || product.vendor || "Validar")}</td>`).join("")}</tr>
            <tr><th>Especificaciones</th>${selected.map(product => `<td>${(product.specs || []).map(escapeHtml).join("<br>")}</td>`).join("")}</tr>
            <tr><th>Disponibilidad</th>${selected.map(() => `<td>Disponible para validar</td>`).join("")}</tr>
          </tbody>
        </table>
      `;
    };

    const renderRadar = (slotProducts, categoryName, config) => {
      const polygons = [...page.querySelectorAll("[data-co-radar-series]")];
      page.querySelectorAll("[data-co-radar-label]").forEach((label, index) => {
        label.textContent = (config.labels[index] || "").toUpperCase();
      });
      polygons.forEach((polygon, index) => {
        const product = slotProducts[index] || null;
        polygon.style.setProperty("--series-color", colors[index]);
        polygon.removeAttribute("hidden");
        if (product) {
          polygon.setAttribute("points", productScore(product, categoryName).map(radarPoint).join(" "));
          polygon.classList.remove("is-empty");
        } else {
          polygon.setAttribute("points", "");
          polygon.classList.add("is-empty");
        }
      });
      if (legend) {
        legend.innerHTML = slotProducts.map((product, index) => product ? `
          <span style="--legend:${colors[index]}"><b>${index + 1}</b>${escapeHtml(product.family || product.title)}</span>
        ` : "").join("");
      }
    };

    const mountSlotSelects = () => {
      if (!cards) return;
      slotSelectWrappers.forEach((wrapper, index) => {
        const mount = cards.querySelector(`[data-co-slot-proxy="${index}"]`);
        if (!wrapper || !mount) return;
        wrapper.classList.add("co-luxury-chip__search--inline");
        mount.innerHTML = "";
        mount.appendChild(wrapper);
      });
    };

    const renderCards = (slotProducts, categoryName, config) => {
      if (!cards) return;
      cards.innerHTML = slotProducts.map((product, slotIndex) => {
        const hasProduct = Boolean(product);
        const scores = hasProduct ? productScore(product, categoryName) : config.labels.map(() => 0);
        const safeTitle = hasProduct ? escapeHtml(itemLabel(product)) : `Referencia ${slotIndex + 1} por seleccionar`;
        const safeFamily = hasProduct ? escapeHtml(categoryNames[categoryName] || product.family || "CycloOutlet") : escapeHtml(categoryNames[categoryName] || "CycloOutlet");
        const safeTech = hasProduct ? escapeHtml(technicalLine(product)) : "Usa la búsqueda de arriba para elegir un producto de esta categoría.";
        const safePrice = hasProduct ? escapeHtml(product.price) : "";
        const mediaHtml = hasProduct && product.image ? `<div class="co-luxury-product__media"><img src="${product.image}" alt=""><span>${slotIndex + 1}</span></div>` : `<div class="co-luxury-product__media is-empty"><span>${slotIndex + 1}</span><i data-lucide="search"></i></div>`;
        return `
          <article class="co-luxury-product co-luxury-product--compare-slot ${hasProduct ? "is-filled" : "is-empty"}" style="--slot-color:${colors[slotIndex]}"
            ${hasProduct ? `data-quote-product
            data-quote-title="${safeTitle}"
            data-quote-url="${escapeHtml(product.url)}"
            data-quote-image="${escapeHtml(product.image || "")}"
            data-quote-variant-id="${escapeHtml(product.variantId)}"
            data-quote-price-cents="${escapeHtml(product.priceCents)}"
            data-quote-price="${escapeHtml(product.price)}"
            data-quote-family="${safeFamily}"` : ""}>
            <div class="co-luxury-slotbar">
              <div class="co-luxury-slotbar__badge"><span>${slotIndex + 1}</span></div>
              <div class="co-luxury-slotbar__select" data-co-slot-proxy="${slotIndex}"></div>
            </div>
            ${mediaHtml}
            <div class="co-luxury-product__body">
              <div class="co-luxury-inline-meta">
                <small>${safeTech}</small>
                ${hasProduct ? `<strong data-product-price>${safePrice}</strong>` : `<strong data-product-price class="is-placeholder">Selecciona la referencia</strong>`}
              </div>
              <div class="co-luxury-actions">
                ${hasProduct ? `<a href="${product.url}">Ficha técnica</a>
                <button type="button" data-cart-add data-variant-id="${escapeHtml(product.variantId)}">Comprar</button>
                ` : `<button type="button" disabled>Ficha técnica</button>
                <button type="button" disabled>Comprar</button>
                `}
              </div>
            </div>
          </article>
        `;
      }).join("");
      mountSlotSelects();
      if (window.lucide?.createIcons) window.lucide.createIcons();
    };

    const renderWinner = (selected, categoryName, config) => {
      if (!selected.length) return;
      const ranked = [...selected].sort((a, b) => averageScore(b, categoryName) - averageScore(a, categoryName));
      const best = ranked[0];
      if (winner) winner.textContent = best.title;
      if (winnerCopy) winnerCopy.textContent = `${config.copy} Lectura técnica del set: ${itemLabel(best)} alcanza ${averageScore(best, categoryName)}/100 en estos criterios. Valida medida, compatibilidad y disponibilidad antes de cerrar la compra.`;
      if (whatsapp) {
        const list = selected.map(product => `${itemLabel(product)} (${product.price})`).join(" vs ");
        whatsapp.href = "https://wa.me/573142533532?text=" + encodeURIComponent(`Hola CycloOutlet, estoy comparando: ${list}. Quiero validar compatibilidad y diferencias técnicas.`);
      }
    };

    const currentFilteredProducts = () => filterBySubcategory(products.filter(product => categoryOf(product) === category.value));
    let visualSyncTimer;
    const syncComparatorVisual = () => {
      clearTimeout(visualSyncTimer);
      const paintNow = () => renderSlots(currentFilteredProducts());
      paintNow();
      requestAnimationFrame(paintNow);
      visualSyncTimer = setTimeout(paintNow, 90);
      setTimeout(paintNow, 260);
    };

    category.addEventListener("change", () => { if (subcategory) subcategory.value = ""; paint(); });
    subcategory?.addEventListener("change", () => { paint(); });
    slotSelects.forEach(select => {
      ["change", "input", "co:slot-sync"].forEach(eventName => {
        select.addEventListener(eventName, () => {
          delete select.dataset.keepEmpty;
          syncComparatorVisual();
        });
      });
    });
    window.addEventListener("cyclooutlet:comparator-reference-changed", syncComparatorVisual);
    inventory?.addEventListener("click", event => {
      const button = event.target.closest("[data-co-inventory-handle]");
      if (!button) return;
      const selectedHandles = slotSelects.map(select => select.value);
      const firstAvailable = selectedHandles.findIndex(handle => handle === button.dataset.coInventoryHandle);
      const slot = firstAvailable >= 0 ? firstAvailable : 0;
      setProductInSlot(button.dataset.coInventoryHandle, slot);
    });
    page.querySelector("[data-co-reset-compare]")?.addEventListener("click", () => {
      slotSelects.forEach(select => {
        select.dataset.keepEmpty = "true";
        select.value = "";
      });
      page.querySelectorAll("[data-co-chip-image]").forEach(image => {
        image.hidden = true;
        image.setAttribute("aria-hidden", "true");
        image.removeAttribute("src");
        image.removeAttribute("srcset");
        image.alt = "";
      });
      renderSlots(filterBySubcategory(products.filter(product => categoryOf(product) === category.value)));
    });
    applyPresetFromQuery().then(applied => {
      if (!applied) paint();
    });
  };

  document.addEventListener("click", event => {
    const quoteButton = event.target.closest("[data-quote-add]");
    if (quoteButton) {
      const item = getProductData(quoteButton);
      if (item) addToQuote(quoteButton.dataset.quoteAdd, item);
    }
    const clearButton = event.target.closest("[data-co-clear-quote]");
    if (clearButton) {
      const quotes = readQuotes();
      quotes[clearButton.dataset.coClearQuote] = [];
      writeQuotes(quotes);
      renderQuotePage();
    }
    const deltaButton = event.target.closest("[data-co-quote-delta]");
    if (deltaButton) {
      event.preventDefault();
      updateQuoteLineQuantity(deltaButton.dataset.coQuoteId, deltaButton.dataset.lineKey, Number(deltaButton.dataset.coQuoteDelta || 0));
    }
    const removeButton = event.target.closest("[data-co-remove-line]");
    if (removeButton) {
      event.preventDefault();
      removeQuoteLine(removeButton.dataset.coRemoveLine, removeButton.dataset.lineKey);
    }
    const chooseButton = event.target.closest("[data-co-choose-quote]");
    if (chooseButton) chooseQuote(chooseButton.dataset.coChooseQuote);
  });

  window.addEventListener("cyclooutlet:quotes-updated", renderQuotePage);
  document.addEventListener("DOMContentLoaded", () => {
    initComparator();
    renderQuotePage();
  });
})();
(() => {
  const COMPARE_PRESET_KEY = "cyclooutlet_compare_preset_v1";

  const normalize = value => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  const parseCents = value => Number(String(value || "0").replace(/[^\d]/g, "")) || 0;
  const formatMoney = cents => new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0
  }).format((Number(cents || 0)) / 100);

  const metricConfig = categoryName => window.CycloOutletComparatorMatrix?.metricConfig?.(categoryName)?.labels || ({
    grupos: ["Cambio", "Peso", "Frenado", "Valor", "Electrónica", "Compatibilidad"],
    bielas: ["Rigidez", "Peso", "Compatibilidad", "Relación", "Potencia", "Valor"],
    potenciometros: ["Precisión", "Peso", "Compatibilidad", "Batería", "Uso", "Valor"],
    cassettes: ["Rango", "Saltos", "Peso", "Durabilidad", "Compatibilidad", "Valor"],
    cadenas: ["Fricción", "Durabilidad", "Cambio", "Compatibilidad", "Peso", "Valor"],
    frenos: ["Potencia", "Modulación", "Peso", "Disipación", "Compatibilidad", "Valor"],
    manetas: ["Ergonomía", "Precisión", "Peso", "Integración", "Compatibilidad", "Valor"],
    tensores: ["Precisión", "Capacidad", "Peso", "Compatibilidad", "Durabilidad", "Valor"],
    corazas: ["Rodadura", "Agarre", "Pinchazos", "Peso", "Volumen", "Valor"],
    pedales: ["Transferencia", "Peso", "Agarre", "Durabilidad", "Compatibilidad", "Valor"],
    coronas: ["Relación", "Rigidez", "Peso", "Cambio", "Compatibilidad", "Valor"],
    accesorios: ["Función", "Compatibilidad", "Uso", "Durabilidad", "Originalidad", "Valor"]
  }[categoryName] || ["Función", "Compatibilidad", "Uso", "Durabilidad", "Originalidad", "Valor"]);

  const priceScore = (item, categoryName) => {
    const price = Number(item.priceCents || 0);
    if (!price) return 70;
    if (categoryName === "grupos") return price < 350000000 ? 94 : price < 700000000 ? 78 : 58;
    if (categoryName === "corazas") return price < 25000000 ? 92 : price < 42000000 ? 80 : 66;
    if (categoryName === "bielas" || categoryName === "potenciometros") return price < 60000000 ? 92 : price < 150000000 ? 80 : 64;
    return price < 50000000 ? 92 : price < 150000000 ? 78 : 62;
  };

  const clampScore = value => Math.max(8, Math.min(99, Math.round(Number(value || 0))));

  const scoreProduct = item => {
    const matrixScore = window.CycloOutletComparatorMatrix?.score?.(item, item?.category || "accesorios");
    if (Array.isArray(matrixScore) && matrixScore.length === 6) return matrixScore;
    const categoryName = item.category || "accesorios";
    const title = normalize(`${item.title || ""} ${item.baseTitle || ""} ${item.variantTitle || ""} ${item.family || ""} ${item.sku || ""}`);
    const family = normalize(item.family || "");
    const value = priceScore(item, categoryName);
    const isDura = family.includes("dura") || title.includes("dura");
    const isUltegra = family.includes("ultegra") || title.includes("ultegra");
    const is105 = family.includes("105") || title.includes("105");
    const isDi2 = title.includes("di2") || title.includes("electron");
    const isCarbon = title.includes("carbono") || title.includes("carbon");
    const isDisc = title.includes("disco") || title.includes("rotor") || title.includes("hidraul") || title.includes("hydraulic");
    const isTubeless = title.includes("tubeless") || title.includes(" tr") || title.includes("str");

    if (categoryName === "grupos") {
      const isElectronic = isDi2 || title.includes("eps") || title.includes("etap") || title.includes("axs") || title.includes("wireless") || title.includes("electronico") || title.includes("electrónico");
      const isRim = title.includes("herradura") || title.includes("rin") || title.includes("rim") || title.includes("caliper");
      const is12 = /(^|\D)12\s*(v|vel|speed|x)/.test(title) || title.includes("12v") || title.includes("12 velocidades");
      const is11 = /(^|\D)11\s*(v|vel|speed|x)/.test(title) || title.includes("11v") || title.includes("11 velocidades");
      const isCampy = family.includes("campagnolo") || title.includes("campagnolo");
      const cambioBase = isDura ? 94 : isUltegra ? 88 : is105 ? 79 : isCampy ? 90 : 74;
      const pesoBase = isDura ? 96 : isUltegra ? 88 : is105 ? 78 : isCampy ? 86 : 72;
      const compatBase = is105 || isUltegra || isDura ? 90 : isCampy ? 82 : 76;
      return [
        clampScore(cambioBase + (isElectronic ? 5 : 0) + (is12 ? 2 : 0) - (is11 ? 1 : 0)),
        clampScore(pesoBase + (isRim ? 4 : 0) - (isDisc ? 7 : 0) - (isElectronic ? 5 : 0) - (is12 ? 1 : 0)),
        clampScore(isDisc ? 94 : isRim ? 78 : 82),
        value,
        clampScore(isElectronic ? (isDura ? 98 : isUltegra ? 94 : is105 ? 88 : 86) : 18),
        clampScore(compatBase + (is12 ? 3 : 0) - (isElectronic ? 3 : 0))
      ];
    }

    if (categoryName === "corazas") {
      const isGp5000 = title.includes("5000") || title.includes("gp5000");
      const isGrandPrix = title.includes("grand prix");
      const isFourSeason = title.includes("4 estaciones") || title.includes("four season");
      const isUltra = title.includes("ultra sport");
      const widthMatch = title.match(/\b(23|25|26|28|30|32)\b|(\d{2})c|700x(23|25|26|28|30|32)/);
      const width = widthMatch ? Number(widthMatch[1] || widthMatch[2] || widthMatch[3]) : 0;
      const widthScore = width >= 28 && width <= 30 ? 94 : width === 32 ? 88 : width === 25 || width === 26 ? 82 : width === 23 ? 66 : 78;
      return [
        isGp5000 ? 96 : isGrandPrix ? 84 : isUltra ? 72 : 78,
        isFourSeason ? 92 : isGp5000 ? 88 : isGrandPrix ? 80 : isUltra ? 68 : 76,
        isFourSeason ? 96 : isTubeless ? 86 : isGp5000 ? 78 : isGrandPrix ? 76 : 66,
        isGp5000 ? 90 : isUltra ? 82 : isTubeless ? 76 : isFourSeason ? 70 : 74,
        widthScore,
        value
      ];
    }

    if (categoryName === "bielas") return [
      isDura ? 98 : isUltegra ? 92 : is105 ? 82 : 76,
      isCarbon ? 96 : isDura ? 92 : isUltegra ? 86 : 74,
      is105 || isUltegra || isDura ? 92 : 76,
      title.includes("50/34") || title.includes("52/36") || title.includes("53/39") ? 94 : 78,
      title.includes("potencio") || title.includes("power") ? 98 : 66,
      value
    ];

    if (categoryName === "potenciometros") return [
      title.includes("dual") || title.includes("dura") ? 94 : title.includes("xcadey") ? 88 : 82,
      isCarbon ? 92 : isDura ? 88 : isUltegra ? 82 : 78,
      is105 || isUltegra || isDura || title.includes("shimano") ? 90 : 76,
      title.includes("bateria") || title.includes("carga") ? 88 : 78,
      title.includes("biela") || title.includes("left") || title.includes("izquierda") ? 88 : 76,
      value
    ];

    if (categoryName === "cassettes") return [
      title.includes("34") || title.includes("36") ? 94 : title.includes("30") || title.includes("32") ? 84 : 72,
      isDura ? 94 : isUltegra ? 88 : is105 ? 80 : 74,
      isDura ? 94 : isUltegra ? 86 : 78,
      is105 ? 92 : isUltegra ? 88 : isDura ? 82 : 78,
      title.includes("12") ? 92 : title.includes("11") ? 84 : 74,
      value
    ];

    if (categoryName === "cadenas") return [
      isDura ? 92 : isUltegra ? 88 : is105 ? 82 : 76,
      is105 ? 92 : isUltegra ? 88 : isDura ? 82 : 76,
      isDura || isUltegra ? 92 : 82,
      title.includes("12") ? 92 : title.includes("11") ? 84 : 76,
      isDura ? 92 : isUltegra ? 86 : 78,
      value
    ];

    if (categoryName === "frenos") return [
      isDisc ? 94 : 78,
      isDura ? 96 : isUltegra ? 90 : is105 ? 82 : 76,
      isDura ? 94 : isUltegra ? 86 : 78,
      isDisc ? 92 : 72,
      isDisc || title.includes("herradura") ? 90 : 74,
      value
    ];

    if (categoryName === "manetas") return [
      isDura ? 96 : isUltegra ? 92 : is105 ? 84 : 76,
      isDi2 ? 96 : 82,
      isDura ? 94 : isUltegra ? 86 : 78,
      isDi2 ? 96 : 74,
      is105 || isUltegra || isDura ? 92 : 76,
      value
    ];

    if (categoryName === "tensores") return [
      isDi2 ? 96 : isDura ? 94 : isUltegra ? 90 : 82,
      title.includes("gs") || title.includes("largo") ? 92 : 78,
      isDura ? 94 : isUltegra ? 86 : 78,
      is105 || isUltegra || isDura ? 92 : 76,
      is105 ? 92 : isUltegra ? 88 : isDura ? 82 : 78,
      value
    ];

    if (categoryName === "pedales") return [
      isDura ? 94 : isUltegra ? 88 : is105 ? 80 : 74,
      isCarbon ? 94 : isDura ? 90 : isUltegra ? 82 : 76,
      title.includes("spd") || title.includes("look") ? 90 : 78,
      is105 ? 88 : isUltegra ? 86 : isDura ? 82 : 76,
      title.includes("shimano") ? 92 : 76,
      value
    ];

    if (categoryName === "coronas") return [
      title.includes("53") || title.includes("52") ? 92 : title.includes("50") ? 86 : 78,
      isDura ? 94 : isUltegra ? 88 : is105 ? 80 : 76,
      isDura ? 92 : isUltegra ? 84 : 78,
      isDura || isUltegra ? 92 : 82,
      title.includes("12") || title.includes("11") || is105 || isUltegra || isDura ? 90 : 76,
      value
    ];

    if (categoryName === "accesorios") return [
      title.includes("bateria") || title.includes("cargador") || title.includes("adaptador") || title.includes("cable") || title.includes("soporte") ? 88 : 76,
      is105 || isUltegra || isDura || title.includes("shimano") || title.includes("specialized") || title.includes("garmin") ? 90 : 74,
      title.includes("adaptador") || title.includes("cable") || title.includes("soporte") ? 90 : 78,
      title.includes("original") || title.includes("shimano") || title.includes("specialized") ? 88 : 76,
      title.includes("original") || title.includes("oem") || title.includes("shimano") || title.includes("specialized") || title.includes("garmin") ? 92 : 72,
      value
    ];

    return [
      isDura ? 94 : isUltegra ? 90 : is105 ? 82 : 76,
      isCarbon || isDi2 ? 92 : 78,
      isDisc ? 90 : 78,
      value,
      is105 || isUltegra || isDura ? 90 : 76,
      isDura ? 94 : isUltegra ? 88 : is105 ? 82 : 76
    ];
  };

  const radarPoint = (score, index) => {
    const angle = (-90 + index * 60) * Math.PI / 180;
    const radius = 112 * Number(score || 0) / 100;
    return `${(140 + Math.cos(angle) * radius).toFixed(1)},${(137 + Math.sin(angle) * radius).toFixed(1)}`;
  };

  const itemFromOption = (option, category) => {
    if (!option || !option.value) return null;
    return {
      title: option.dataset.title || option.textContent?.trim() || "Producto CycloOutlet",
      baseTitle: option.dataset.baseTitle || option.dataset.title || "Producto CycloOutlet",
      variantTitle: option.dataset.variantTitle || "",
      family: option.dataset.family || "CycloOutlet",
      category,
      handle: option.dataset.handleValue || option.value,
      productHandle: option.dataset.productHandle || "",
      variantId: option.dataset.variantId || "",
      sku: option.dataset.sku || "",
      priceCents: parseCents(option.dataset.priceCents),
      price: option.dataset.price || formatMoney(parseCents(option.dataset.priceCents)),
      url: option.dataset.url || "#"
    };
  };

  const pointsFrom = item => scoreProduct(item).map(radarPoint).join(" ");

  const renderBars = (mount, item, category) => {
    if (!mount || !item) return;
    const labels = metricConfig(category);
    const scores = scoreProduct(item);
    mount.innerHTML = labels.map((label, index) => `
      <span>
        <small>${label}</small>
        <i><b style="width:${scores[index]}%"></b></i>
      </span>
    `).join("");
  };

  const buildComparatorUrl = (category, current, compare) => {
    const url = new URL('/pages/comparador', window.location.origin);
    url.searchParams.set('view', 'comparador');
    url.searchParams.set('category', category || 'accesorios');
    if (current?.handle) url.searchParams.set('a', current.handle);
    if (compare?.handle) url.searchParams.set('b', compare.handle);
    return url.pathname + url.search;
  };

  const init = () => {
    document.querySelectorAll('[data-product-mini-comparator]').forEach(mini => {
      if (mini.dataset.variantMiniReady === 'true') return;
      mini.dataset.variantMiniReady = 'true';
      const root = mini.closest('[data-apex-product-detail]');
      const category = mini.dataset.currentCategory || 'accesorios';
      const currentSelect = mini.querySelector('[data-mini-current-variant-select]');
      const compareSelect = mini.querySelector('[data-mini-compare-select]');
      const button = mini.querySelector('[data-mini-compare-full]');
      const currentShape = mini.querySelector('.co-mini-series--current');
      const compareShape = mini.querySelector('.co-mini-series--compare');
      const currentBars = mini.querySelector('[data-mini-card-bars="current"]');
      const compareBars = mini.querySelector('[data-mini-card-bars="compare"]');
      const compareCard = mini.querySelector('[data-mini-card="compare"]');
      const currentTitle = mini.querySelector('[data-mini-current-title]');
      const currentPrice = mini.querySelector('[data-mini-current-price]');
      const currentFamily = mini.querySelector('[data-mini-current-family]');
      const currentNote = mini.querySelector('[data-mini-current-variant-note]');
      const compareTitle = mini.querySelector('[data-mini-compare-title]');
      const compareTarget = mini.querySelector('[data-mini-compare-target]');
      const compareFamily = mini.querySelector('[data-mini-compare-family]');
      const compareNote = mini.querySelector('[data-mini-compare-variant-note]');
      const axisLabels = [...mini.querySelectorAll('.co-mini-axis-label')];

      const setAxisLabels = () => {
        metricConfig(category).forEach((label, index) => {
          if (axisLabels[index]) axisLabels[index].textContent = label;
        });
      };

      const persistPreset = (current, compare) => {
        try {
          sessionStorage.setItem(COMPARE_PRESET_KEY, JSON.stringify({
            category,
            a: current?.handle || '',
            b: compare?.handle || '',
            source: 'mini-comparator-variants'
          }));
        } catch (error) {}
      };

      const update = () => {
        const current = itemFromOption(currentSelect?.selectedOptions?.[0], category);
        const compare = itemFromOption(compareSelect?.selectedOptions?.[0], category);
        setAxisLabels();

        if (current) {
          if (currentTitle) currentTitle.textContent = current.baseTitle || current.title;
          if (currentPrice) currentPrice.textContent = current.price;
          if (currentFamily) currentFamily.textContent = current.family;
          if (currentNote) currentNote.textContent = [current.variantTitle, current.sku].filter(Boolean).join(' · ') || 'Referencia principal';
          if (currentShape) currentShape.setAttribute('points', pointsFrom(current));
          renderBars(currentBars, current, category);
        }

        if (compare) {
          compareCard?.classList.remove('is-empty');
          compareShape?.classList.remove('is-empty');
          if (compareShape) compareShape.setAttribute('points', pointsFrom(compare));
          if (compareTitle) compareTitle.textContent = compare.baseTitle || compare.title;
          if (compareFamily) compareFamily.textContent = compare.family;
          if (compareTarget) compareTarget.textContent = compare.price;
          if (compareNote) compareNote.textContent = [compare.variantTitle, compare.sku].filter(Boolean).join(' · ') || 'Referencia principal';
          renderBars(compareBars, compare, category);
        } else {
          compareCard?.classList.add('is-empty');
          compareShape?.classList.add('is-empty');
          if (compareShape) compareShape.setAttribute('points', '140,97 175,117 175,157 140,177 105,157 105,117');
          if (compareTitle) compareTitle.textContent = 'Selecciona producto o variante';
          if (compareFamily) compareFamily.textContent = 'Sin seleccionar';
          if (compareTarget) compareTarget.textContent = 'Puedes comparar contra otra medida, relación o referencia.';
          if (compareNote) compareNote.textContent = '';
          if (compareBars) compareBars.innerHTML = '';
        }

        if (button) {
          button.href = buildComparatorUrl(category, current, compare);
          button.dataset.coComparePreset = JSON.stringify({ category, a: current?.handle || '', b: compare?.handle || '' });
        }
      };

      currentSelect?.addEventListener('change', update);
      compareSelect?.addEventListener('change', update);
      button?.addEventListener('click', () => persistPreset(itemFromOption(currentSelect?.selectedOptions?.[0], category), itemFromOption(compareSelect?.selectedOptions?.[0], category)));

      root?.addEventListener('cyclooutlet:variant-change', event => {
        const variantId = event.detail?.variant?.id;
        const productHandle = mini.dataset.currentHandle || '';
        const value = `${productHandle}::${variantId}`;
        if (variantId && currentSelect && [...currentSelect.options].some(option => option.value === value)) {
          currentSelect.value = value;
          update();
        }
      });

      update();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
(() => {
  const addItems = async (items = []) => {
    if (window.CycloOutletCartDrawer?.addItems) {
      return window.CycloOutletCartDrawer.addItems(items);
    }
    const valid = items
      .map(item => ({ id: Number(item.id), quantity: Math.max(1, Number(item.quantity || 1)) }))
      .filter(item => Number.isFinite(item.id) && item.id > 0);
    if (!valid.length) return null;
    const response = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: valid })
    });
    if (!response.ok) throw new Error("Cart add failed");
    return response.json();
  };

  window.CycloOutletCheckout = {
    goCheckoutWithItems: async items => {
      await addItems(items);
      if (window.CycloOutletCartDrawer?.open) {
        window.CycloOutletCartDrawer.open();
      } else {
        window.location.assign("/cart");
      }
    },
    checkoutPermalink: items => `/cart/${items.map(item => `${item.id}:${item.quantity || 1}`).join(",")}`,
    openCheckout: () => {
      if (window.CycloOutletCartDrawer?.open) {
        window.CycloOutletCartDrawer.open();
      } else {
        window.location.assign("/cart");
      }
    }
  };
})();
(() => {
  const canHover = () => window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const initCardHoverGalleries = () => {
    if (!canHover()) return;
    document.querySelectorAll('[data-co-card-hover-gallery]').forEach((card) => {
      if (card.dataset.coCardHoverReady === 'true') return;
      card.dataset.coCardHoverReady = 'true';

      const media = card.querySelector('.co-catalog-card__media');
      const image = card.querySelector('.co-catalog-card__image');
      const sources = Array.from(card.querySelectorAll('[data-co-card-hover-source]'))
        .map((node) => node.dataset.src || '')
        .filter(Boolean)
        .filter((src, index, all) => all.indexOf(src) === index);
      if (!media || !image || sources.length <= 1) return;

      const originalSrc = image.getAttribute('src') || image.currentSrc || sources[0];
      const originalSrcset = image.getAttribute('srcset');
      const originalSizes = image.getAttribute('sizes');
      let index = 0;
      let timer = 0;
      let startDelay = 0;
      let switchingTimer = 0;

      const preload = () => sources.forEach((src) => {
        const probe = new Image();
        probe.decoding = 'async';
        probe.src = src;
      });

      const show = (nextIndex) => {
        index = ((nextIndex % sources.length) + sources.length) % sources.length;
        media.classList.add('is-image-switching');
        window.clearTimeout(switchingTimer);
        switchingTimer = window.setTimeout(() => {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = sources[index];
          switchingTimer = window.setTimeout(() => media.classList.remove('is-image-switching'), 110);
        }, 90);
      };

      const stop = () => {
        window.clearTimeout(startDelay);
        window.clearInterval(timer);
        window.clearTimeout(switchingTimer);
        startDelay = 0;
        timer = 0;
        media.classList.remove('is-image-switching');
      };

      const reset = () => {
        stop();
        index = 0;
        image.src = originalSrc;
        if (originalSrcset) image.setAttribute('srcset', originalSrcset); else image.removeAttribute('srcset');
        if (originalSizes) image.setAttribute('sizes', originalSizes); else image.removeAttribute('sizes');
      };

      const start = () => {
        stop();
        preload();
        startDelay = window.setTimeout(() => {
          show(index + 1);
          timer = window.setInterval(() => show(index + 1), 1050);
        }, 520);
      };

      card.addEventListener('mouseenter', start);
      card.addEventListener('mouseleave', reset);
    });
  };

  const initProductImageZoom = () => {
    if (!canHover()) return;
    document.querySelectorAll('.template-product .co-product-gallery-slide:not([data-co-gallery-kind])').forEach((slide) => {
      if (slide.dataset.coImageZoomReady === 'true') return;
      slide.dataset.coImageZoomReady = 'true';
      const image = slide.querySelector('.co-product-gallery-source-image, img');
      if (!image) return;

      const reset = () => {
        image.style.setProperty('--co-product-image-zoom', '1');
        image.style.setProperty('--co-product-image-zoom-x', '50%');
        image.style.setProperty('--co-product-image-zoom-y', '50%');
      };

      const positionZoom = (event) => {
        if (!slide.classList.contains('is-active')) return;
        const rect = slide.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const x = Math.max(6, Math.min(94, ((event.clientX - rect.left) / rect.width) * 100));
        const y = Math.max(6, Math.min(94, ((event.clientY - rect.top) / rect.height) * 100));
        image.style.setProperty('--co-product-image-zoom-x', `${x}%`);
        image.style.setProperty('--co-product-image-zoom-y', `${y}%`);
        image.style.setProperty('--co-product-image-zoom', '1.65');
      };

      slide.addEventListener('mouseenter', positionZoom);
      slide.addEventListener('mousemove', positionZoom);
      slide.addEventListener('mouseleave', reset);
    });
  };

  const initHoverEffects = () => {
    initCardHoverGalleries();
    initProductImageZoom();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverEffects, { once: true });
  } else {
    initHoverEffects();
  }
  document.addEventListener('shopify:section:load', initHoverEffects);
})();

(() => {
  const AUTOPLAY_ATTRIBUTE = 'data-co-auto-gallery';

  const createGallery = (root) => {
    if (!root || root.dataset.coGalleryReady === 'true') return;
    root.dataset.coGalleryReady = 'true';

    const slides = Array.from(root.querySelectorAll('[data-co-gallery-slide]'));
    if (slides.length <= 1) return;

    const dots = Array.from(root.querySelectorAll('[data-co-gallery-dot], .co-auto-gallery-dots i'));
    const prev = root.querySelector('[data-co-gallery-prev]');
    const next = root.querySelector('[data-co-gallery-next]');
    const interval = Number(root.dataset.coGalleryInterval || root.getAttribute('data-co-gallery-interval') || 4200);
    let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    let timer = null;

    const paint = (nextIndex) => {
      index = ((nextIndex % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute?.('aria-current', active ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      if (root.dataset.coGalleryAutoplay === 'false') return;
      timer = setInterval(() => paint(index + 1), interval);
    };

    prev?.addEventListener('click', (event) => {
      event.preventDefault();
      paint(index - 1);
      start();
    });

    next?.addEventListener('click', (event) => {
      event.preventDefault();
      paint(index + 1);
      start();
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener?.('click', (event) => {
        event.preventDefault();
        paint(dotIndex);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // Product variant image sync when Shopify variant has a featured image.
    const productRoot = root.closest('[data-apex-product-detail]');
    const variantSelect = productRoot?.querySelector('[data-variant-select]');
    const variantsJson = productRoot?.querySelector('[data-product-variants-json]');
    if (variantSelect && variantsJson) {
      let variants = [];
      try { variants = JSON.parse(variantsJson.textContent || '[]'); } catch { variants = []; }
      variantSelect.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === String(variantSelect.value));
        const imageId = variant?.featured_image?.id || variant?.featured_media?.id;
        if (!imageId) return;
        const targetIndex = slides.findIndex(slide => String(slide.dataset.imageId) === String(imageId));
        if (targetIndex >= 0) {
          paint(targetIndex);
          start();
        }
      });
    }

    paint(index);
    start();
  };

  const createSpinViewer = (viewer) => {
    if (!viewer || viewer.dataset.coSpinReady === 'true') return;
    const image = viewer.querySelector('[data-co-spin-image]');
    const frameNodes = Array.from(viewer.querySelectorAll('[data-co-spin-frame]'));
    const frames = frameNodes.map(node => node.dataset.src).filter(Boolean);
    if (!image || frames.length < 2) return;

    viewer.dataset.coSpinReady = 'true';
    const slide = viewer.closest('[data-co-gallery-slide]');
    const loaded = new Set([0]);
    const loading = new Map();
    let index = 0;
    let dragging = false;
    let pointerId = null;
    let startX = 0;
    let lastX = 0;
    let carry = 0;
    let autoplay = null;
    let resumeTimer = null;
    const autoplayEnabled = viewer.dataset.coSpinAutoplay !== 'false';
    const autoplayInterval = Math.max(90, Number(viewer.dataset.coSpinInterval || 130));
    const threshold = () => Math.max(18, Math.min(44, Math.round(viewer.clientWidth / 14)));

    const normalize = value => ((value % frames.length) + frames.length) % frames.length;

    const preloadFrame = (frameIndex) => {
      const target = normalize(frameIndex);
      if (loaded.has(target)) return Promise.resolve();
      if (loading.has(target)) return loading.get(target);
      const task = new Promise(resolve => {
        const preload = new Image();
        preload.decoding = 'async';
        preload.onload = () => {
          loaded.add(target);
          loading.delete(target);
          resolve();
        };
        preload.onerror = () => {
          loading.delete(target);
          resolve();
        };
        preload.src = frames[target];
      });
      loading.set(target, task);
      return task;
    };

    const paint = (nextIndex) => {
      index = normalize(nextIndex);
      const src = frames[index];
      if (image.currentSrc !== src && image.src !== src) image.src = src;
      viewer.dataset.coSpinFrame = String(index + 1);
      preloadFrame(index + 1);
      preloadFrame(index - 1);
    };

    const stopAutoplay = () => {
      if (autoplay) clearInterval(autoplay);
      autoplay = null;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = null;
    };

    const startAutoplay = () => {
      if (!autoplayEnabled || document.hidden || dragging || autoplay) return;
      autoplay = window.setInterval(() => {
        if (document.hidden || dragging) return;
        if (slide && !slide.classList.contains('is-active')) return;
        paint(index + 1);
      }, autoplayInterval);
    };

    const resumeAutoplaySoon = () => {
      if (!autoplayEnabled) return;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        resumeTimer = null;
        startAutoplay();
      }, 1100);
    };

    const preloadInitial = () => {
      const nearby = [1, -1, 2, -2, 3, -3]
        .map(normalize)
        .filter((value, position, list) => list.indexOf(value) === position && value !== 0);
      Promise.allSettled(nearby.map(preloadFrame)).then(startAutoplay);

      const preloadRest = () => {
        for (let frameIndex = 0; frameIndex < frames.length; frameIndex += 1) preloadFrame(frameIndex);
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(preloadRest, { timeout: 2200 });
      } else {
        window.setTimeout(preloadRest, 1600);
      }
    };

    const stepByDistance = (distance) => {
      carry += distance;
      const step = threshold();
      while (Math.abs(carry) >= step) {
        const direction = carry > 0 ? -1 : 1;
        paint(index + direction);
        carry += carry > 0 ? -step : step;
      }
    };

    viewer.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      stopAutoplay();
      pointerId = event.pointerId;
      startX = event.clientX;
      lastX = event.clientX;
      carry = 0;
      viewer.classList.add('is-dragging');
      viewer.setPointerCapture?.(event.pointerId);
    });

    viewer.addEventListener('pointermove', (event) => {
      if (!dragging || event.pointerId !== pointerId) return;
      const delta = event.clientX - lastX;
      lastX = event.clientX;
      stepByDistance(delta);
      if (Math.abs(event.clientX - startX) > 8) event.preventDefault();
    });

    const endDrag = (event) => {
      if (!dragging || (pointerId !== null && event.pointerId !== pointerId)) return;
      dragging = false;
      pointerId = null;
      carry = 0;
      viewer.classList.remove('is-dragging');
      resumeAutoplaySoon();
    };

    viewer.addEventListener('pointerup', endDrag);
    viewer.addEventListener('pointercancel', endDrag);
    viewer.addEventListener('lostpointercapture', endDrag);
    viewer.addEventListener('dragstart', event => event.preventDefault());
    viewer.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      stopAutoplay();
      paint(index + (event.key === 'ArrowLeft' ? -1 : 1));
      resumeAutoplaySoon();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else resumeAutoplaySoon();
    });

    paint(0);
    preloadInitial();
  };

  const init = () => {
    document.querySelectorAll(`[${AUTOPLAY_ATTRIBUTE}]`).forEach(createGallery);
    document.querySelectorAll('[data-co-spin-viewer]').forEach(createSpinViewer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
(() => {
  const SELECTOR = '.apex-card-media, .co-static-product-media, .co-offer-media, .apex-group-media, .co-product-gallery-main';
  const fallback = '#ffffff';
  const clamp = value => Math.max(0, Math.min(255, Math.round(value)));

  const niceColor = (r, g, b) => {
    const brightness = (r + g + b) / 3;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const saturation = max ? (max - min) / max : 0;

    // Imágenes de producto suelen tener fondo blanco: mantenerlo claro y premium.
    if (brightness > 205 && saturation < .22) return '#ffffff';
    if (brightness > 225) return `rgb(${clamp(r * .93 + 12)}, ${clamp(g * .93 + 12)}, ${clamp(b * .93 + 12)})`;

    // Si domina un color oscuro, no llevarlo a negro puro; dejar un tono de soporte visual.
    if (brightness < 42) return '#11110f';

    // Suaviza el color dominante para que funcione como fondo y no compita con la imagen.
    return `rgb(${clamp(r * .82 + 34)}, ${clamp(g * .82 + 34)}, ${clamp(b * .82 + 34)})`;
  };

  const sample = (host) => {
    if (!host || host.dataset.coImageBackgroundReady === 'true') return;
    const img = host.querySelector('img');
    const src = host.dataset.coDominantSrc || img?.currentSrc || img?.src;
    if (!src) {
      host.style.setProperty('--co-dominant-bg', fallback);
      host.classList.add('co-image-bg-ready', 'co-white-image-bg');
      host.dataset.coImageBackgroundReady = 'true';
      return;
    }

    const probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.onload = () => {
      try {
        const size = 64;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(probe, 0, 0, size, size);
        const pixels = ctx.getImageData(0, 0, size, size).data;
        const buckets = new Map();

        for (let i = 0; i < pixels.length; i += 4) {
          const a = pixels[i + 3] / 255;
          if (a < .42) continue;
          const r = pixels[i], g = pixels[i + 1], b = pixels[i + 2];
          const brightness = (r + g + b) / 3;
          if (brightness < 10) continue;
          const qr = Math.round(r / 24) * 24;
          const qg = Math.round(g / 24) * 24;
          const qb = Math.round(b / 24) * 24;
          const key = `${qr},${qg},${qb}`;
          buckets.set(key, (buckets.get(key) || 0) + a);
        }

        let best = null;
        let bestWeight = -1;
        for (const [key, weight] of buckets.entries()) {
          if (weight > bestWeight) { best = key; bestWeight = weight; }
        }
        if (!best) throw new Error('no dominant color');
        const [r, g, b] = best.split(',').map(Number);
        const bg = niceColor(r, g, b);
        host.style.setProperty('--co-dominant-bg', bg);
        host.classList.toggle('co-white-image-bg', bg === '#ffffff');
        host.classList.add('co-image-bg-ready');
        host.dataset.coImageBackgroundReady = 'true';
      } catch (error) {
        host.style.setProperty('--co-dominant-bg', fallback);
        host.classList.add('co-image-bg-ready', 'co-white-image-bg');
        host.dataset.coImageBackgroundReady = 'true';
      }
    };
    probe.onerror = () => {
      host.style.setProperty('--co-dominant-bg', fallback);
      host.classList.add('co-image-bg-ready', 'co-white-image-bg');
      host.dataset.coImageBackgroundReady = 'true';
    };
    probe.src = src;
  };

  const init = () => document.querySelectorAll(SELECTOR).forEach(sample);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('load', init, { once: true });
})();
(() => {
  const HOST_SELECTOR = [
    '.apex-card-media',
    '.co-static-product-media',
    '.co-offer-media',
    '.apex-group-media',
    '.co-product-gallery-main',
    '.apex-product-media',
    '.apex-collection-featured-image',
    '.co-luxury-product__media',
    '.co-line-media',
    '.co-quote-line .co-line-media',
    '.co-compare-product-media'
  ].join(',');

  const clamp = (value) => Math.max(0, Math.min(255, Math.round(value)));
  const cssUrl = (url) => `url("${String(url || '').replace(/"/g, '%22')}")`;
  const brightness = (r, g, b) => (r * 0.299 + g * 0.587 + b * 0.114);
  const saturation = (r, g, b) => {
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    return max ? (max - min) / max : 0;
  };

  const soften = (r, g, b) => {
    const br = brightness(r, g, b);
    const sat = saturation(r, g, b);

    // Blanco/casi blanco real: no meter gris ni beige.
    if (br >= 226 && sat <= 0.18) return { color: '#ffffff', white: true, photo: false };
    if (br >= 238) return { color: '#ffffff', white: true, photo: false };

    // Fondos claros con leve tinte: mantener el tinte para fusionar el marco de la foto.
    if (br >= 190) {
      return {
        color: `rgb(${clamp(r * 0.96 + 8)}, ${clamp(g * 0.96 + 8)}, ${clamp(b * 0.96 + 8)})`,
        white: false,
        photo: false
      };
    }

    // Fondos madera/foto: suavizar hacia claro para que sea premium.
    if (br >= 92) {
      return {
        color: `rgb(${clamp(r * 0.72 + 58)}, ${clamp(g * 0.72 + 58)}, ${clamp(b * 0.72 + 58)})`,
        white: false,
        photo: true
      };
    }

    // Fondo oscuro: no volver negro puro; dejar soporte carbón suave.
    return { color: '#151513', white: false, photo: true };
  };

  const edgeAverage = (image) => {
    const size = 72;
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(image, 0, 0, size, size);
    const data = ctx.getImageData(0, 0, size, size).data;
    let r = 0, g = 0, b = 0, w = 0;
    const edge = 9;

    for (let y = 0; y < size; y++) {
      for (let x = 0; x < size; x++) {
        const isEdge = x < edge || y < edge || x >= size - edge || y >= size - edge;
        if (!isEdge) continue;
        const idx = (y * size + x) * 4;
        const alpha = data[idx + 3] / 255;
        if (alpha < 0.35) continue;
        const rr = data[idx], gg = data[idx + 1], bb = data[idx + 2];
        // Ignorar negro extremo de letras/bordes pequeños en esquinas.
        if (brightness(rr, gg, bb) < 8) continue;
        const weight = alpha;
        r += rr * weight;
        g += gg * weight;
        b += bb * weight;
        w += weight;
      }
    }

    if (!w) throw new Error('no edge pixels');
    return [r / w, g / w, b / w];
  };

  const pickImage = (host) => {
    const img = host.querySelector('img');
    return host.dataset.coDominantSrc || img?.currentSrc || img?.src || '';
  };

  const applyFallback = (host, src) => {
    host.classList.add('co-image-harmony', 'co-white-bg');
    host.style.setProperty('--co-edge-bg', '#ffffff');
    host.style.setProperty('--co-dominant-bg', '#ffffff');
    if (src) host.style.setProperty('--co-media-bg-image', cssUrl(src));
    host.dataset.coImageHarmonyReady = 'true';
  };

  const processHost = (host) => {
    if (!host || host.dataset.coImageHarmonyReady === 'true') return;
    const src = pickImage(host);
    if (!src) return applyFallback(host, '');

    host.classList.add('co-image-harmony');
    host.style.setProperty('--co-media-bg-image', cssUrl(src));

    const probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.onload = () => {
      try {
        const [r, g, b] = edgeAverage(probe);
        const result = soften(r, g, b);
        host.style.setProperty('--co-edge-bg', result.color);
        host.style.setProperty('--co-dominant-bg', result.color);
        host.classList.toggle('co-white-bg', result.white);
        host.classList.toggle('co-photo-bg', result.photo);
        host.classList.add('co-image-bg-ready');
        host.dataset.coImageHarmonyReady = 'true';
      } catch (error) {
        applyFallback(host, src);
      }
    };
    probe.onerror = () => applyFallback(host, src);
    probe.src = src;
  };

  const init = () => document.querySelectorAll(HOST_SELECTOR).forEach(processHost);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  window.addEventListener('load', init, { once: true });

  // Shopify puede insertar/actualizar tarjetas después de filtrar o buscar.
  const observer = new MutationObserver(() => init());
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
})();
;


(() => {
  const IMG_SELECTOR = '.template-product .co-product-gallery-slide img, .template-product .co-product-gallery-thumbs img';

  const brightness = (r, g, b) => (r * 0.299 + g * 0.587 + b * 0.114);

  function analyzeWhiteEdges(img) {
    try {
      const size = 36;
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, size, size);
      const data = ctx.getImageData(0, 0, size, size).data;
      let sum = 0;
      let count = 0;
      const edge = 6;
      for (let y = 0; y < size; y++) {
        for (let x = 0; x < size; x++) {
          const isEdge = x < edge || y < edge || x >= size - edge || y >= size - edge;
          if (!isEdge) continue;
          const idx = (y * size + x) * 4;
          const alpha = data[idx + 3];
          if (alpha < 24) continue;
          const b = brightness(data[idx], data[idx + 1], data[idx + 2]);
          sum += b;
          count += 1;
        }
      }
      if (!count) return false;
      return (sum / count) >= 236;
    } catch (error) {
      return false;
    }
  }

  function processImage(img) {
    if (!img || img.dataset.v116Processed === 'true') return;
    const mark = () => {
      if (analyzeWhiteEdges(img)) {
        img.classList.add('co-white-bg-source');
      }
      img.dataset.v116Processed = 'true';
    };

    if (img.complete && img.naturalWidth > 0) {
      mark();
    } else {
      img.addEventListener('load', mark, { once: true });
    }
  }

  function init() {
    document.querySelectorAll(IMG_SELECTOR).forEach(processImage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  window.addEventListener('load', init, { once: true });

  const observer = new MutationObserver(init);
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
})();


/* ===== Media de variantes ===== */
(() => {
  const PRODUCT_SELECTOR = '[data-apex-product-detail]';

  const parseVariants = (root) => {
    const node = root.querySelector('[data-product-variants-json]');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); }
    catch { return []; }
  };

  const normalizedFile = (url) => {
    try {
      const clean = String(url || '').split('?')[0];
      return clean.slice(clean.lastIndexOf('/') + 1).toLowerCase();
    } catch { return ''; }
  };

  const activateMedia = (root, variant) => {
    if (!root || !variant) return false;
    const gallery = root.querySelector('[data-co-product-gallery], [data-co-auto-gallery]');
    if (!gallery) return false;

    const mediaId = variant?.featured_media?.id || variant?.featured_image?.id || variant?.image_id;
    const mediaSrc = variant?.featured_media?.preview_image?.src || variant?.featured_image?.src || variant?.image?.src || '';

    let thumb = null;
    let slide = null;

    if (mediaId) {
      thumb = gallery.querySelector(`[data-co-gallery-dot][data-image-id="${String(mediaId)}"]`);
      slide = gallery.querySelector(`[data-co-gallery-slide][data-image-id="${String(mediaId)}"]`);
    }

    if ((!thumb || !slide) && mediaSrc) {
      const file = normalizedFile(mediaSrc);
      const images = [...gallery.querySelectorAll('img')];
      const matchingImage = images.find((img) => {
        const candidates = [img.currentSrc, img.src, img.getAttribute('srcset')]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        return file && candidates.includes(file);
      });
      if (matchingImage) {
        thumb = matchingImage.closest('[data-co-gallery-dot]');
        slide = matchingImage.closest('[data-co-gallery-slide]');
      }
    }

    // Use the theme's existing click handler when possible so autoplay/index stay in sync.
    if (thumb) {
      thumb.click();
      thumb.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      return true;
    }

    if (!slide) return false;
    gallery.querySelectorAll('[data-co-gallery-slide]').forEach((item) => {
      const active = item === slide;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    gallery.querySelectorAll('[data-co-gallery-dot]').forEach((item) => {
      const active = mediaId && String(item.dataset.imageId) === String(mediaId);
      item.classList.toggle('is-active', Boolean(active));
      item.setAttribute('aria-current', active ? 'true' : 'false');
    });
    return true;
  };

  const initProduct = (root) => {
    if (!root || root.dataset.coVariantMediaReady === 'true') return;
    root.dataset.coVariantMediaReady = 'true';

    const select = root.querySelector('[data-variant-select]');
    const variants = parseVariants(root);
    if (!select || !variants.length) return;

    const currentVariant = () => variants.find((item) => String(item.id) === String(select.value));
    const sync = (variant = currentVariant()) => activateMedia(root, variant);

    select.addEventListener('change', () => sync());
    root.addEventListener('cyclooutlet:variant-change', (event) => sync(event.detail?.variant));

    // Keep the initially selected Shopify variant synchronized after all gallery handlers load.
    requestAnimationFrame(() => requestAnimationFrame(() => sync()));
  };

  const init = () => document.querySelectorAll(PRODUCT_SELECTOR).forEach(initProduct);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* ===== WhatsApp premium ===== */
(() => {
  'use strict';

  const HOST_ID = 'co-whatsapp-host';
  const LEGACY_SELECTOR = '.co-whatsapp-panel, .co-wa41-panel, #co-whatsapp-host, co-whatsapp-host';
  const PRIMARY_WHATSAPP = String(window.CycloOutletWhatsAppAssets?.number || '573142533532').replace(/\D/g, '');
  const FELIPE = PRIMARY_WHATSAPP;
  const ANDREA = PRIMARY_WHATSAPP;

  window.CycloOutletWhatsAppReady = true;

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  };

  const removeLegacyWhatsApp = (root = document) => {
    root.querySelectorAll?.(LEGACY_SELECTOR).forEach((node) => node.remove());
  };

  const currentContext = () => {
    const title = document.querySelector('.apex-product-title, .product__title, main h1, h1')?.textContent?.trim();
    return title
      ? `Estoy viendo ${title}.`
      : 'Estoy visitando la página de CycloOutlet.';
  };

  const whatsappUrl = (number, advisor, purpose) => {
    const message = `Hola CycloOutlet, quiero hablar con ${advisor}. ${currentContext()} Necesito ${purpose}.`;
    return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
  };

  const lockHostStyles = (host) => {
    const styles = {
      all: 'initial',
      position: 'fixed',
      right: 'clamp(13px, 1.35vw, 20px)',
      bottom: 'clamp(13px, 1.35vw, 20px)',
      width: '0',
      height: '0',
      minWidth: '0',
      minHeight: '0',
      maxWidth: '0',
      maxHeight: '0',
      display: 'block',
      padding: '0',
      margin: '0',
      border: '0',
      borderRadius: '0',
      background: 'transparent',
      backgroundColor: 'transparent',
      backgroundImage: 'none',
      boxShadow: 'none',
      overflow: 'visible',
      opacity: '1',
      visibility: 'visible',
      zIndex: '2147483000',
      pointerEvents: 'auto',
      isolation: 'isolate'
    };

    Object.entries(styles).forEach(([property, value]) => {
      const cssProperty = property.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
      host.style.setProperty(cssProperty, value, 'important');
    });
  };

  const iconMarkup = `
    <svg class="wa-icon wa-icon--fallback" viewBox="0 0 64 64" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
      <path class="wa-ring" d="M31.9 6.4c-14.1 0-25.5 11.4-25.5 25.5 0 4.9 1.4 9.7 4 13.8L6 58l12.8-4.2a25.4 25.4 0 0 0 13.1 3.6h.1c14 0 25.5-11.4 25.5-25.5S46 6.4 31.9 6.4Z"/>
      <path class="wa-phone" d="M24.3 19.1c-.7-1.7-1.5-1.7-2.2-1.7h-1.8c-.6 0-1.7.2-2.6 1.2-.9 1-3.4 3.3-3.4 8.1 0 4.7 3.5 9.3 4 9.9.5.6 6.8 10.4 16.5 14.6 2.3 1 4.1 1.6 5.5 2 2.3.7 4.4.6 6.1.4 1.9-.3 5.8-2.4 6.6-4.7.8-2.3.8-4.2.6-4.7-.2-.4-.9-.6-1.9-1.1-1-.5-5.8-2.9-6.7-3.2-.9-.3-1.6-.5-2.2.5-.7 1-2.6 3.2-3.1 3.8-.6.7-1.2.7-2.1.2-1-.5-4.1-1.5-7.8-4.8-2.9-2.6-4.8-5.8-5.4-6.8-.6-1-.1-1.5.4-2 .4-.4 1-1.2 1.5-1.7.5-.6.7-1 .9-1.7.3-.6.2-1.2-.1-1.7-.2-.5-2.1-5.2-2.8-7.1Z"/>
    </svg>`;

  const arrowMarkup = `
    <svg class="wa-arrow-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.8 4.5 12.3 10l-5.5 5.5"/>
    </svg>`;

  const shadowStyles = `
    :host {
      color-scheme: light;
      font-family: "Source Sans 3", Arial, sans-serif;
    }

    *, *::before, *::after {
      box-sizing: border-box;
    }

    .wa-wrap {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      overflow: visible;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
    }

    .wa-toggle,
    .wa-toggle:hover,
    .wa-toggle:focus,
    .wa-toggle:focus-visible,
    .wa-toggle:active {
      all: unset !important;
      box-sizing: border-box !important;
      position: absolute !important;
      right: 0 !important;
      bottom: 0 !important;
      display: grid !important;
      place-items: center !important;
      width: 68px !important;
      height: 68px !important;
      min-width: 68px !important;
      min-height: 68px !important;
      padding: 0 !important;
      margin: 0 !important;
      cursor: pointer !important;
      border: 0 !important;
      border-radius: 50% !important;
      outline: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      appearance: none !important;
      -webkit-appearance: none !important;
      overflow: visible !important;
      -webkit-tap-highlight-color: transparent !important;
    }

    .wa-toggle::before,
    .wa-toggle::after {
      content: none !important;
      display: none !important;
    }

    .wa-orb {
      position: relative !important;
      display: grid !important;
      place-items: center !important;
      width: 72px !important;
      height: 72px !important;
      border: 0 !important;
      border-radius: 50% !important;
      background: transparent !important;
      box-shadow:
        0 14px 28px rgba(18, 169, 75, .30),
        0 0 0 1px rgba(218, 171, 11, .26),
        0 0 22px rgba(37, 211, 102, .22) !important;
      isolation: isolate !important;
      transition: transform .22s ease, box-shadow .22s ease, filter .22s ease !important;
      animation: wa-breathe 4.6s ease-in-out infinite, wa-attention 8.5s ease-in-out infinite !important;
    }

    .wa-orb::before {
      content: "" !important;
      position: absolute !important;
      inset: -8px !important;
      border: 1px solid rgba(225, 180, 25, .38) !important;
      border-radius: 50% !important;
      opacity: .18 !important;
      transform: scale(.93) !important;
      animation: wa-ring 8.5s ease-out infinite !important;
      pointer-events: none !important;
    }

    .wa-orb::after {
      content: "" !important;
      position: absolute !important;
      top: 10px !important;
      left: 16px !important;
      width: 28px !important;
      height: 12px !important;
      border-radius: 50% !important;
      background: linear-gradient(105deg, rgba(255,255,255,.52), rgba(255,255,255,0)) !important;
      transform: rotate(-24deg) !important;
      filter: blur(.2px) !important;
      pointer-events: none !important;
    }

    .wa-icon {
      all: initial !important;
      box-sizing: border-box !important;
      position: relative !important;
      z-index: 1 !important;
      display: block !important;
      width: 40px !important;
      height: 40px !important;
      overflow: visible !important;
      background: transparent !important;
      pointer-events: none !important;
      filter: drop-shadow(0 2px 2px rgba(0, 82, 35, .16)) !important;
      transition: transform .22s ease !important;
    }


    .wa-logo {
      all: initial !important;
      box-sizing: border-box !important;
      position: relative !important;
      z-index: 2 !important;
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
      object-position: center !important;
      border: 0 !important;
      border-radius: 50% !important;
      background: transparent !important;
      filter: drop-shadow(0 2px 3px rgba(0, 0, 0, .14)) !important;
      pointer-events: none !important;
    }

    .wa-icon--fallback {
      width: 40px !important;
      height: 40px !important;
    }

    .wa-ring {
      fill: none !important;
      stroke: #fff !important;
      stroke-width: 4.9 !important;
      stroke-linecap: round !important;
      stroke-linejoin: round !important;
    }

    .wa-phone {
      fill: #fff !important;
      stroke: none !important;
    }

    .wa-toggle:hover .wa-orb,
    .wa-toggle:focus-visible .wa-orb,
    .wa-wrap.is-open .wa-orb {
      transform: translateY(-2px) scale(1.045) !important;
      box-shadow:
        0 18px 34px rgba(18, 169, 75, .34),
        0 0 0 1px rgba(218, 171, 11, .34),
        0 0 28px rgba(37, 211, 102, .34) !important;
    }

    .wa-toggle:hover .wa-icon,
    .wa-toggle:focus-visible .wa-icon,
    .wa-wrap.is-open .wa-icon {
      transform: scale(1.04) rotate(-2deg) !important;
    }

    .wa-toggle:focus-visible .wa-orb {
      outline: 2px solid rgba(37, 211, 102, .72) !important;
      outline-offset: 4px !important;
    }

    .wa-drawer {
      position: absolute !important;
      right: 0 !important;
      bottom: 76px !important;
      width: min(324px, calc(100vw - 24px)) !important;
      display: grid !important;
      gap: 7px !important;
      padding: 10px !important;
      margin: 0 !important;
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
      transform: translateY(10px) scale(.975) !important;
      transform-origin: bottom right !important;
      transition: opacity .2s ease, transform .2s ease, visibility .2s ease !important;
      color: #111 !important;
      border: 1px solid rgba(215, 170, 18, .34) !important;
      border-radius: 20px !important;
      background:
        radial-gradient(circle at 90% 0%, rgba(247, 210, 61, .14), transparent 34%),
        linear-gradient(145deg, rgba(255,255,255,.985), rgba(255,252,241,.955)) !important;
      box-shadow:
        0 22px 54px rgba(0,0,0,.18),
        0 5px 16px rgba(0,0,0,.08),
        inset 0 1px 0 rgba(255,255,255,.9) !important;
      backdrop-filter: blur(14px) saturate(1.08) !important;
      -webkit-backdrop-filter: blur(14px) saturate(1.08) !important;
      overflow: hidden !important;
    }

    .wa-drawer::before {
      content: "" !important;
      position: absolute !important;
      top: 0 !important;
      left: 20px !important;
      right: 20px !important;
      height: 2px !important;
      border-radius: 0 0 99px 99px !important;
      background: linear-gradient(90deg, transparent, #25d366 24%, #e0b413 76%, transparent) !important;
      opacity: .86 !important;
      pointer-events: none !important;
    }

    .wa-wrap.is-open .wa-drawer {
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      transform: translateY(0) scale(1) !important;
    }

    .wa-drawer[aria-hidden="true"] {
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
      transform: translateY(10px) scale(.975) !important;
    }

    .wa-head {
      all: initial !important;
      box-sizing: border-box !important;
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      min-height: 34px !important;
      padding: 2px 4px 3px !important;
      font-family: "Source Sans 3", Arial, sans-serif !important;
    }

    .wa-head-copy {
      all: initial !important;
      display: grid !important;
      gap: 2px !important;
      font-family: "Source Sans 3", Arial, sans-serif !important;
    }

    .wa-head-copy strong {
      all: initial !important;
      color: #151515 !important;
      font-family: "Source Sans 3", Arial, sans-serif !important;
      font-size: 14px !important;
      line-height: 1.05 !important;
      font-weight: 900 !important;
      letter-spacing: -.01em !important;
    }

    .wa-status {
      all: initial !important;
      display: inline-flex !important;
      align-items: center !important;
      gap: 6px !important;
      color: #5e5e5e !important;
      font-family: "Source Sans 3", Arial, sans-serif !important;
      font-size: 9.5px !important;
      line-height: 1 !important;
      font-weight: 760 !important;
      letter-spacing: .06em !important;
      text-transform: uppercase !important;
    }

    .wa-status::before {
      content: "" !important;
      width: 7px !important;
      height: 7px !important;
      border-radius: 50% !important;
      background: #25d366 !important;
      box-shadow: 0 0 0 3px rgba(37,211,102,.12), 0 0 8px rgba(37,211,102,.28) !important;
    }

    .wa-close,
    .wa-close:hover,
    .wa-close:focus,
    .wa-close:focus-visible,
    .wa-close:active {
      all: unset !important;
      box-sizing: border-box !important;
      display: grid !important;
      place-items: center !important;
      width: 27px !important;
      height: 27px !important;
      cursor: pointer !important;
      border: 1px solid rgba(0,0,0,.07) !important;
      border-radius: 50% !important;
      color: #4a4a4a !important;
      background: rgba(255,255,255,.72) !important;
      font-family: Arial, sans-serif !important;
      font-size: 18px !important;
      line-height: 1 !important;
      box-shadow: 0 4px 11px rgba(0,0,0,.06) !important;
      transition: transform .18s ease, border-color .18s ease, color .18s ease !important;
      -webkit-tap-highlight-color: transparent !important;
    }

    .wa-close:hover,
    .wa-close:focus-visible {
      transform: rotate(6deg) scale(1.04) !important;
      border-color: rgba(37,211,102,.42) !important;
      color: #149a48 !important;
      outline: 0 !important;
    }

    .wa-card,
    .wa-card:visited {
      all: unset !important;
      box-sizing: border-box !important;
      display: grid !important;
      grid-template-columns: 88px minmax(0, 1fr) 28px !important;
      align-items: center !important;
      gap: 11px !important;
      width: 100% !important;
      min-height: 94px !important;
      padding: 8px 9px !important;
      color: #111 !important;
      text-decoration: none !important;
      cursor: pointer !important;
      border: 1px solid rgba(0,0,0,.065) !important;
      border-radius: 18px !important;
      background: rgba(255,255,255,.78) !important;
      box-shadow: 0 6px 16px rgba(0,0,0,.055), inset 0 1px 0 rgba(255,255,255,.84) !important;
      transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease, background .18s ease !important;
    }

    .wa-card:hover,
    .wa-card:focus-visible {
      transform: translateY(-1px) !important;
      border-color: rgba(37,211,102,.32) !important;
      background: rgba(255,255,255,.96) !important;
      box-shadow: 0 10px 22px rgba(0,0,0,.085), inset 3px 0 0 rgba(37,211,102,.7) !important;
      outline: 0 !important;
    }

    .wa-avatar {
      all: initial !important;
      box-sizing: border-box !important;
      display: block !important;
      width: 88px !important;
      height: 88px !important;
      overflow: hidden !important;
      border: 1px solid rgba(221,176,19,.34) !important;
      border-radius: 16px !important;
      background: linear-gradient(180deg, rgba(18,18,18,.98), rgba(28,28,28,.98)) !important;
      box-shadow: 0 8px 18px rgba(0,0,0,.16), 0 0 0 1px rgba(255,255,255,.56) inset !important;
    }

    .wa-avatar-image {
      all: initial !important;
      box-sizing: border-box !important;
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
      object-position: center center !important;
      background: #0f0f0f !important;
    }

    .wa-copy {
      all: initial !important;
      box-sizing: border-box !important;
      min-width: 0 !important;
      display: grid !important;
      gap: 3px !important;
      font-family: "Source Sans 3", Arial, sans-serif !important;
    }

    .wa-copy strong {
      all: initial !important;
      color: #151515 !important;
      font-family: "Source Sans 3", Arial, sans-serif !important;
      font-size: 15px !important;
      line-height: 1 !important;
      font-weight: 900 !important;
      letter-spacing: -.015em !important;
    }

    .wa-copy small {
      all: initial !important;
      overflow: hidden !important;
      color: #666 !important;
      font-family: "Source Sans 3", Arial, sans-serif !important;
      font-size: 10.5px !important;
      line-height: 1.15 !important;
      font-weight: 700 !important;
      white-space: nowrap !important;
      text-overflow: ellipsis !important;
    }

    .wa-arrow {
      all: initial !important;
      box-sizing: border-box !important;
      display: grid !important;
      place-items: center !important;
      width: 27px !important;
      height: 27px !important;
      border: 1px solid rgba(37,211,102,.2) !important;
      border-radius: 50% !important;
      color: #179b4b !important;
      background: rgba(37,211,102,.08) !important;
      transition: transform .18s ease, background .18s ease !important;
    }

    .wa-card:hover .wa-arrow,
    .wa-card:focus-visible .wa-arrow {
      transform: translateX(2px) !important;
      background: rgba(37,211,102,.14) !important;
    }

    .wa-arrow-icon {
      all: initial !important;
      box-sizing: border-box !important;
      display: block !important;
      width: 14px !important;
      height: 14px !important;
    }

    .wa-arrow-icon path {
      fill: none !important;
      stroke: currentColor !important;
      stroke-width: 2 !important;
      stroke-linecap: round !important;
      stroke-linejoin: round !important;
    }

    @keyframes wa-breathe {
      0%, 100% {
        box-shadow:
          0 12px 26px rgba(18, 169, 75, .34),
          0 0 0 1px rgba(218, 171, 11, .24),
          0 0 18px rgba(37, 211, 102, .18),
          inset 0 2px 3px rgba(255,255,255,.52),
          inset 0 -6px 12px rgba(0, 99, 40, .22);
      }
      50% {
        box-shadow:
          0 14px 30px rgba(18, 169, 75, .39),
          0 0 0 1px rgba(218, 171, 11, .32),
          0 0 24px rgba(37, 211, 102, .26),
          inset 0 2px 3px rgba(255,255,255,.55),
          inset 0 -6px 12px rgba(0, 99, 40, .22);
      }
    }

    @keyframes wa-ring {
      0%, 62% { opacity: 0; transform: scale(.92); }
      72% { opacity: .52; }
      100% { opacity: 0; transform: scale(1.2); }
    }


    @keyframes wa-attention {
      0%, 72%, 100% {
        box-shadow:
          0 14px 28px rgba(18, 169, 75, .30),
          0 0 0 1px rgba(218, 171, 11, .26),
          0 0 22px rgba(37, 211, 102, .22) !important;
        filter: brightness(1) !important;
      }
      78% {
        box-shadow:
          0 16px 32px rgba(18, 169, 75, .34),
          0 0 0 1px rgba(218, 171, 11, .32),
          0 0 28px rgba(37, 211, 102, .30) !important;
        filter: brightness(1.03) !important;
      }
      84% {
        box-shadow:
          0 18px 36px rgba(18, 169, 75, .38),
          0 0 0 1px rgba(218, 171, 11, .38),
          0 0 38px rgba(37, 211, 102, .42) !important;
        filter: brightness(1.07) !important;
      }
      90% {
        box-shadow:
          0 16px 32px rgba(18, 169, 75, .34),
          0 0 0 1px rgba(218, 171, 11, .32),
          0 0 30px rgba(37, 211, 102, .34) !important;
        filter: brightness(1.03) !important;
      }
    }

    @media (max-width: 640px) {
      .wa-toggle,
      .wa-toggle:hover,
      .wa-toggle:focus,
      .wa-toggle:focus-visible,
      .wa-toggle:active {
        width: 70px !important;
        height: 70px !important;
        min-width: 70px !important;
        min-height: 70px !important;
      }

      .wa-orb {
        width: 64px !important;
        height: 64px !important;
      }

      .wa-icon {
        width: 38px !important;
        height: 38px !important;
      }

      .wa-drawer {
        bottom: 78px !important;
        width: min(320px, calc(100vw - 20px)) !important;
        border-radius: 18px !important;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .wa-orb,
      .wa-orb::before,
      .wa-icon,
      .wa-drawer,
      .wa-card,
      .wa-arrow,
      .wa-close {
        animation: none !important;
        transition: none !important;
      }
    }
  `;

  const init = () => {
    removeLegacyWhatsApp();
    document.getElementById(HOST_ID)?.remove();

    const assets = window.CycloOutletWhatsAppAssets || {};
    const logoMarkup = assets.logo
      ? `<img class="wa-logo" src="${assets.logo}" alt="" loading="eager" decoding="async">`
      : iconMarkup;
    const host = document.createElement('co-whatsapp-host');
    host.id = HOST_ID;
    host.setAttribute('aria-label', 'Asesoría técnica personalizada por WhatsApp');
    lockHostStyles(host);

    const shadow = host.attachShadow({ mode: 'open' });
    shadow.innerHTML = `
      <style>${shadowStyles}</style>
      <div class="wa-wrap">
        <section class="wa-drawer" id="wa-drawer" aria-label="Seleccionar asesor" aria-hidden="true">
          <div class="wa-head">
            <span class="wa-head-copy">
              <strong>Asesoría técnica personalizada</strong>
              <span class="wa-status">Equipo disponible</span>
            </span>
            <button class="wa-close" type="button" aria-label="Cerrar asesores">×</button>
          </div>

          <a class="wa-card" href="${whatsappUrl(FELIPE, 'Felipe', 'asesoría técnica personalizada y validación de compatibilidad')}" target="_blank" rel="noopener">
            <span class="wa-avatar" aria-hidden="true"><img class="wa-avatar-image" data-wa-avatar="felipe" alt="" loading="lazy" decoding="async"></span>
            <span class="wa-copy"><strong>Felipe</strong><small>Soporte y compatibilidad</small></span>
            <span class="wa-arrow">${arrowMarkup}</span>
          </a>

          <a class="wa-card" href="${whatsappUrl(ANDREA, 'Andrea', 'asesoría técnica personalizada, disponibilidad y compra')}" target="_blank" rel="noopener">
            <span class="wa-avatar" aria-hidden="true"><img class="wa-avatar-image" data-wa-avatar="andrea" alt="" loading="lazy" decoding="async"></span>
            <span class="wa-copy"><strong>Andrea</strong><small>Disponibilidad y compra</small></span>
            <span class="wa-arrow">${arrowMarkup}</span>
          </a>
        </section>

        <button class="wa-toggle" type="button" aria-controls="wa-drawer" aria-label="Abrir asesores de WhatsApp" aria-expanded="false">
          <span class="wa-orb">${logoMarkup}</span>
        </button>
      </div>`;

    const avatarSources = { felipe: assets.felipe || '', andrea: assets.andrea || '' };
    shadow.querySelectorAll('[data-wa-avatar]').forEach((avatar) => {
      const source = avatarSources[avatar.dataset.waAvatar];
      if (source) avatar.setAttribute('src', source);
    });

    document.body.appendChild(host);

    const wrap = shadow.querySelector('.wa-wrap');
    const toggle = shadow.querySelector('.wa-toggle');
    const drawer = shadow.querySelector('.wa-drawer');
    const close = shadow.querySelector('.wa-close');

    const cards = [...shadow.querySelectorAll('.wa-card')];

    const setOpen = (open) => {
      const isOpen = Boolean(open);
      wrap?.classList.toggle('is-open', isOpen);
      toggle?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle?.setAttribute('aria-label', isOpen ? 'Cerrar asesores de WhatsApp' : 'Abrir asesores de WhatsApp');
      drawer?.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      drawer?.toggleAttribute('inert', !isOpen);
      cards.forEach((card) => {
        card.tabIndex = isOpen ? 0 : -1;
        card.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      });
    };

    toggle?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setOpen(!wrap?.classList.contains('is-open'));
    });

    close?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setOpen(false);
      toggle?.focus({ preventScroll: true });
    });

    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (!wrap?.classList.contains('is-open')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        setOpen(false);
      });
    });

    setOpen(false);

    document.addEventListener('click', (event) => {
      if (!event.composedPath().includes(host)) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(LEGACY_SELECTOR)) node.remove();
          removeLegacyWhatsApp(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  ready(init);
})();

/* ===== Formularios WhatsApp home ===== */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-co-whatsapp-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const field = form.querySelector('textarea[name="message"]');
      const submit = form.querySelector('[type="submit"]');
      const raw = (field?.value || '').trim();
      const message = raw || 'Quiero contarles mi bicicleta, mi objetivo y el componente que estoy evaluando para recibir asesoría técnica personalizada.';
      const text = `Hola CycloOutlet, necesito asesoría técnica personalizada.

${message}`;
      const link = document.createElement('a');
      link.href = `https://wa.me/573142533532?text=${encodeURIComponent(text)}`;
      link.target = '_blank';
      link.rel = 'noopener';
      link.dataset.ctaType = submit?.dataset.ctaType || 'home_advisor_panel';
      link.hidden = true;
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  });
});

/* ===== Panel de asesoría rotativo del hero ===== */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-co-strength-rotator]').forEach(function (rotator) {
    var slides = Array.prototype.slice.call(rotator.querySelectorAll('[data-co-strength-slide]'));
    var dots = Array.prototype.slice.call(rotator.querySelectorAll('[data-co-strength-dot]'));
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!slides.length) return;

    var index = 0;
    var timer = null;

    function clearTimers() {
      if (timer) window.clearTimeout(timer);
      timer = null;
    }

    function show(nextIndex) {
      clearTimers();
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });

      if (!reduceMotion.matches && slides.length > 1) {
        timer = window.setTimeout(function () { show(index + 1); }, 6200);
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
    });
    rotator.querySelector('[data-co-strength-prev]')?.addEventListener('click', function () { show(index - 1); });
    rotator.querySelector('[data-co-strength-next]')?.addEventListener('click', function () { show(index + 1); });

    reduceMotion.addEventListener?.('change', function () { show(0); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearTimers();
      else show(index);
    });

    show(0);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-co-feature-stream]').forEach(function (panel) {
    var viewport = panel.querySelector('[data-co-feature-stream-viewport]');
    var track = panel.querySelector('[data-co-feature-stream-track]');
    if (!viewport || !track || track.dataset.coFeatureStreamReady === 'true') return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var originals = Array.prototype.slice.call(track.children);
    var up = panel.querySelector('[data-co-feature-stream-up]');
    var down = panel.querySelector('[data-co-feature-stream-down]');
    var visibleCount = 3;
    if (!originals.length) return;

    track.dataset.coFeatureStreamReady = 'true';
    if (originals.length <= visibleCount || reduceMotion.matches) return;

    originals.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      track.appendChild(clone);
    });

    var offset = 0;
    var sequenceHeight = 0;
    var raf = null;
    var lastTime = 0;
    var speed = window.matchMedia('(max-width: 740px)').matches ? 8 : 10; // px/s: movimiento deliberadamente lento

    function measure() {
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.rowGap || style.gap || 0) || 0;
      sequenceHeight = originals.reduce(function (sum, item) {
        return sum + item.getBoundingClientRect().height;
      }, 0) + gap * Math.max(0, originals.length - 1);
      if (sequenceHeight > 0) offset = offset % sequenceHeight;
      track.style.transform = 'translate3d(0,' + (-offset) + 'px,0)';
    }

    function step(direction) {
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.rowGap || style.gap || 0) || 0;
      var first = originals[0];
      var amount = first ? first.getBoundingClientRect().height + gap : 0;
      if (!amount || !sequenceHeight) return;
      offset = (offset + (direction * amount) + sequenceHeight) % sequenceHeight;
      track.style.transform = 'translate3d(0,' + (-offset) + 'px,0)';
      lastTime = 0;
    }

    up?.addEventListener('click', function () { step(-1); });
    down?.addEventListener('click', function () { step(1); });

    function frame(now) {
      if (!lastTime) lastTime = now;
      var delta = Math.min(50, now - lastTime);
      lastTime = now;
      if (!document.hidden && !reduceMotion.matches && sequenceHeight > 0) {
        offset += speed * (delta / 1000);
        if (offset >= sequenceHeight) offset -= sequenceHeight;
        track.style.transform = 'translate3d(0,' + (-offset) + 'px,0)';
      }
      raf = window.requestAnimationFrame(frame);
    }

    measure();
    raf = window.requestAnimationFrame(frame);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        speed = window.matchMedia('(max-width: 740px)').matches ? 8 : 10;
        measure();
      }, 120);
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      lastTime = 0;
    });

    reduceMotion.addEventListener?.('change', function () {
      lastTime = 0;
      if (reduceMotion.matches) {
        offset = 0;
        track.style.transform = 'translate3d(0,0,0)';
      }
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-co-focus-message]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var target = document.querySelector('#co131-message') || document.querySelector('#co131-home-contact-message');
      if (!target) return;
      window.setTimeout(function () {
        target.focus({ preventScroll: true });
        if (!target.value) target.value = 'Hola CycloOutlet, quiero que me ayuden a buscar este producto: ';
        target.setSelectionRange(target.value.length, target.value.length);
      }, 180);
    });
  });
});

/* ===== Colecciones activas ===== */
/* CycloOutlet — comportamiento único de la colección premium limpia. */
(() => {
  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const queryTokens = (value) => normalize(value).split(/\s+/).filter(Boolean);

  const textMatchesQuery = (searchText, query) => {
    const tokens = queryTokens(query);
    return !tokens.length || tokens.every((token) => searchText.includes(token));
  };

  const clampQuantity = (input, rawValue) => {
    if (!input) return 1;
    const min = Math.max(1, Number(input.min || 1));
    const declaredMax = Number(input.max || 99);
    const max = Number.isFinite(declaredMax) && declaredMax >= min ? declaredMax : 99;
    const parsed = Math.round(Number(rawValue || min));
    const value = Math.min(max, Math.max(min, Number.isFinite(parsed) ? parsed : min));
    input.value = String(value);
    return value;
  };

  const initCatalog = () => {
    const page = document.querySelector('[data-co-clean-catalog]');
    if (!page || page.dataset.coCleanReady === 'true') return;
    page.dataset.coCleanReady = 'true';

    const grid = page.querySelector('[data-co-clean-grid]');
    const cards = grid ? [...grid.querySelectorAll('[data-co-clean-card]')] : [];
    const collectionSelect = page.querySelector('[data-co-clean-collection]');
    const seriesSelect = page.querySelector('[data-co-clean-series]');
    const compatibilitySelect = page.querySelector('[data-co-clean-compatibility]');
    const priceSelect = page.querySelector('[data-co-clean-price]');
    const sortSelect = page.querySelector('[data-co-clean-sort]');
    const quickSearch = page.querySelector('[data-co-clean-quick-search]');
    const quickClear = page.querySelector('[data-co-clean-quick-clear]');
    const countNode = page.querySelector('[data-co-clean-count]');
    const emptyNode = page.querySelector('[data-co-clean-empty]');
    const sticky = page.querySelector('[data-co-clean-sticky]');

    const url = new URL(window.location.href);
    let searchQuery = url.searchParams.get('co_search') || '';
    if (quickSearch) quickSearch.value = searchQuery;
    if (quickClear) quickClear.hidden = !searchQuery.trim();

    if (url.searchParams.has('catalog_category')) {
      url.searchParams.delete('catalog_category');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    const filterParams = {
      series: 'catalog_series',
      compatibility: 'catalog_compatibility',
      price: 'catalog_price'
    };

    const setSelectFromUrl = (select, parameter) => {
      if (!select) return;
      const value = url.searchParams.get(parameter) || '';
      const optionExists = [...select.options].some((option) => option.value === value);
      select.value = optionExists ? value : '';
    };

    setSelectFromUrl(seriesSelect, filterParams.series);
    setSelectFromUrl(compatibilitySelect, filterParams.compatibility);
    setSelectFromUrl(priceSelect, filterParams.price);

    const cardSearchText = (card) => normalize([
      card.dataset.title,
      card.dataset.vendor,
      card.dataset.series,
      card.dataset.coCategory,
      card.dataset.cicloApexSku,
      card.textContent
    ].join(' '));

    const indexedCards = cards.map((card) => ({ card, searchText: cardSearchText(card) }));

    const mobilePills = page.querySelector('.co-catalog-clean__mobile-pills');
    if (url.searchParams.has('co_mobile_filter')) {
      url.searchParams.delete('co_mobile_filter');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    const mobileFilterDefinitions = [
      { label: 'Filtros', value: '__filters', primary: true },
      ...Array.from(collectionSelect?.options || [])
        .filter((option) => String(option.value || '').includes('/collections/'))
        .map((option) => {
          const destination = String(option.value || '/collections/all');
          let handle = '';
          try {
            const path = new URL(destination, window.location.origin).pathname.replace(/\/$/, '');
            handle = path === '/collections/all' ? '' : decodeURIComponent(path.split('/').filter(Boolean).pop() || '');
          } catch (error) {
            handle = '';
          }
          return {
            label: String(option.textContent || '').trim() === 'Todas las categorías' ? 'Todos' : String(option.textContent || '').trim(),
            value: handle,
            collection: destination
          };
        })
    ];

    const buildMobileFilterPills = () => {
      if (!mobilePills || mobilePills.dataset.coMobileFiltersReady === 'true') return;
      mobilePills.dataset.coMobileFiltersReady = 'true';
      const currentPath = window.location.pathname.replace(/\/$/, '');
      mobilePills.innerHTML = mobileFilterDefinitions.map((item) => {
        if (item.primary) {
          return '<button type="button" class="co-catalog-clean__mobile-pill co-catalog-clean__mobile-pill--primary" data-co-mobile-filter-toggle aria-expanded="false">' + item.label + '</button>';
        }
        let itemPath = '';
        try {
          itemPath = new URL(item.collection || '/collections/all', window.location.origin).pathname.replace(/\/$/, '');
        } catch (error) {
          itemPath = '';
        }
        const active = itemPath === currentPath;
        const activeClass = active ? ' is-active' : '';
        const collectionAttribute = item.collection ? ' data-co-mobile-collection="' + item.collection + '"' : '';
        return '<button type="button" class="co-catalog-clean__mobile-pill' + activeClass + '" data-co-mobile-filter="' + item.value + '"' + collectionAttribute + ' aria-pressed="' + (active ? 'true' : 'false') + '">' + item.label + '</button>';
      }).join('');
    };

    const parsePriceRange = (value) => {
      if (!value) return null;
      const [minRaw, maxRaw] = String(value).split('-');
      const min = Number(minRaw || 0);
      const max = Number(maxRaw || Number.MAX_SAFE_INTEGER);
      if (!Number.isFinite(min) || !Number.isFinite(max)) return null;
      return { min, max };
    };

    const clearLegacyVisibility = (card) => {
      card.removeAttribute('data-co-category-hidden');
      card.removeAttribute('data-co-search-hidden');
      card.classList.remove(
        'co-filtered-out',
        'co-filter-hidden',
        'co-filtered-out',
        'co-search-filtered-out',
        'co-series-priority-grupos',
        'co-series-priority-other'
      );
      card.style.removeProperty('display');
    };

    const applyFilters = () => {
      const series = seriesSelect?.value || '';
      const compatibility = compatibilitySelect?.value || '';
      const priceRange = parsePriceRange(priceSelect?.value || '');
      const query = normalize(searchQuery);
      let visible = 0;

      indexedCards.forEach(({ card, searchText }) => {
        clearLegacyVisibility(card);

        const cardSeries = normalize(card.dataset.series);
        const cardTech = normalize(card.dataset.coTech);
        const cardBrake = normalize(card.dataset.coBrake);
        const price = Number(card.dataset.priceCents || 0);

        const seriesMatch = !series || cardSeries === series;
        let compatibilityMatch = true;
        if (compatibility === 'di2') compatibilityMatch = cardTech === 'di2';
        else if (compatibility === 'disc') compatibilityMatch = cardBrake === 'disc';
        else if (compatibility === 'mechanical') compatibilityMatch = cardTech !== 'di2';
        const priceMatch = !priceRange || (price >= priceRange.min && price <= priceRange.max);
        const searchMatch = textMatchesQuery(searchText, searchQuery);
        const show = seriesMatch && compatibilityMatch && priceMatch && searchMatch;

        card.toggleAttribute('data-co-clean-hidden', !show);
        card.hidden = !show;
        card.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) visible += 1;
      });

      if (countNode) {
        countNode.textContent = query
          ? `${visible} productos encontrados para “${searchQuery.trim()}”`
          : `${visible} productos encontrados`;
      }
      if (emptyNode) emptyNode.hidden = visible !== 0;
    };

    const saveFilterState = () => {
      const nextUrl = new URL(window.location.href);
      const controls = [
        [seriesSelect, filterParams.series],
        [compatibilitySelect, filterParams.compatibility],
        [priceSelect, filterParams.price]
      ];

      controls.forEach(([select, parameter]) => {
        const value = select?.value || '';
        if (value) nextUrl.searchParams.set(parameter, value);
        else nextUrl.searchParams.delete(parameter);
      });
      nextUrl.searchParams.delete('page');
      nextUrl.hash = 'productos-filtrados';
      window.history.replaceState({}, '', nextUrl.pathname + nextUrl.search + nextUrl.hash);
      applyFilters();
    };

    [seriesSelect, compatibilitySelect, priceSelect].forEach((select) => {
      select?.addEventListener('change', saveFilterState);
    });

    collectionSelect?.addEventListener('change', () => {
      const destination = collectionSelect.value || '/collections/all';
      const currentUrl = new URL(window.location.href);
      const targetUrl = new URL(destination, window.location.origin);

      ['catalog_series', 'catalog_compatibility', 'catalog_price', 'co_search', 'sort_by'].forEach((parameter) => {
        const value = currentUrl.searchParams.get(parameter);
        if (value) targetUrl.searchParams.set(parameter, value);
      });

      targetUrl.searchParams.delete('catalog_category');
      targetUrl.searchParams.delete('page');
      targetUrl.hash = 'productos-filtrados';
      window.location.assign(targetUrl.toString());
    });

    let quickSearchTimer = 0;
    const syncQuickSearch = (value, pushEvent = false) => {
      searchQuery = String(value || '');
      if (quickSearch && quickSearch.value !== searchQuery) quickSearch.value = searchQuery;
      if (quickClear) quickClear.hidden = !searchQuery.trim();

      const nextUrl = new URL(window.location.href);
      if (searchQuery.trim()) nextUrl.searchParams.set('co_search', searchQuery.trim());
      else nextUrl.searchParams.delete('co_search');
      nextUrl.searchParams.delete('page');
      nextUrl.hash = 'productos-filtrados';
      window.history.replaceState({}, '', nextUrl.pathname + nextUrl.search + nextUrl.hash);
      applyFilters();

      if (pushEvent) {
        window.dispatchEvent(new CustomEvent('cyclooutlet:product-search-query', { detail: { query: searchQuery, source: 'quick' } }));
      }
    };

    buildMobileFilterPills();

    mobilePills?.addEventListener('click', (event) => {
      const toggleButton = event.target.closest('[data-co-mobile-filter-toggle]');
      if (toggleButton) {
        event.preventDefault();
        const isOpen = sticky?.classList.toggle('is-filters-open');
        toggleButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        return;
      }
      const filterButton = event.target.closest('[data-co-mobile-filter]');
      if (!filterButton) return;
      event.preventDefault();
      sticky?.classList.remove('is-filters-open');
      const toggle = mobilePills.querySelector('[data-co-mobile-filter-toggle]');
      toggle?.setAttribute('aria-expanded', 'false');
      const targetCollection = filterButton.dataset.coMobileCollection || '';
      if (targetCollection) {
        const targetUrl = new URL(targetCollection, window.location.origin);
        const currentUrl = new URL(window.location.href);
        ['co_search', 'sort_by'].forEach((parameter) => {
          const value = currentUrl.searchParams.get(parameter);
          if (value) targetUrl.searchParams.set(parameter, value);
        });
        targetUrl.hash = 'productos-filtrados';
        if (targetUrl.pathname !== currentUrl.pathname) {
          window.location.assign(targetUrl.toString());
          return;
        }
        return;
      }
    });


    quickSearch?.addEventListener('input', () => {
      window.clearTimeout(quickSearchTimer);
      const value = quickSearch.value;
      if (quickClear) quickClear.hidden = !value.trim();
      quickSearchTimer = window.setTimeout(() => syncQuickSearch(value, false), 120);
    });

    quickSearch?.addEventListener('search', () => syncQuickSearch(quickSearch.value, false));

    quickClear?.addEventListener('click', (event) => {
      event.preventDefault();
      if (quickSearch) quickSearch.value = '';
      syncQuickSearch('', false);
      quickSearch?.focus();
    });

    sortSelect?.addEventListener('change', () => {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('sort_by', sortSelect.value);
      nextUrl.searchParams.delete('page');
      nextUrl.hash = 'productos-filtrados';
      window.location.assign(nextUrl.toString());
    });

    page.addEventListener('click', (event) => {
      const minus = event.target.closest('[data-co-clean-minus]');
      const plus = event.target.closest('[data-co-clean-plus]');
      if (!minus && !plus) return;
      const quantity = event.target.closest('[data-co-clean-quantity]');
      const input = quantity?.querySelector('[data-co-clean-quantity-input]');
      if (!input || event.target.disabled) return;
      event.preventDefault();
      const delta = plus ? 1 : -1;
      clampQuantity(input, Number(input.value || 1) + delta);
    });

    page.querySelectorAll('[data-co-clean-quantity-input]').forEach((input) => {
      input.addEventListener('change', () => clampQuantity(input, input.value));
      input.addEventListener('blur', () => clampQuantity(input, input.value));
    });

    page.addEventListener('click', async (event) => {
      const cartButton = event.target.closest('[data-co-clean-cart]');
      if (!cartButton || !page.contains(cartButton) || cartButton.disabled) return;
      event.preventDefault();
      event.stopPropagation();

      const form = cartButton.closest('[data-co-clean-card-form]');
      const variantId = Number(cartButton.dataset.variantId || form?.querySelector('[name="id"]')?.value || 0);
      const quantityInput = form?.querySelector('[name="quantity"]');
      const quantity = clampQuantity(quantityInput, quantityInput?.value || 1);
      if (!variantId) return;

      const originalHtml = cartButton.innerHTML;
      cartButton.disabled = true;
      cartButton.classList.add('is-cart-loading');
      cartButton.textContent = 'Agregando';

      try {
        if (window.CycloOutletCartDrawer?.addItems) {
          await window.CycloOutletCartDrawer.addItems([{ id: variantId, quantity }]);
        } else {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity }] })
          });
          if (!response.ok) throw new Error('No fue posible añadir el producto');
          window.location.assign('/cart');
        }
      } catch (_) {
        window.location.assign(`/cart/${variantId}:${quantity}`);
      } finally {
        cartButton.disabled = false;
        cartButton.classList.remove('is-cart-loading');
        cartButton.innerHTML = originalHtml;
        if (window.lucide?.createIcons) window.lucide.createIcons();
      }
    }, true);

    page.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-co-clean-buy]');
      if (!button || !page.contains(button) || button.disabled) return;
      event.preventDefault();
      event.stopPropagation();

      const form = button.closest('[data-co-clean-card-form]');
      const variantId = Number(button.dataset.variantId || form?.querySelector('[name="id"]')?.value || 0);
      const quantityInput = form?.querySelector('[name="quantity"]');
      const quantity = clampQuantity(quantityInput, quantityInput?.value || 1);
      if (!variantId) return;

      const originalText = button.textContent.trim() || 'Comprar';
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Procesando';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] })
        });
        if (!response.ok) throw new Error('No fue posible añadir el producto');
        window.location.assign('/checkout');
      } catch (_) {
        window.location.assign(`/cart/${variantId}:${quantity}?checkout`);
        window.setTimeout(() => {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.textContent = originalText;
        }, 1200);
      }
    }, true);

    window.addEventListener('cyclooutlet:product-search-query', (event) => {
      if (event.detail?.source === 'quick') return;
      searchQuery = String(event.detail?.query || '');
      if (quickSearch) quickSearch.value = searchQuery;
      if (quickClear) quickClear.hidden = !searchQuery.trim();
      const nextUrl = new URL(window.location.href);
      if (searchQuery.trim()) nextUrl.searchParams.set('co_search', searchQuery.trim());
      else nextUrl.searchParams.delete('co_search');
      nextUrl.hash = 'productos-filtrados';
      window.history.replaceState({}, '', nextUrl.pathname + nextUrl.search + nextUrl.hash);
      applyFilters();
    });

    window.addEventListener('popstate', () => window.location.reload());

    let stickyPlaceholder = null;
    let stickyNaturalTop = null;
    let stickyFixed = false;

    const ensureStickyPlaceholder = () => {
      if (!sticky || stickyPlaceholder) return;
      stickyPlaceholder = document.createElement('div');
      stickyPlaceholder.className = 'co-catalog-clean__sticky-placeholder';
      stickyPlaceholder.setAttribute('aria-hidden', 'true');
      sticky.parentNode?.insertBefore(stickyPlaceholder, sticky);
    };

    const getStickyTop = () => {
      const root = getComputedStyle(document.documentElement);
      const custom = parseFloat(root.getPropertyValue('--co-chrome-height'));
      if (Number.isFinite(custom) && custom > 0) return custom;
      const header = document.querySelector('.apex-header');
      const announcement = document.querySelector('.co-top-announcement');
      return Math.max(0, Math.round((header?.getBoundingClientRect().height || 80) + (announcement?.getBoundingClientRect().height || 0)));
    };

    const captureNaturalTop = () => {
      if (!sticky || stickyFixed) return;
      stickyNaturalTop = sticky.getBoundingClientRect().top + window.scrollY;
    };

    const updateStickyState = () => {
      if (!sticky) return;
      ensureStickyPlaceholder();
      if (stickyNaturalTop == null) captureNaturalTop();
      const stickyTop = getStickyTop();
      const shouldFix = window.scrollY + stickyTop >= (stickyNaturalTop || 0);

      if (shouldFix && !stickyFixed) {
        stickyFixed = true;
        if (stickyPlaceholder) {
          stickyPlaceholder.style.display = 'block';
          stickyPlaceholder.style.height = `${sticky.offsetHeight}px`;
        }
        sticky.classList.add('is-stuck', 'is-fixed');
        sticky.style.position = 'fixed';
        sticky.style.top = `${stickyTop}px`;
        sticky.style.left = '0';
        sticky.style.right = '0';
        sticky.style.width = '100%';
        sticky.style.zIndex = '1200';
      } else if (!shouldFix && stickyFixed) {
        stickyFixed = false;
        sticky.classList.remove('is-stuck', 'is-fixed');
        sticky.style.position = '';
        sticky.style.top = '';
        sticky.style.left = '';
        sticky.style.right = '';
        sticky.style.width = '';
        sticky.style.zIndex = '';
        if (stickyPlaceholder) {
          stickyPlaceholder.style.display = 'none';
          stickyPlaceholder.style.height = '0px';
        }
        requestAnimationFrame(captureNaturalTop);
      } else if (stickyFixed) {
        sticky.style.top = `${stickyTop}px`;
        if (stickyPlaceholder) stickyPlaceholder.style.height = `${sticky.offsetHeight}px`;
      }
    };

    captureNaturalTop();
    window.addEventListener('scroll', updateStickyState, { passive: true });
    window.addEventListener('resize', () => {
      if (!stickyFixed) captureNaturalTop();
      updateStickyState();
    }, { passive: true });
    updateStickyState();

    applyFilters();
    window.setTimeout(applyFilters, 120);
    window.setTimeout(applyFilters, 480);
    window.setTimeout(applyFilters, 1100);

    if (window.lucide?.createIcons) window.lucide.createIcons();
  };

  const boot = () => {
    initCatalog();
    document.addEventListener('shopify:section:load', initCatalog);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();


(function () {
  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const runCollectionSearch = () => {
    if (!document.body.classList.contains('template-collection')) return;
    const input = document.querySelector('[data-co-header-product-search-input]');
    const clear = document.querySelector('[data-co-header-product-clear]');
    const cards = [...document.querySelectorAll('[data-co-clean-card], .co-catalog-card')];
    const empty = document.querySelector('[data-co-clean-empty]');
    const count = document.querySelector('[data-co-clean-count]');
    if (!input || !cards.length) return;
    const tokens = normalize(input.value).split(/\s+/).filter(Boolean);
    if (clear) clear.hidden = tokens.length === 0;
    let visible = 0;
    cards.forEach((card) => {
      const haystack = normalize([card.dataset.title, card.dataset.vendor, card.dataset.series, card.dataset.coCategory, card.dataset.cicloApexSku, card.textContent].join(' '));
      const matches = tokens.length === 0 || tokens.every((token) => haystack.includes(token));
      card.hidden = !matches;
      card.style.display = matches ? '' : 'none';
      if (matches) visible += 1;
    });
    if (count) count.textContent = String(visible);
    if (empty) empty.hidden = visible !== 0;
  };

  document.addEventListener('input', (event) => {
    if (event.target && event.target.matches('[data-co-header-product-search-input]')) runCollectionSearch();
  });

  document.addEventListener('click', (event) => {
    const clear = event.target.closest('[data-co-header-product-clear]');
    if (!clear) return;
    const input = document.querySelector('[data-co-header-product-search-input]');
    if (!input) return;
    input.value = '';
    clear.hidden = true;
    runCollectionSearch();
    input.focus();
  });

  window.addEventListener('DOMContentLoaded', runCollectionSearch);
})();


/* ===== Capa final efectiva ===== */
(() => {
  if (window.__cycloOutletShell) return;
  window.__cycloOutletShell = true;

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const mq = (query) => window.matchMedia(query).matches;
  const isMobile = () => mq("(max-width: 767px)");
  const normalize = (value) =>
    String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();

  const topMessages = [
    "Tecnicos certificados",
    "Distribuidores autorizados Shimano",
    "Taller proximamente",
    "Envios a nivel nacional",
    "Compra contraentrega",
    "Asesoria especializada"
  ];

  let announcementTimer = 0;

  function rotateAnnouncement() {
    const bar = $(".co-top-announcement, .co-top-announcement--dual");
    if (!bar) return;
    if (bar.dataset.coAnnouncementMode === "marquee") return;

    bar.dataset.coAnnouncementMode = "marquee";
    window.clearInterval(announcementTimer);
    announcementTimer = 0;

    const items = [...topMessages, ...topMessages]
      .map((message) => `<span class="co-top-announcement__item">${message}</span>`)
      .join("");

    bar.innerHTML = `
      <div class="co-top-announcement__marquee" aria-label="Informacion clave CycloOutlet">
        <div class="co-top-announcement__marquee-track">${items}</div>
      </div>
    `;
  }

  let headerHeightObserver = null;

  function setHeaderHeightVar() {
    const headerSection = $("#shopify-section-apex-header");
    if (!headerSection) return;

    const sync = () => {
      const height = Math.ceil(headerSection.getBoundingClientRect().height);
      if (height > 0) {
        document.documentElement.style.setProperty("--co-header-live-height", `${height}px`);
      }
    };

    sync();

    if (!headerHeightObserver && "ResizeObserver" in window) {
      headerHeightObserver = new ResizeObserver(sync);
      headerHeightObserver.observe(headerSection);
    }
  }

  function filterProductsFromHeaderSearch() {
    if (!document.body.classList.contains("template-collection")) return;
    const input = $("header.apex-header [data-co-header-product-search-input], header.apex-header input[type='search']");
    const clear = $("header.apex-header .co-header-product-clear, header.apex-header [data-co-header-product-clear]");
    const cards = $$("[data-co-clean-card], .co-catalog-card");
    const count = $("[data-co-clean-count]");
    const empty = $("[data-co-clean-empty]");
    if (!input || !cards.length || input.dataset.coFinalSearch === "1") return;
    input.dataset.coFinalSearch = "1";

    const apply = () => {
      const tokens = normalize(input.value).split(/\s+/).filter(Boolean);
      if (clear) clear.hidden = !tokens.length;
      let visible = 0;
      cards.forEach((card) => {
        const text = normalize(
          [
            card.dataset.title,
            card.dataset.vendor,
            card.dataset.series,
            card.dataset.coCategory,
            card.dataset.cicloApexSku,
            card.textContent
          ].join(" ")
        );
        const ok = !tokens.length || tokens.every((token) => text.includes(token));
        card.hidden = !ok;
        card.toggleAttribute("data-co-clean-hidden", !ok);
        if (ok) visible += 1;
      });
      if (count) count.textContent = `${visible} productos encontrados`;
      if (empty) empty.hidden = visible !== 0;
    };

    input.addEventListener("input", apply);
    input.addEventListener("search", apply);
    clear?.addEventListener("click", (event) => {
      event.preventDefault();
      input.value = "";
      apply();
      input.focus();
    });
    apply();
  }

  function initRelatedProductArrows() {
    const carousel = document.querySelector('[data-related-carousel]');
    if (!carousel || carousel.dataset.coRelatedArrowsReady === '1') return;

    const panel = carousel.closest('.co-related-products-panel');
    const previous = panel?.querySelector('[data-related-prev]');
    const next = panel?.querySelector('[data-related-next]');
    if (!panel || !previous || !next) return;

    carousel.dataset.coRelatedArrowsReady = '1';

    const step = () => {
      const card = carousel.querySelector('.co-related-product-card');
      if (!card) return Math.max(160, carousel.clientWidth * .55);
      const styles = getComputedStyle(carousel);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      previous.disabled = carousel.scrollLeft <= 3;
      next.disabled = carousel.scrollLeft >= maxScroll - 3;
    };

    previous.addEventListener('click', () => {
      carousel.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      carousel.scrollBy({ left: step(), behavior: 'smooth' });
    });
    carousel.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    update();
  }

  function boot() {
    rotateAnnouncement();
    setHeaderHeightVar();
    filterProductsFromHeaderSearch();
    initRelatedProductArrows();
  }

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      boot();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  ["load", "pageshow", "resize", "orientationchange"].forEach((eventName) => window.addEventListener(eventName, schedule, { passive: true }));
  [80, 240, 560, 1200, 2400, 4200].forEach((timeout) => window.setTimeout(boot, timeout));
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ===== Ficha de producto: ajuste visual de imágenes según proporción ===== */
(() => {
  const classify = (img) => {
    if (!img || img.dataset.coMediaFitReady === 'true') return;
    const apply = () => {
      if (!img.naturalWidth || !img.naturalHeight) return;
      img.dataset.coMediaFitReady = 'true';
      const ratio = img.naturalWidth / img.naturalHeight;
      img.classList.remove('co-media-wide', 'co-media-square', 'co-media-tall');
      if (ratio >= 1.45) img.classList.add('co-media-wide');
      else if (ratio <= 0.78) img.classList.add('co-media-tall');
      else img.classList.add('co-media-square');
    };
    if (img.complete) apply();
    else img.addEventListener('load', apply, { once: true });
  };
  const init = () => document.querySelectorAll('.template-product .co-product-gallery-main .co-product-gallery-source-image').forEach(classify);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
